import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** JSON Object Scalar */
  JSON: any;
  /** Percent scalar type */
  Percent: any;
};

export type Account = {
  id: Scalars['String'];
};

export type AccountInput = {
  id: Scalars['String'];
  type: AccountType;
};

export enum AccountType {
  RiotAccount = 'RIOT_ACCOUNT'
}

export type AnalyzeChannelInput = {
  from: Scalars['Date'];
  momentTypes?: Maybe<Array<Scalars['String']>>;
  to: Scalars['Date'];
};

export type AspectRatio = {
  __typename?: 'AspectRatio';
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type AspectRatioInput = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type Asset = {
  url: Scalars['String'];
};

export enum AuthenticateType {
  Collection = 'COLLECTION'
}

export type BetaKey = {
  __typename?: 'BetaKey';
  key: Scalars['String'];
  organization: Organization;
  usedAt?: Maybe<Scalars['Date']>;
  usedByUserId?: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Campaign = {
  __typename?: 'Campaign';
  /**
   * Lists channels that are part of a campaign during specific timeranges.
   * As an example, an 8 hour long stream could have a 2 hour sponsored segment.
   *
   * If a channel isn't included in the list it means that the all
   * streams on the channel during the campaingn are part of the campaign.
   */
  channelCampaignSegments: Array<ChannelCampaignSegments>;
  channels?: Maybe<ChannelCollection>;
  end?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  /**
   * Specifies which moment types are relevant for a campaign.
   *
   * If the campaign is looking for a specific sponsor like a brand name, the moment
   * type should be specified. If all moments should be included in the campaign
   * the field can be left empty.
   */
  momentTypes?: Maybe<Array<Scalars['String']>>;
  /**
   * Returns moments grouped by the groupBy key.
   *
   * A startsAt filter is required. If none is provided it defaults to (campaignStart, campaignEnd) if
   * the campaign has start/end values set, and if not it defaults to the last 24 hours.
   */
  moments?: Maybe<GroupedMomentConnection>;
  segments?: Maybe<Array<CampaignSegment>>;
  slug?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
};


export type CampaignMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentsFilterByInput>;
  first: Scalars['Int'];
  groupBy: CampaignMomentsGroupByInput;
};

export type CampaignFilter = {
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type CampaignInput = {
  channelCampaignSegments: Array<ChannelCampaignSegmentsInput>;
  channelCollectionId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  momentTypes?: Maybe<Array<Scalars['String']>>;
  slug?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
};

export enum CampaignMomentsGroupByInput {
  Channel = 'CHANNEL',
  None = 'NONE',
  Stream = 'STREAM'
}

export type CampaignSegment = {
  __typename?: 'CampaignSegment';
  ends: Scalars['Date'];
  starts: Scalars['Date'];
  title?: Maybe<Scalars['String']>;
};

export type Channel = {
  chatMessages: ChatMessageConnection;
  id: Scalars['String'];
  linkedAccounts: Array<Account>;
  name: Scalars['String'];
  platform: StreamingPlatform;
  streams: StreamConnection;
  videos: VideoConnection;
};


export type ChannelChatMessagesArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type ChannelStreamsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<StreamsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<StreamsOrderByInput>;
};


export type ChannelVideosArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<VideosFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<VideosOrderByInput>;
};

export type ChannelCampaignSegments = {
  __typename?: 'ChannelCampaignSegments';
  channel: Channel;
  segments: Array<Timerange>;
};

export type ChannelCampaignSegmentsInput = {
  channelId: Scalars['String'];
  segments: Array<TimerangeInput>;
};

export type ChannelCollection = {
  __typename?: 'ChannelCollection';
  channels: ChannelConnection;
  cursor?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  moments: MomentConnection;
  slug?: Maybe<Scalars['String']>;
  streams: MixedStreamConnection;
  title: Scalars['String'];
  videos: MixedVideoConnection;
};


export type ChannelCollectionChannelsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ChannelsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<ChannelsOrderByInput>;
};


export type ChannelCollectionMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderByInput>;
};


export type ChannelCollectionStreamsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<StreamsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<StreamsOrderByInput>;
};


export type ChannelCollectionVideosArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<VideosFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<VideosOrderByInput>;
};

export type ChannelCollectionConnection = {
  __typename?: 'ChannelCollectionConnection';
  data: Array<ChannelCollection>;
  pagination: Pagination;
};

export type ChannelCollectionFilter = {
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type ChannelCollectionInput = {
  channelIds: Array<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChannelCollectionsFilter = {
  ids?: Maybe<Array<Scalars['String']>>;
  slugs?: Maybe<Array<Scalars['String']>>;
};

export type ChannelCollectionsOrderBy = {
  slug?: Maybe<Sort>;
};

export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  data: Array<Channel>;
  pagination: Pagination;
};

export type ChannelFilter = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform: StreamingPlatform;
};

export type ChannelMomentsFilterByInput = {
  chatMoments?: Maybe<ChatMomentFilterInput>;
  multiPerspectiveMoments?: Maybe<MultiPerspectiveMomentFilterInput>;
  publishedAt?: Maybe<TimeRangeFilterInput>;
  startsAt?: Maybe<TimeRangeFilterInput>;
};

export type ChannelsFilterByInput = {
  name?: Maybe<StringFilter>;
};

export type ChannelsOrderByInput = {
  name?: Maybe<Sort>;
};

export type ChatMessage = Edge & {
  __typename?: 'ChatMessage';
  cursor: Scalars['String'];
  id: Scalars['String'];
  matching: Array<Scalars['String']>;
  /**
   * This is set by mmnts users to indicate that a moment didn't match what it
   * should have matched. An empty array means that it shouldn't have matched anything. An
   * array of types means that it should have matched all of those types.
   *
   * The field not being present means that it hasn't been marked as an incorrect match.
   */
  shouldBeMatching?: Maybe<Array<Scalars['String']>>;
  text: Scalars['String'];
  timestamp: Scalars['Date'];
  userId: Scalars['String'];
};

export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  data: Array<ChatMessage>;
  pagination: Pagination;
};

export type ChatMoment = Edge & Moment & Unread & {
  __typename?: 'ChatMoment';
  channel: Channel;
  createdAt: Scalars['Date'];
  cursor: Scalars['String'];
  edits: Array<MomentEdit>;
  endsAt: Scalars['Date'];
  exports: Array<VideoExport>;
  games?: Maybe<Array<Game>>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  sourceRecording?: Maybe<Recording>;
  sourceRecordingEndsAt?: Maybe<Scalars['Date']>;
  sourceRecordingStartsAt?: Maybe<Scalars['Date']>;
  startsAt: Scalars['Date'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  trimmedRecordings: Array<Recording>;
  type: Scalars['String'];
  usedIn: Array<MultiPerspectiveMoment>;
  /** Only available if the moment happened during a valorant match played on this stream. */
  valorantMatch?: Maybe<ValorantMatch>;
  video: Video;
};


export type ChatMomentEditsArgs = {
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type ChatMomentExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};

export type ChatMomentFilterInput = {
  include?: Maybe<Scalars['Boolean']>;
  types?: Maybe<Array<Scalars['String']>>;
};

export type ClientToken = {
  __typename?: 'ClientToken';
  accessToken: Scalars['String'];
};

export type Crop = {
  __typename?: 'Crop';
  aspectRatio: AspectRatio;
  position: Rect;
  title: Scalars['String'];
};

export type CropData = {
  __typename?: 'CropData';
  cropRect: Rect;
  /** @deprecated Use title */
  id: Scalars['String'];
  muted: Scalars['Boolean'];
  offset: Scalars['Float'];
  title: Scalars['String'];
  video: Video;
  videoId: Scalars['String'];
};

export type CropDataInput = {
  cropRect: RectInput;
  muted: Scalars['Boolean'];
  offset: Scalars['Float'];
  title: Scalars['String'];
  videoId: Scalars['String'];
};

export type CropInput = {
  aspectRatio: AspectRatioInput;
  position: RectInput;
  title: Scalars['String'];
};

export type CustomReason = {
  __typename?: 'CustomReason';
  reason: Scalars['String'];
};

export type Edge = {
  cursor: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  channels?: Maybe<ChannelCollection>;
  end?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  momentCollections: Array<MomentCollection>;
  /**
   * Returns moments grouped by the groupBy key.
   * A startsAt filter is required, if none is provided it defaults to the last 24 hours.
   */
  moments?: Maybe<GroupedMomentConnection>;
  slug?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
  title: Scalars['String'];
};


export type EventMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentsFilterByInput>;
  first: Scalars['Int'];
  groupBy: EventMomentsGroupByInput;
};

export type EventFilter = {
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type EventInput = {
  channelCollectionId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  momentCollectionIds: Array<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
  title: Scalars['String'];
};

export enum EventMomentsGroupByInput {
  Channel = 'CHANNEL',
  None = 'NONE',
  Stream = 'STREAM'
}

export type ExportRecordingInput = {
  aspectRatio: AspectRatioInput;
  cameraCrop?: Maybe<RectInput>;
  gameplayCrop?: Maybe<RectInput>;
};

export type Format = {
  __typename?: 'Format';
  aspectRatio: AspectRatio;
  id: Scalars['String'];
  /** Pre-created templates for the most common layouts for the format. */
  templates: Array<Template>;
  title: Scalars['String'];
};

export type FormatInput = {
  aspectRatio: AspectRatioInput;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type Game = {
  __typename?: 'Game';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GameFilter = {
  id?: Maybe<Scalars['String']>;
};

export type GamePlayed = {
  __typename?: 'GamePlayed';
  game: Game;
  startedAt: Scalars['Date'];
};

export type GroupedMoment = Edge & {
  __typename?: 'GroupedMoment';
  cursor: Scalars['String'];
  key: Scalars['String'];
  moment: Moment;
};

export type GroupedMomentConnection = {
  __typename?: 'GroupedMomentConnection';
  data: Array<GroupedMoment>;
  pagination: Pagination;
};

export type InputRegionSetting = {
  value: Region;
};

export type ManualSignalInput = {
  endsAt: Scalars['Date'];
  gameIds?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Scalars['JSON']>;
  published: Scalars['Boolean'];
  startsAt: Scalars['Date'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  videoId: Scalars['String'];
};

export type ManualSignalMoment = Edge & Moment & Unread & {
  __typename?: 'ManualSignalMoment';
  channel: Channel;
  createdAt: Scalars['Date'];
  cursor: Scalars['String'];
  edits: Array<MomentEdit>;
  endsAt: Scalars['Date'];
  exports: Array<VideoExport>;
  games?: Maybe<Array<Game>>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  startsAt: Scalars['Date'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  usedIn: Array<MultiPerspectiveMoment>;
  /** Only available if the moment happened during a valorant match played on this stream. */
  valorantMatch?: Maybe<ValorantMatch>;
  video: Video;
};


export type ManualSignalMomentEditsArgs = {
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type ManualSignalMomentExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};

export type ManualSignalMomentFilterInput = {
  include?: Maybe<Scalars['Boolean']>;
  types?: Maybe<Array<Scalars['String']>>;
};

export type MixedStreamConnection = StreamConnection & {
  __typename?: 'MixedStreamConnection';
  data: Array<Stream>;
  pagination: Pagination;
};

export type MixedVideoConnection = VideoConnection & {
  __typename?: 'MixedVideoConnection';
  data: Array<Video>;
  pagination: Pagination;
};

export type MmntsUser = {
  __typename?: 'MmntsUser';
  id: Scalars['String'];
  organization?: Maybe<Organization>;
  settings?: Maybe<UserSettings>;
};

export type Moment = {
  channel: Channel;
  createdAt: Scalars['Date'];
  edits: Array<MomentEdit>;
  endsAt: Scalars['Date'];
  exports: Array<VideoExport>;
  games?: Maybe<Array<Game>>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  startsAt: Scalars['Date'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  usedIn: Array<MultiPerspectiveMoment>;
  video: Video;
};


export type MomentEditsArgs = {
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type MomentExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};

export type MomentCollection = {
  __typename?: 'MomentCollection';
  cursor: Scalars['String'];
  id: Scalars['String'];
  /** Lists moments for the collection */
  moments: MomentConnection;
  publicPassword: Scalars['Boolean'];
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type MomentCollectionMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentsFilter>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderBy>;
};

export type MomentCollectionConnection = {
  __typename?: 'MomentCollectionConnection';
  data: Array<MomentCollection>;
  pagination: Pagination;
};

export type MomentCollectionDeleteInput = {
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/**
 * Any of id or slug is required. If organizationId or organizationSlug is omitted the users
 * organization id will be used for querying.
 */
export type MomentCollectionFilter = {
  /** Required if slug is null */
  id?: Maybe<Scalars['String']>;
  /** Optional */
  organizationId?: Maybe<Scalars['String']>;
  /** Optional */
  organizationSlug?: Maybe<Scalars['String']>;
  /** Required if id is null */
  slug?: Maybe<Scalars['String']>;
};

export type MomentCollectionInput = {
  momentIds: Array<Scalars['String']>;
  /** Optional. This defaults to the authenticated users org if not set. */
  organizationId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MomentCollectionsFilterByInput = {
  title?: Maybe<StringFilter>;
};

export type MomentCollectionsOrderByInput = {
  title?: Maybe<Sort>;
};

export type MomentConnection = {
  __typename?: 'MomentConnection';
  data: Array<Moment>;
  pagination: Pagination;
};

export type MomentEdit = {
  __typename?: 'MomentEdit';
  approved: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  cursor: Scalars['String'];
  exports: Array<VideoExport>;
  format: Format;
  id: Scalars['String'];
  moment: Moment;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  /** Ordered by Scene.index. */
  scenes: Array<Scene>;
  /** Marks this edit as approved for customers. */
  setApproved: Scalars['Boolean'];
  /** Marks the edit as published. */
  setPublished: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};


export type MomentEditExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};


export type MomentEditSetApprovedArgs = {
  approved: Scalars['Boolean'];
};


export type MomentEditSetPublishedArgs = {
  published: Scalars['Boolean'];
};

export type MomentEditCollection = {
  __typename?: 'MomentEditCollection';
  cursor: Scalars['String'];
  /** Lists edits for the collection */
  edits: MomentEditConnection;
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MomentEditCollectionEditsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};

export type MomentEditCollectionConnection = {
  __typename?: 'MomentEditCollectionConnection';
  data: Array<MomentEditCollection>;
  pagination: Pagination;
};

export type MomentEditCollectionFilter = {
  id?: Maybe<Scalars['String']>;
};

export type MomentEditCollectionInput = {
  momentEditIds: Array<Scalars['String']>;
  /** Optional. This defaults to the authenticated users org if not set. */
  organizationId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MomentEditCollectionsFilterByInput = {
  title?: Maybe<StringFilter>;
};

export type MomentEditCollectionsOrderByInput = {
  title?: Maybe<Sort>;
};

export type MomentEditConnection = {
  __typename?: 'MomentEditConnection';
  data: Array<MomentEdit>;
  pagination: Pagination;
};

export type MomentEditFilter = {
  id?: Maybe<Scalars['String']>;
};

export type MomentEditFilterBy = {
  formatId?: Maybe<Scalars['String']>;
  /** Defaults to false if value is not provided. */
  includeUnapproved?: Maybe<Scalars['Boolean']>;
  /** Defaults to false if value is not provided. */
  includeUnpublished?: Maybe<Scalars['Boolean']>;
};

export type MomentEditInput = {
  approved: Scalars['Boolean'];
  formatId: Scalars['String'];
  published: Scalars['Boolean'];
  scenes: Array<SceneInput>;
  title: Scalars['String'];
};

export type MomentEditOrderBy = {
  createdAt?: Maybe<Sort>;
  updatedAt?: Maybe<Sort>;
};

export type MomentEditWithIdInput = {
  approved: Scalars['Boolean'];
  formatId: Scalars['String'];
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  scenes: Array<SceneInput>;
  title: Scalars['String'];
};

export type MomentFilter = {
  id?: Maybe<Scalars['String']>;
};

export type MomentInput = {
  endsAt: Scalars['Date'];
  published?: Maybe<Scalars['Boolean']>;
  startsAt: Scalars['Date'];
  type: Scalars['String'];
  videoId: Scalars['String'];
};

export type MomentsFilter = {
  channelIds?: Maybe<Array<Scalars['String']>>;
  chat?: Maybe<ChatMomentFilterInput>;
  gameIds?: Maybe<Array<Scalars['String']>>;
  /**
   * Filters signals that are used or not used in multi perspective moments.
   * Not set: no filter
   * False: only include signals that haven't been used
   * True: only include signals that have been used
   */
  isUsed?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<ManualSignalMomentFilterInput>;
  momentIds?: Maybe<Array<Scalars['String']>>;
  multiPerspective?: Maybe<MultiPerspectiveMomentFilterInput>;
  publishedAt?: Maybe<TimeRangeFilterInput>;
  startsAt?: Maybe<TimeRangeFilterInput>;
  valorant?: Maybe<ValorantMomentFilterInput>;
};

export type MomentsFilterByInput = {
  channelIds?: Maybe<Array<Scalars['String']>>;
  isUsed?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<TimeRangeFilterInput>;
  startsAt?: Maybe<TimeRangeFilterInput>;
  videoPublishedAt?: Maybe<TimeRangeFilterInput>;
};

export type MomentsOrderBy = {
  createdAt?: Maybe<Sort>;
  startsAt?: Maybe<Sort>;
};

export type MomentsOrderByInput = {
  publishedAt?: Maybe<Sort>;
  score?: Maybe<Sort>;
  startsAt?: Maybe<Sort>;
};

export type MultiPerspectiveMoment = Edge & Moment & Unread & {
  __typename?: 'MultiPerspectiveMoment';
  channel: Channel;
  /** Derived from videos. */
  channels: Array<Channel>;
  createdAt: Scalars['Date'];
  cursor: Scalars['String'];
  edits: Array<MomentEdit>;
  endsAt: Scalars['Date'];
  exports: Array<VideoExport>;
  games?: Maybe<Array<Game>>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  /**
   * The video that defines when the moment happened. startsAt and endsAt refers to
   * timestamps within the main video.
   */
  mainVideo: Video;
  metadata?: Maybe<Scalars['JSON']>;
  offsets: Array<VideoWithOffsets>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  ratings: Array<UserRating>;
  signals: Array<Moment>;
  startsAt: Scalars['Date'];
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Not used. */
  usedIn: Array<MultiPerspectiveMoment>;
  /** Alias for mainVideo. */
  video: Video;
  /** All videos involved in the moment */
  videos: Array<Video>;
};


export type MultiPerspectiveMomentEditsArgs = {
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type MultiPerspectiveMomentExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};

export type MultiPerspectiveMomentFilterInput = {
  include?: Maybe<Scalars['Boolean']>;
  mainVideoOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Checks that all user ratings are greater than or
   * equal to the given rating.
   */
  minUserRating?: Maybe<Rating>;
  notMainVideoOnly?: Maybe<Scalars['Boolean']>;
  /** Includes moments that matches tags. Case-insensitive. */
  tags?: Maybe<TagFilterInput>;
  /** Only includes moments with no ratings. */
  unratedOnly?: Maybe<Scalars['Boolean']>;
};

export type MultiPerspectiveMomentInput = {
  edits: Array<MomentEditInput>;
  endsAt: Scalars['Date'];
  gameIds?: Maybe<Array<Scalars['String']>>;
  mainVideoId: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  offsets: Array<VideoWithOffsetsInput>;
  /** Setting published to true sets the publishedAt field to current time. */
  published: Scalars['Boolean'];
  /** A list of moment ids. */
  signalIds: Array<Scalars['String']>;
  startsAt: Scalars['Date'];
  tags: Array<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoIds: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds a moment edit to an existing moment. */
  addMomentEditToMoment?: Maybe<MomentEdit>;
  /** Adds a relation between mainVideoId and relatedVideoId. */
  addRelatedVideo?: Maybe<RelatedVideo>;
  /** Adds a scene to a moment edit. */
  addSceneToMomentEdit?: Maybe<Scene>;
  addTwitchUser?: Maybe<TwitchUser>;
  /** Analyzes moments on a channel */
  analyzeChannel: Array<Moment>;
  /** Analyzes moments on a vod */
  analyzeVod: Array<Moment>;
  authenticateClient?: Maybe<ClientToken>;
  createBetaKey?: Maybe<BetaKey>;
  /** Creates a new campaign. */
  createCampaign?: Maybe<Campaign>;
  /** Creates a new channel collection. */
  createChannelCollection?: Maybe<ChannelCollection>;
  /** Creates a new event. */
  createEvent?: Maybe<Event>;
  createManualSignal?: Maybe<ManualSignalMoment>;
  /** Creates a new moment collection. */
  createMomentCollection?: Maybe<MomentCollection>;
  /** Creates a new moment edit collection. */
  createMomentEditCollection?: Maybe<MomentEditCollection>;
  /** Creates a new multi perspective moment. */
  createMultiPerspectiveMoment?: Maybe<MultiPerspectiveMoment>;
  /** Creates a new event. */
  createValorantMatchVideoSync: ValorantMatchVideoSync;
  deleteManualSignal?: Maybe<ManualSignalMoment>;
  deleteMomentCollection?: Maybe<MomentCollection>;
  /** Deletes a multi perspective moment. */
  deleteMultiPerspectiveMoment?: Maybe<MultiPerspectiveMoment>;
  deleteValorantMatchVideoSync?: Maybe<ValorantMatchVideoSync>;
  /** Deletes an exported video. */
  deleteVideoExport?: Maybe<VideoExport>;
  /** Export an edit. */
  exportEdit?: Maybe<VideoExport>;
  /** Export a moment. */
  exportMoment?: Maybe<VideoExport>;
  /** Links an account to a channel. */
  linkAccountToChannel: Scalars['Boolean'];
  linkRiotAccount?: Maybe<RiotAccount>;
  linkTwitchAccount?: Maybe<TwitchUser>;
  /** Rate a moment. */
  rateMoment?: Maybe<UserRating>;
  /** Remove a rating for a moment. */
  removeMomentRating?: Maybe<UserRating>;
  /** Removes an existing relation between mainVideoId and relatedVideoId. */
  removeRelatedVideo?: Maybe<Scalars['Boolean']>;
  /** Removes a scene. */
  removeScene?: Maybe<Scene>;
  /**
   * Sets a list of types that a ChatMessage should have been matching.
   * Setting the shouldBeMatching field to [] means that the message should
   * not have matched anything.  Setting it to a null value clears any old stored data.
   */
  setChatMessageShouldBeMatching?: Maybe<ChatMessage>;
  /**
   * Marks content as read. Returns a boolean that indicates if the content changed status because of this mutation,
   * i.e. if the content was unread before the call.
   */
  setIsRead?: Maybe<Scalars['Boolean']>;
  /**
   * Marks content as unread. Returns a boolean that indicates if the content changed status because of this mutation,
   * i.e. if the content was read before the call.
   */
  setIsUnread?: Maybe<Scalars['Boolean']>;
  /**
   * Sets an offset between two videos for a multi perspective moment.
   * If an offset already exists between those two videos it will be overwritten, otherwise it
   * gets added.
   */
  setMultiPerspectiveMomentVideoOffset?: Maybe<MultiPerspectiveMoment>;
  setValorantMatchVideoSync?: Maybe<ValorantMatchVideoSync>;
  /** Trims a moment. Id is moment id */
  trimMoment?: Maybe<Recording>;
  /** Unlinks an account from a channel. */
  unlinkAccountFromChannel: Scalars['Boolean'];
  /** Updates a campaign. Only the fields provided in input will be updated. */
  updateCampaign?: Maybe<Campaign>;
  /** Updates a channel collection. Only the fields provided in input will be updated. */
  updateChannelCollection?: Maybe<ChannelCollection>;
  /** Updates an event. Only the fields provided in input will be updated. */
  updateEvent?: Maybe<Event>;
  updateManualSignal?: Maybe<ManualSignalMoment>;
  /** Updates a moment collection. Only the fields provided in input will be updated. */
  updateMomentCollection?: Maybe<MomentCollection>;
  /** Updates a moment edit. */
  updateMomentEdit?: Maybe<MomentEdit>;
  /** Updates a moment edit collection. Only the fields provided in input will be updated. */
  updateMomentEditCollection?: Maybe<MomentEditCollection>;
  /** Updates a multi perspective moment. */
  updateMultiPerspectiveMoment?: Maybe<MultiPerspectiveMoment>;
  /** Updates an existing relation between mainVideoId and relatedVideoId. Only the fields provided in the input will be updated. */
  updateRelatedVideo?: Maybe<RelatedVideo>;
  /** Updates a scene. */
  updateScene?: Maybe<Scene>;
  updateTwitchUser?: Maybe<TwitchUser>;
  updateUserSettings?: Maybe<UserSettings>;
  /** Update the video export for */
  updateVideoExport?: Maybe<VideoExport>;
  useBetaKey?: Maybe<MmntsUser>;
};


export type MutationAddMomentEditToMomentArgs = {
  input: MomentEditInput;
  momentId: Scalars['String'];
};


export type MutationAddRelatedVideoArgs = {
  input: RelatedVideoInput;
  mainVideoId: Scalars['String'];
  relatedVideoId: Scalars['String'];
};


export type MutationAddSceneToMomentEditArgs = {
  editId: Scalars['String'];
  scene: SceneInput;
};


export type MutationAddTwitchUserArgs = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};


export type MutationAnalyzeChannelArgs = {
  channelId: Scalars['String'];
  dryRun: Scalars['Boolean'];
  input: AnalyzeChannelInput;
};


export type MutationAnalyzeVodArgs = {
  dryRun: Scalars['Boolean'];
  videoId: Scalars['String'];
};


export type MutationAuthenticateClientArgs = {
  collectionSlug: Scalars['String'];
  organizationSlug: Scalars['String'];
  password: Scalars['String'];
  type: AuthenticateType;
};


export type MutationCreateBetaKeyArgs = {
  organizationId: Scalars['String'];
};


export type MutationCreateCampaignArgs = {
  input: CampaignInput;
};


export type MutationCreateChannelCollectionArgs = {
  input: ChannelCollectionInput;
};


export type MutationCreateEventArgs = {
  input: EventInput;
};


export type MutationCreateManualSignalArgs = {
  input: ManualSignalInput;
};


export type MutationCreateMomentCollectionArgs = {
  input: MomentCollectionInput;
};


export type MutationCreateMomentEditCollectionArgs = {
  input: MomentEditCollectionInput;
};


export type MutationCreateMultiPerspectiveMomentArgs = {
  input: MultiPerspectiveMomentInput;
};


export type MutationCreateValorantMatchVideoSyncArgs = {
  input: ValorantMatchVideoSyncEventInput;
};


export type MutationDeleteManualSignalArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMomentCollectionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMultiPerspectiveMomentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteValorantMatchVideoSyncArgs = {
  valorantMatchId: Scalars['String'];
  videoId: Scalars['String'];
};


export type MutationDeleteVideoExportArgs = {
  id: Scalars['String'];
};


export type MutationExportEditArgs = {
  id: Scalars['String'];
};


export type MutationExportMomentArgs = {
  edit: MomentEditInput;
  id: Scalars['String'];
};


export type MutationLinkAccountToChannelArgs = {
  account: AccountInput;
  channelId: Scalars['String'];
};


export type MutationLinkRiotAccountArgs = {
  code: Scalars['String'];
  twitchId: Scalars['String'];
};


export type MutationLinkTwitchAccountArgs = {
  code: Scalars['String'];
};


export type MutationRateMomentArgs = {
  input: UserRatingInput;
  momentId: Scalars['String'];
};


export type MutationRemoveMomentRatingArgs = {
  momentId: Scalars['String'];
};


export type MutationRemoveRelatedVideoArgs = {
  mainVideoId: Scalars['String'];
  relatedVideoId: Scalars['String'];
};


export type MutationRemoveSceneArgs = {
  sceneId: Scalars['String'];
};


export type MutationSetChatMessageShouldBeMatchingArgs = {
  id: Scalars['String'];
  shouldBeMatching?: Maybe<Array<Scalars['String']>>;
};


export type MutationSetIsReadArgs = {
  contentId: Scalars['String'];
  contentType: UnreadContentType;
};


export type MutationSetIsUnreadArgs = {
  contentId: Scalars['String'];
  contentType: UnreadContentType;
};


export type MutationSetMultiPerspectiveMomentVideoOffsetArgs = {
  fromVideoId: Scalars['String'];
  momentId: Scalars['String'];
  offsets: OffsetsInput;
  toVideoId: Scalars['String'];
};


export type MutationSetValorantMatchVideoSyncArgs = {
  matchStartTime: Scalars['Date'];
  valorantMatchId: Scalars['String'];
  videoId: Scalars['String'];
};


export type MutationTrimMomentArgs = {
  id: Scalars['String'];
  input: TrimMomentInput;
};


export type MutationUnlinkAccountFromChannelArgs = {
  account: AccountInput;
  channelId: Scalars['String'];
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['String'];
  input: PartialCampaignInput;
};


export type MutationUpdateChannelCollectionArgs = {
  id: Scalars['String'];
  input?: Maybe<PartialChannelCollectionInput>;
};


export type MutationUpdateEventArgs = {
  id: Scalars['String'];
  input: PartialEventInput;
};


export type MutationUpdateManualSignalArgs = {
  input: PartialManualSignalInput;
};


export type MutationUpdateMomentCollectionArgs = {
  id: Scalars['String'];
  input?: Maybe<PartialMomentCollectionInput>;
};


export type MutationUpdateMomentEditArgs = {
  id: Scalars['String'];
  input: PartialMomentEditInput;
};


export type MutationUpdateMomentEditCollectionArgs = {
  id: Scalars['String'];
  input?: Maybe<PartialMomentEditCollectionInput>;
};


export type MutationUpdateMultiPerspectiveMomentArgs = {
  id: Scalars['String'];
  input: PartialMultiPerspectiveMomentInput;
};


export type MutationUpdateRelatedVideoArgs = {
  input: PartialRelatedVideoInput;
  mainVideoId: Scalars['String'];
  relatedVideoId: Scalars['String'];
};


export type MutationUpdateSceneArgs = {
  input: PartialSceneInput;
  sceneId: Scalars['String'];
};


export type MutationUpdateTwitchUserArgs = {
  id: Scalars['String'];
  input: PartialTwitchUserInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: PartialUserSettings;
};


export type MutationUpdateVideoExportArgs = {
  id: Scalars['String'];
  input: PartialVideoExportInput;
};


export type MutationUseBetaKeyArgs = {
  betaKey: Scalars['String'];
};

export type Offsets = {
  __typename?: 'Offsets';
  audioOffset: Scalars['Float'];
  videoOffset: Scalars['Float'];
};

export type OffsetsInput = {
  audioOffset: Scalars['Float'];
  videoOffset: Scalars['Float'];
};

export type Organization = {
  __typename?: 'Organization';
  campaigns: Array<Campaign>;
  collections: MomentCollectionConnection;
  editCollections: MomentEditCollectionConnection;
  id: Scalars['String'];
  members: Array<MmntsUser>;
  /** Lists moments for the organization */
  moments?: Maybe<MomentConnection>;
  name: Scalars['String'];
  roster: TwitchUserConnection;
  slug: Scalars['String'];
};


export type OrganizationCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentCollectionsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentCollectionsOrderByInput>;
};


export type OrganizationEditCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentEditCollectionsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditCollectionsOrderByInput>;
};


export type OrganizationMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<MomentsFilter>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderBy>;
};


export type OrganizationRosterArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ChannelsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<ChannelsOrderByInput>;
};

export type OrganizationQueryBy = {
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Overlay = {
  __typename?: 'Overlay';
  data: Scalars['JSON'];
  overlayType: OverlayType;
};

export type OverlayInput = {
  data: Scalars['JSON'];
  overlayType: OverlayType;
};

export enum OverlayType {
  Killfeed = 'KILLFEED'
}

export type Pagination = {
  __typename?: 'Pagination';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
};

export type PartialCampaignInput = {
  channelCampaignSegments?: Maybe<Array<ChannelCampaignSegmentsInput>>;
  channelCollectionId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  momentTypes?: Maybe<Array<Scalars['String']>>;
  slug?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};

export type PartialChannelCollectionInput = {
  channelIds?: Maybe<Array<Scalars['String']>>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PartialEventInput = {
  channelCollectionId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  momentCollectionIds?: Maybe<Array<Scalars['String']>>;
  slug?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};

export type PartialManualSignalInput = {
  endsAt?: Maybe<Scalars['Date']>;
  gameIds?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Scalars['JSON']>;
  published?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['String']>;
};

export type PartialMomentCollectionInput = {
  momentIds?: Maybe<Array<Scalars['String']>>;
  password?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PartialMomentEditCollectionInput = {
  momentEditIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type PartialMomentEditInput = {
  approved?: Maybe<Scalars['Boolean']>;
  formatId?: Maybe<Scalars['String']>;
  organizationid?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  scenes?: Maybe<Array<SceneInputWithId>>;
  title?: Maybe<Scalars['String']>;
};

export type PartialMultiPerspectiveMomentInput = {
  edits?: Maybe<Array<MomentEditWithIdInput>>;
  endsAt?: Maybe<Scalars['Date']>;
  gameIds?: Maybe<Array<Scalars['String']>>;
  mainVideoId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  offsets?: Maybe<Array<VideoWithOffsetsInput>>;
  /** Setting published to true sets the publishedAt field to current time. */
  published?: Maybe<Scalars['Boolean']>;
  /** A list of moment ids. */
  signalIds?: Maybe<Array<Scalars['String']>>;
  startsAt?: Maybe<Scalars['Date']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  videoIds?: Maybe<Array<Scalars['String']>>;
};

export type PartialRelatedVideoInput = {
  offset?: Maybe<Scalars['Float']>;
  overlaps?: Maybe<Array<TimerangeInput>>;
  reason?: Maybe<Scalars['String']>;
};

export type PartialSceneInput = {
  cropData?: Maybe<Array<CropDataInput>>;
  end?: Maybe<Scalars['Date']>;
  index?: Maybe<Scalars['Int']>;
  overlays?: Maybe<Array<OverlayInput>>;
  start?: Maybe<Scalars['Date']>;
  template?: Maybe<TemplateInput>;
};

export type PartialTwitchUserInput = {
  autoSyncValorantMatches?: Maybe<Scalars['Boolean']>;
  dontJoinChat?: Maybe<Scalars['Boolean']>;
};

export type PartialUserSettings = {
  region?: Maybe<InputRegionSetting>;
};

export type PartialVideoExportInput = {
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  momentEditId?: Maybe<Scalars['String']>;
  momentId?: Maybe<Scalars['String']>;
  /**
   * Output is JSON in format of
   * {
   *   videos: {[resolution: string]: string},
   *   thumbnails: {[index: number]: string}
   *   source: RecordingSource
   * }
   */
  output?: Maybe<Scalars['String']>;
  status?: Maybe<RecordingStatus>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PlayedInValorantMatches = {
  __typename?: 'PlayedInValorantMatches';
  valorantMatches: Array<ValorantMatch>;
};

export type Query = {
  __typename?: 'Query';
  campaign?: Maybe<Campaign>;
  channel?: Maybe<Channel>;
  channelCollection?: Maybe<ChannelCollection>;
  channelCollections?: Maybe<ChannelCollectionConnection>;
  channels?: Maybe<ChannelConnection>;
  event?: Maybe<Event>;
  formats?: Maybe<Array<Maybe<Format>>>;
  game?: Maybe<Game>;
  moment?: Maybe<Moment>;
  momentCollection?: Maybe<MomentCollection>;
  /**
   * Lists moment collections. Only includes collections that the current
   * user has permission to see, i.e. collections belonging to the users
   * organization or collections that are owned by the current user.
   */
  momentCollections: MomentCollectionConnection;
  momentEdit?: Maybe<MomentEdit>;
  momentEditCollection?: Maybe<MomentEditCollection>;
  /** Lists moment edit collections. */
  momentEditCollections: MomentEditCollectionConnection;
  /** Lists all edits that belongs to the users organization. */
  momentEdits: MomentEditConnection;
  /** Lists moments. */
  moments?: Maybe<MomentConnection>;
  organization?: Maybe<Organization>;
  recording?: Maybe<Recording>;
  twitchUserSourceByName?: Maybe<TwitchUserSource>;
  /**
   * Fetches a list of the Valorant leaderboard. We snapshot the leaderboard
   * frequently. By defualt the most recent snapshot is returned, the 'snapshotTakenAt'
   * parameter can be used to use a snapshot from a given date.
   */
  valorantLeaderboard?: Maybe<ValorantLeaderboardPlayerConnection>;
  valorantMatch?: Maybe<ValorantMatch>;
  valorantMatchVideoSync?: Maybe<ValorantMatchVideoSync>;
  valorantMatches?: Maybe<ValorantMatchConnection>;
  /** The channelIds parameter limits which channels to show moments for. */
  valorantMoments?: Maybe<ValorantMomentConnection>;
  video?: Maybe<Video>;
  /** Get video export by id. */
  videoExport?: Maybe<VideoExport>;
  videos?: Maybe<MixedVideoConnection>;
  viewer?: Maybe<MmntsUser>;
};


export type QueryCampaignArgs = {
  filter: CampaignFilter;
};


export type QueryChannelArgs = {
  filter?: Maybe<ChannelFilter>;
};


export type QueryChannelCollectionArgs = {
  filter?: Maybe<ChannelCollectionFilter>;
};


export type QueryChannelCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ChannelCollectionsFilter>;
  first: Scalars['Int'];
  orderBy?: Maybe<ChannelCollectionsOrderBy>;
};


export type QueryChannelsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ChannelsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<ChannelsOrderByInput>;
};


export type QueryEventArgs = {
  filter: EventFilter;
};


export type QueryGameArgs = {
  filter?: Maybe<GameFilter>;
};


export type QueryMomentArgs = {
  filter?: Maybe<MomentFilter>;
};


export type QueryMomentCollectionArgs = {
  filter: MomentCollectionFilter;
};


export type QueryMomentCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentCollectionsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentCollectionsOrderByInput>;
};


export type QueryMomentEditArgs = {
  filter?: Maybe<MomentEditFilter>;
};


export type QueryMomentEditCollectionArgs = {
  filter?: Maybe<MomentEditCollectionFilter>;
};


export type QueryMomentEditCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentEditCollectionsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditCollectionsOrderByInput>;
};


export type QueryMomentEditsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type QueryMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<MomentsFilter>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderBy>;
};


export type QueryOrganizationArgs = {
  by: OrganizationQueryBy;
};


export type QueryRecordingArgs = {
  id: Scalars['String'];
};


export type QueryTwitchUserSourceByNameArgs = {
  name: Scalars['String'];
};


export type QueryValorantLeaderboardArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ValorantLeaderboardFilterByInput>;
  first: Scalars['Int'];
  region: ValorantRegion;
  snapshotTakenAt?: Maybe<ValorantLeaderboardSnapshotInput>;
};


export type QueryValorantMatchArgs = {
  id: Scalars['String'];
};


export type QueryValorantMatchVideoSyncArgs = {
  valorantMatchId: Scalars['String'];
  videoId: Scalars['String'];
};


export type QueryValorantMatchesArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ValorantMatchesFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<ValorantMatchesOrderByInput>;
};


export type QueryValorantMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  channelIds: Array<Scalars['String']>;
  filter?: Maybe<ValorantMomentFilterInput>;
  first: Scalars['Int'];
};


export type QueryVideoArgs = {
  id: Scalars['String'];
  platform: StreamingPlatform;
};


export type QueryVideoExportArgs = {
  id: Scalars['String'];
};


export type QueryVideosArgs = {
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<VideosFilter>;
  first: Scalars['Int'];
};

export enum Rating {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export type Recording = {
  __typename?: 'Recording';
  duration: Scalars['Float'];
  id: Scalars['String'];
  output?: Maybe<RecordingOutput>;
  parent?: Maybe<Recording>;
  /** startsAt is relative to the video in seconds. */
  startsAt: Scalars['Float'];
  status: RecordingStatus;
  video: Video;
};

export type RecordingOutput = {
  __typename?: 'RecordingOutput';
  source?: Maybe<RecordingSource>;
  thumbnails?: Maybe<Array<Maybe<RecordingThumbnail>>>;
  videos?: Maybe<Array<Maybe<RecordingVideo>>>;
};

/**
 * Depending on where the recording was rendered,
 * the services will have different base urls.
 */
export enum RecordingSource {
  Raas = 'RAAS',
  Rec = 'REC'
}

export enum RecordingStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS'
}

export type RecordingThumbnail = Asset & {
  __typename?: 'RecordingThumbnail';
  index: Scalars['Int'];
  url: Scalars['String'];
};

export type RecordingVideo = Asset & {
  __typename?: 'RecordingVideo';
  resolution: Scalars['String'];
  url: Scalars['String'];
};

export type Rect = {
  __typename?: 'Rect';
  height: Scalars['Percent'];
  width: Scalars['Percent'];
  x: Scalars['Percent'];
  y: Scalars['Percent'];
};

export type RectInput = {
  height: Scalars['Percent'];
  width: Scalars['Percent'];
  x: Scalars['Percent'];
  y: Scalars['Percent'];
};

export enum Region {
  Eu = 'EU',
  Us = 'US'
}

export type RegionSetting = {
  __typename?: 'RegionSetting';
  value: Region;
};

export type RelatedVideo = {
  __typename?: 'RelatedVideo';
  offset?: Maybe<Scalars['Float']>;
  overlaps: Array<Timerange>;
  reasons: Array<RelatedVideoReason>;
  video: Video;
};

export type RelatedVideoInput = {
  offset?: Maybe<Scalars['Float']>;
  overlaps: Array<TimerangeInput>;
  reason: Scalars['String'];
};

export type RelatedVideoReason = CustomReason | PlayedInValorantMatches;

export type RiotAccount = Account & {
  __typename?: 'RiotAccount';
  channel?: Maybe<Channel>;
  id: Scalars['String'];
  puuid: Scalars['String'];
  valorantMatches?: Maybe<ValorantMatchConnection>;
  valorantUserInfo?: Maybe<ValorantUserInfo>;
};


export type RiotAccountValorantMatchesArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ValorantMatchesFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<ValorantMatchesOrderByInput>;
};

export type RiotAccountInValorantMatch = ValorantMatchParticipant & {
  __typename?: 'RiotAccountInValorantMatch';
  account: RiotAccount;
  gameName?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
};

export type Scene = {
  __typename?: 'Scene';
  cropData: Array<CropData>;
  end: Scalars['Date'];
  id: Scalars['String'];
  /** Key that is used to sort scenes in an edit. */
  index: Scalars['Int'];
  overlays?: Maybe<Array<Overlay>>;
  start: Scalars['Date'];
  template: Template;
};

export type SceneInput = {
  cropData: Array<CropDataInput>;
  end: Scalars['Date'];
  index: Scalars['Int'];
  overlays?: Maybe<Array<OverlayInput>>;
  start: Scalars['Date'];
  template: TemplateInput;
};

export type SceneInputWithId = {
  cropData: Array<CropDataInput>;
  end: Scalars['Date'];
  id: Scalars['String'];
  index: Scalars['Int'];
  overlays?: Maybe<Array<OverlayInput>>;
  start: Scalars['Date'];
  template: TemplateInput;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stream = {
  allowedChatMomentTypes: Array<Scalars['String']>;
  endedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  startedAt: Scalars['Date'];
};

export type StreamConnection = {
  data: Array<Stream>;
  pagination: Pagination;
};

export enum StreamingPlatform {
  Twitch = 'TWITCH',
  Youtube = 'YOUTUBE'
}

export type StreamsFilterByInput = {
  overlaps?: Maybe<TimeRangeFilterInput>;
  startedAt?: Maybe<TimeRangeFilterInput>;
};

export type StreamsOrderByInput = {
  startedAt?: Maybe<Sort>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type TagFilterInput = {
  and?: Maybe<Array<Scalars['String']>>;
  or?: Maybe<Array<Scalars['String']>>;
};

export type Template = {
  __typename?: 'Template';
  crops: Array<Crop>;
  /**
   * ID is optional since these can be stored in a template library and belong to a Format,
   * or a new one can be created 'inline' for a moment if the user wants a custom template.
   */
  id?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Either id or title and crops is required. */
export type TemplateInput = {
  crops?: Maybe<Array<CropInput>>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TimeRangeFilterInput = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export type Timerange = {
  __typename?: 'Timerange';
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type TimerangeInput = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type TrimMomentInput = {
  /** duration is the wanted duration of the trim. Input is in seconds. */
  duration: Scalars['Float'];
  /** startsAt should be relative to the source recording. Input in seconds. */
  startsAt: Scalars['Float'];
};

export type TwitchStream = Edge & Stream & Unread & {
  __typename?: 'TwitchStream';
  allowedChatMomentTypes: Array<Scalars['String']>;
  cursor: Scalars['String'];
  endedAt?: Maybe<Scalars['Date']>;
  gamesPlayed: Array<GamePlayed>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  startedAt: Scalars['Date'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<TwitchUser>;
  valorantMatches: Array<ValorantMatch>;
  video?: Maybe<TwitchVideo>;
};

export type TwitchStreamConnection = StreamConnection & {
  __typename?: 'TwitchStreamConnection';
  data: Array<TwitchStream>;
  pagination: Pagination;
};

export type TwitchUser = Channel & Edge & {
  __typename?: 'TwitchUser';
  autoSyncValorantMatches: Scalars['Boolean'];
  broadcasterType?: Maybe<Scalars['String']>;
  chatMessages: ChatMessageConnection;
  cursor: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  dontJoinChat: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  linkedAccounts: Array<Account>;
  login?: Maybe<Scalars['String']>;
  moments: MomentConnection;
  name: Scalars['String'];
  offlineImageUrl?: Maybe<Scalars['String']>;
  platform: StreamingPlatform;
  profileImageUrl?: Maybe<Scalars['String']>;
  streams: TwitchStreamConnection;
  videos: TwitchVideoConnection;
  viewCount?: Maybe<Scalars['Float']>;
};


export type TwitchUserChatMessagesArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type TwitchUserMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<ChannelMomentsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderByInput>;
};


export type TwitchUserStreamsArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<StreamsFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<StreamsOrderByInput>;
};


export type TwitchUserVideosArgs = {
  after?: Maybe<Scalars['String']>;
  filterBy?: Maybe<VideosFilterByInput>;
  first: Scalars['Int'];
  orderBy?: Maybe<VideosOrderByInput>;
};

export type TwitchUserConnection = {
  __typename?: 'TwitchUserConnection';
  data: Array<TwitchUser>;
  pagination: Pagination;
};

export type TwitchUserSource = {
  __typename?: 'TwitchUserSource';
  creationDate?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

export type TwitchVideo = Edge & Unread & Video & {
  __typename?: 'TwitchVideo';
  cursor: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  moments: MomentConnection;
  mutedSegments?: Maybe<Array<VideoSegment>>;
  publishedAt: Scalars['Date'];
  relatedVideos: Array<RelatedVideo>;
  stream?: Maybe<TwitchStream>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  user?: Maybe<TwitchUser>;
  valorantMatchSyncData: Array<ValorantMatchVideoSync>;
  valorantMatches: Array<ValorantMatch>;
  vod: Array<RecordingVideo>;
};


export type TwitchVideoMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderByInput>;
};

export type TwitchVideoConnection = VideoConnection & {
  __typename?: 'TwitchVideoConnection';
  data: Array<TwitchVideo>;
  pagination: Pagination;
};

export type Unread = {
  isUnread: Scalars['Boolean'];
};

export enum UnreadContentType {
  Moment = 'MOMENT',
  TwitchStream = 'TWITCH_STREAM',
  TwitchVideo = 'TWITCH_VIDEO'
}

export type UserRating = {
  __typename?: 'UserRating';
  rating: Rating;
  user: MmntsUser;
};

export type UserRatingInput = {
  rating: Rating;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  region: RegionSetting;
};

export enum ValorantAgent {
  Astra = 'ASTRA',
  Breach = 'BREACH',
  Brimstone = 'BRIMSTONE',
  Chamber = 'CHAMBER',
  Cypher = 'CYPHER',
  Deadlock = 'DEADLOCK',
  Fade = 'FADE',
  Gekko = 'GEKKO',
  Harbor = 'HARBOR',
  Jett = 'JETT',
  Kayo = 'KAYO',
  Killjoy = 'KILLJOY',
  Neon = 'NEON',
  Omen = 'OMEN',
  Phoenix = 'PHOENIX',
  Raze = 'RAZE',
  Reyna = 'REYNA',
  Sage = 'SAGE',
  Skye = 'SKYE',
  Sova = 'SOVA',
  Unknown = 'UNKNOWN',
  Viper = 'VIPER',
  Yoru = 'YORU'
}

export enum ValorantCompetitiveTier {
  Ascendant_1 = 'ASCENDANT_1',
  Ascendant_2 = 'ASCENDANT_2',
  Ascendant_3 = 'ASCENDANT_3',
  Bronze_1 = 'BRONZE_1',
  Bronze_2 = 'BRONZE_2',
  Bronze_3 = 'BRONZE_3',
  Diamond_1 = 'DIAMOND_1',
  Diamond_2 = 'DIAMOND_2',
  Diamond_3 = 'DIAMOND_3',
  Gold_1 = 'GOLD_1',
  Gold_2 = 'GOLD_2',
  Gold_3 = 'GOLD_3',
  Immortal_1 = 'IMMORTAL_1',
  Immortal_2 = 'IMMORTAL_2',
  Immortal_3 = 'IMMORTAL_3',
  Iron_1 = 'IRON_1',
  Iron_2 = 'IRON_2',
  Iron_3 = 'IRON_3',
  NotRanked = 'NOT_RANKED',
  Platinum_1 = 'PLATINUM_1',
  Platinum_2 = 'PLATINUM_2',
  Platinum_3 = 'PLATINUM_3',
  Radiant = 'RADIANT',
  Silver_1 = 'SILVER_1',
  Silver_2 = 'SILVER_2',
  Silver_3 = 'SILVER_3',
  Unknown = 'UNKNOWN'
}

export type ValorantFinishingDamage = {
  __typename?: 'ValorantFinishingDamage';
  /**
   * Either returns the name of the weapon like 'Phantom' or an ability,
   * like 'Ability2'.
   */
  damageItem?: Maybe<Scalars['String']>;
  /**
   * Should be either 'Weapon' or 'Ability'
   * but their api docs doesn't make it clear what values are supported.
   */
  damageType?: Maybe<Scalars['String']>;
  isSecondaryFireMode?: Maybe<Scalars['Boolean']>;
};

export type ValorantLeaderboardFilterByInput = {
  playerAccountIds?: Maybe<Array<Scalars['String']>>;
  twitchUserIds?: Maybe<Array<Scalars['String']>>;
};

export type ValorantLeaderboardPlayer = {
  __typename?: 'ValorantLeaderboardPlayer';
  account?: Maybe<RiotAccount>;
  competitiveTier: ValorantCompetitiveTier;
  cursor?: Maybe<Scalars['String']>;
  gameName?: Maybe<Scalars['String']>;
  leaderboardRank: Scalars['Int'];
  numberOfWins: Scalars['Int'];
  rankedRating: Scalars['Int'];
  tagLine?: Maybe<Scalars['String']>;
};

export type ValorantLeaderboardPlayerConnection = {
  __typename?: 'ValorantLeaderboardPlayerConnection';
  data: Array<ValorantLeaderboardPlayer>;
  pagination: Pagination;
  snapshotTakenAt?: Maybe<Scalars['Date']>;
};

/**
 * Filter used to fetch a valorant leaderboard snapshot taken as close as possible to the given date.
 * If 'before' is set, the last snapshot taken before the given Date is returned.
 * If 'after' is set, the first snapshot taken after the given Date is returned.
 * Both 'before' and 'after' cannot be used at the same time.
 */
export type ValorantLeaderboardSnapshotInput = {
  after?: Maybe<Scalars['Date']>;
  before?: Maybe<Scalars['Date']>;
};

export enum ValorantMap {
  Ascent = 'ASCENT',
  Bind = 'BIND',
  Breeze = 'BREEZE',
  Fracture = 'FRACTURE',
  Haven = 'HAVEN',
  Icebox = 'ICEBOX',
  Lotus = 'LOTUS',
  Pearl = 'PEARL',
  Range = 'RANGE',
  Split = 'SPLIT',
  Sunset = 'SUNSET',
  Unknown = 'UNKNOWN'
}

export type ValorantMatch = {
  __typename?: 'ValorantMatch';
  cursor?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  map?: Maybe<ValorantMap>;
  players: Array<ValorantMatchPlayer>;
  rawRoundResults?: Maybe<Scalars['JSON']>;
  roundResults: Array<ValorantRoundResult>;
  startedAt: Scalars['Date'];
  type: ValorantMatchType;
  videoSyncData: Array<ValorantMatchVideoSync>;
  winningTeam?: Maybe<ValorantMatchTeam>;
};

export type ValorantMatchConnection = {
  __typename?: 'ValorantMatchConnection';
  data: Array<ValorantMatch>;
  pagination: Pagination;
};

export type ValorantMatchParticipant = {
  account: RiotAccount;
  gameName?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
};

export type ValorantMatchPlayer = ValorantMatchParticipant & {
  __typename?: 'ValorantMatchPlayer';
  account: RiotAccount;
  agent?: Maybe<ValorantAgent>;
  competitiveTier?: Maybe<ValorantCompetitiveTier>;
  gameName?: Maybe<Scalars['String']>;
  match: ValorantMatch;
  playerCard?: Maybe<Scalars['String']>;
  playerTitle?: Maybe<Scalars['String']>;
  stats?: Maybe<Scalars['JSON']>;
  tagLine?: Maybe<Scalars['String']>;
  team?: Maybe<ValorantMatchTeam>;
};

export type ValorantMatchPlayerRoundStats = {
  __typename?: 'ValorantMatchPlayerRoundStats';
  damage?: Maybe<Array<Maybe<ValorantMatchRoundDamage>>>;
  economy?: Maybe<ValorantMatchRoundEconomy>;
  kills?: Maybe<Array<Maybe<ValorantMatchRoundKill>>>;
  player?: Maybe<RiotAccountInValorantMatch>;
  score?: Maybe<Scalars['Int']>;
};

export type ValorantMatchRoundDamage = {
  __typename?: 'ValorantMatchRoundDamage';
  bodyshots?: Maybe<Scalars['Int']>;
  damage?: Maybe<Scalars['Int']>;
  headshots?: Maybe<Scalars['Int']>;
  legshots?: Maybe<Scalars['Int']>;
  receiver?: Maybe<RiotAccountInValorantMatch>;
};

export type ValorantMatchRoundEconomy = {
  __typename?: 'ValorantMatchRoundEconomy';
  armorId?: Maybe<Scalars['String']>;
  loadoutValue?: Maybe<Scalars['Int']>;
  remaining?: Maybe<Scalars['Int']>;
  spent?: Maybe<Scalars['Int']>;
  weaponId?: Maybe<Scalars['String']>;
};

export type ValorantMatchRoundKill = {
  __typename?: 'ValorantMatchRoundKill';
  assistants?: Maybe<Array<Maybe<RiotAccountInValorantMatch>>>;
  finishingDamage?: Maybe<ValorantFinishingDamage>;
  killer?: Maybe<RiotAccountInValorantMatch>;
  timeSinceGameStartMillis?: Maybe<Scalars['Int']>;
  timeSinceRoundStartMillis?: Maybe<Scalars['Int']>;
  victim?: Maybe<RiotAccountInValorantMatch>;
};

export enum ValorantMatchTeam {
  Blue = 'BLUE',
  Red = 'RED',
  Solo = 'SOLO',
  Unknown = 'UNKNOWN'
}

export enum ValorantMatchType {
  Casual = 'CASUAL',
  Competitive = 'COMPETITIVE',
  Custom = 'CUSTOM',
  Deathmatch = 'DEATHMATCH',
  Escalation = 'ESCALATION',
  OneForAll = 'ONE_FOR_ALL',
  Premier = 'PREMIER',
  SpikeRush = 'SPIKE_RUSH',
  Swiftplay = 'SWIFTPLAY',
  Unknown = 'UNKNOWN',
  Unrated = 'UNRATED'
}

export type ValorantMatchVideoSync = {
  __typename?: 'ValorantMatchVideoSync';
  error?: Maybe<Scalars['String']>;
  match: ValorantMatch;
  matchStartTime: Scalars['Date'];
  status?: Maybe<ValorantMatchVideoSyncStatus>;
  video: TwitchVideo;
};

export type ValorantMatchVideoSyncEventInput = {
  valorantMatchId: Scalars['String'];
  videoId: Scalars['String'];
};

export enum ValorantMatchVideoSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS'
}

export type ValorantMatchesFilterByInput = {
  endedAt?: Maybe<TimeRangeFilterInput>;
  /** Filters on match types. Is null by default which means include all match types. */
  matchTypes?: Maybe<Array<ValorantMatchType>>;
  playerAccountIds?: Maybe<Array<Scalars['String']>>;
  startedAt?: Maybe<TimeRangeFilterInput>;
};

export type ValorantMatchesOrderByInput = {
  startedAt?: Maybe<Sort>;
};

export type ValorantMoment = Edge & Moment & Unread & {
  __typename?: 'ValorantMoment';
  agent: ValorantAgent;
  channel: Channel;
  combatScore: Scalars['Int'];
  createdAt: Scalars['Date'];
  cursor: Scalars['String'];
  damage: Array<ValorantMatchRoundDamage>;
  edits: Array<MomentEdit>;
  endsAt: Scalars['Date'];
  exports: Array<VideoExport>;
  games?: Maybe<Array<Game>>;
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  kills: Array<ValorantMatchRoundKill>;
  match: ValorantMatch;
  metadata?: Maybe<Scalars['JSON']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['Date']>;
  roundCeremony?: Maybe<ValorantRoundCeremony>;
  startsAt: Scalars['Date'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  usedIn: Array<MultiPerspectiveMoment>;
  valorantTags: Array<ValorantMomentTag>;
  video: Video;
};


export type ValorantMomentEditsArgs = {
  filterBy?: Maybe<MomentEditFilterBy>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentEditOrderBy>;
};


export type ValorantMomentExportsArgs = {
  first: Scalars['Int'];
  orderBy?: Maybe<VideoExportOrderBy>;
};

export type ValorantMomentConnection = {
  __typename?: 'ValorantMomentConnection';
  data: Array<ValorantMoment>;
  pagination: Pagination;
};

export type ValorantMomentFilterInput = {
  agents?: Maybe<Array<ValorantAgent>>;
  include?: Maybe<Scalars['Boolean']>;
  maps?: Maybe<Array<ValorantMap>>;
  matchEndedAt?: Maybe<Scalars['Date']>;
  matchStartedAt?: Maybe<Scalars['Date']>;
  /** Minimum number of kills. Defaults to 2. */
  minKills?: Maybe<Scalars['Int']>;
  players?: Maybe<ValorantMomentPlayerFilter>;
  roundCeremony?: Maybe<ValorantRoundCeremony>;
  tags?: Maybe<ValorantMomentTagsFilterInput>;
};

/** Supports both riot account ids and channel ids. Don't use both. */
export type ValorantMomentPlayer = {
  channelId?: Maybe<Scalars['String']>;
  riotAccountId?: Maybe<Scalars['String']>;
};

/** Use either teammate and/or enemy channelIds, or playerChannelIds. */
export type ValorantMomentPlayerFilter = {
  enemyChannelIds?: Maybe<Array<ValorantMomentPlayer>>;
  playerChannelIds?: Maybe<Array<ValorantMomentPlayer>>;
  teammateChannelIds?: Maybe<Array<ValorantMomentPlayer>>;
};

export enum ValorantMomentTag {
  Clutch = 'CLUTCH',
  Defused = 'DEFUSED',
  Kills = 'KILLS',
  Planted = 'PLANTED'
}

export type ValorantMomentTagsFilterInput = {
  exclude?: Maybe<TagFilterInput>;
  include?: Maybe<TagFilterInput>;
};

export enum ValorantRegion {
  Eu = 'EU',
  Na = 'NA'
}

export enum ValorantRoundCeremony {
  Ace = 'ACE',
  Closer = 'CLOSER',
  Clutch = 'CLUTCH',
  Default = 'DEFAULT',
  Flawless = 'FLAWLESS',
  Teamace = 'TEAMACE',
  Thrifty = 'THRIFTY'
}

export type ValorantRoundResult = {
  __typename?: 'ValorantRoundResult';
  bombDefuser?: Maybe<RiotAccountInValorantMatch>;
  bombPlanter?: Maybe<RiotAccountInValorantMatch>;
  defuseRoundTime?: Maybe<Scalars['Int']>;
  plantRoundTime?: Maybe<Scalars['Int']>;
  plantSite?: Maybe<Scalars['String']>;
  playerStats?: Maybe<Array<Maybe<ValorantMatchPlayerRoundStats>>>;
  roundCeremony?: Maybe<ValorantRoundCeremony>;
  roundNum?: Maybe<Scalars['Int']>;
  roundResult?: Maybe<ValorantRoundResultType>;
  winningTeam?: Maybe<ValorantMatchTeam>;
};

export enum ValorantRoundResultType {
  BombDefused = 'BOMB_DEFUSED',
  BombDetonated = 'BOMB_DETONATED',
  Eliminated = 'ELIMINATED',
  RoundTimerExpired = 'ROUND_TIMER_EXPIRED',
  Surrendered = 'SURRENDERED'
}

export type ValorantUserInfo = {
  __typename?: 'ValorantUserInfo';
  gameName?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
};

export type Video = {
  id: Scalars['String'];
  isUnread: Scalars['Boolean'];
  moments: MomentConnection;
  publishedAt: Scalars['Date'];
  relatedVideos: Array<RelatedVideo>;
  title: Scalars['String'];
  valorantMatches: Array<ValorantMatch>;
  vod: Array<RecordingVideo>;
};


export type VideoMomentsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  orderBy?: Maybe<MomentsOrderByInput>;
};

export type VideoConnection = {
  data: Array<Video>;
  pagination: Pagination;
};

export type VideoExport = {
  __typename?: 'VideoExport';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  moment: Moment;
  momentEdit?: Maybe<MomentEdit>;
  output?: Maybe<RecordingOutput>;
  status: RecordingStatus;
  updatedAt: Scalars['Date'];
};

export type VideoExportOrderBy = {
  createdAt?: Maybe<Sort>;
  updatedAt?: Maybe<Sort>;
};

export type VideoSegment = {
  __typename?: 'VideoSegment';
  duration: Scalars['Float'];
  startsAt: Scalars['Float'];
};

export type VideoWithOffsets = {
  __typename?: 'VideoWithOffsets';
  fromVideo: Video;
  offsets: Offsets;
  toVideo: Video;
};

export type VideoWithOffsetsInput = {
  fromVideoId: Scalars['String'];
  offsets: OffsetsInput;
  toVideoId: Scalars['String'];
};

export type VideosFilter = {
  videoIds?: Maybe<Array<Scalars['String']>>;
};

export type VideosFilterByInput = {
  publishedAt?: Maybe<TimeRangeFilterInput>;
};

export type VideosOrderByInput = {
  publishedAt?: Maybe<Sort>;
};

export type GetTwitchUserBasicsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetTwitchUserBasicsQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, id: string }> };

export type GetVideoSrcUrlsQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetVideoSrcUrlsQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }>, vod: Array<{ __typename?: 'RecordingVideo', resolution: string, url: string }> }> };

export type GetMatchMomentCollectionQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetMatchMomentCollectionQuery = { __typename?: 'Query', momentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename: 'ChatMoment', type: string, metadata?: Maybe<any>, id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'ValorantMoment', id: string, startsAt: any, endsAt: any, agent: ValorantAgent, valorantTags: Array<ValorantMomentTag>, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }> }> } }> };

type MatchMoment_ChatMoment_Fragment = { __typename: 'ChatMoment', type: string, metadata?: Maybe<any>, id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } };

type MatchMoment_ManualSignalMoment_Fragment = { __typename: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } };

type MatchMoment_MultiPerspectiveMoment_Fragment = { __typename: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } };

type MatchMoment_ValorantMoment_Fragment = { __typename: 'ValorantMoment', id: string, startsAt: any, endsAt: any, agent: ValorantAgent, valorantTags: Array<ValorantMomentTag>, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }> };

export type MatchMomentFragment = MatchMoment_ChatMoment_Fragment | MatchMoment_ManualSignalMoment_Fragment | MatchMoment_MultiPerspectiveMoment_Fragment | MatchMoment_ValorantMoment_Fragment;

export type ValorantMatchSignalFragment = { __typename?: 'ValorantMoment', agent: ValorantAgent, valorantTags: Array<ValorantMomentTag>, kills: Array<{ __typename?: 'ValorantMatchRoundKill', victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }> };

export type UpdateMatchMomentCollectionMutationVariables = Exact<{
  momentCollectionId: Scalars['String'];
  momentCollectionInput?: Maybe<PartialMomentCollectionInput>;
}>;


export type UpdateMatchMomentCollectionMutation = { __typename?: 'Mutation', updateMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename: 'ChatMoment', id: string, type: string, metadata?: Maybe<any>, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename: 'ValorantMoment', id: string, startsAt: any, endsAt: any, agent: ValorantAgent, valorantTags: Array<ValorantMomentTag>, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }> }> } }> };

export type GetCampaignPreviewQueryVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type GetCampaignPreviewQuery = { __typename?: 'Query', campaign?: Maybe<{ __typename?: 'Campaign', id: string, slug?: Maybe<string>, title: string, start?: Maybe<any>, end?: Maybe<any>, channels?: Maybe<{ __typename?: 'ChannelCollection', id: string, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, profileImageUrl?: Maybe<string>, displayName?: Maybe<string> }> } }> }> };

export type CampaignPreviewFragment = { __typename?: 'Campaign', id: string, slug?: Maybe<string>, title: string, start?: Maybe<any>, end?: Maybe<any>, channels?: Maybe<{ __typename?: 'ChannelCollection', id: string, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, profileImageUrl?: Maybe<string>, displayName?: Maybe<string> }> } }> };

export type GetCampaignMomentsQueryVariables = Exact<{
  slug: Scalars['String'];
  channelIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  timeframe?: Maybe<TimeRangeFilterInput>;
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetCampaignMomentsQuery = { __typename?: 'Query', campaign?: Maybe<{ __typename?: 'Campaign', id: string, moments?: Maybe<{ __typename?: 'GroupedMomentConnection', data: Array<{ __typename?: 'GroupedMoment', moment: { __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string } }> }> }> };

export type GetMomentCollectionDetailQueryVariables = Exact<{
  id: Scalars['String'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetMomentCollectionDetailQuery = { __typename?: 'Query', momentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> } | { __typename?: 'ManualSignalMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> } | { __typename?: 'ValorantMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> }> } }> };

type MomentCollectionGridItem_ChatMoment_Fragment = { __typename?: 'ChatMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> };

type MomentCollectionGridItem_ManualSignalMoment_Fragment = { __typename?: 'ManualSignalMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> };

type MomentCollectionGridItem_MultiPerspectiveMoment_Fragment = { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> };

type MomentCollectionGridItem_ValorantMoment_Fragment = { __typename?: 'ValorantMoment', id: string, published: boolean, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> };

export type MomentCollectionGridItemFragment = MomentCollectionGridItem_ChatMoment_Fragment | MomentCollectionGridItem_ManualSignalMoment_Fragment | MomentCollectionGridItem_MultiPerspectiveMoment_Fragment | MomentCollectionGridItem_ValorantMoment_Fragment;

export type GetMomentCollectionIdsQueryVariables = Exact<{
  id: Scalars['String'];
  first: Scalars['Int'];
}>;


export type GetMomentCollectionIdsQuery = { __typename?: 'Query', momentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type GetOrganizationCollectionsListQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetOrganizationCollectionsListQuery = { __typename?: 'Query', organization?: Maybe<{ __typename?: 'Organization', id: string, collections: { __typename?: 'MomentCollectionConnection', data: Array<{ __typename?: 'MomentCollection', id: string, title: string, slug: string, publicPassword: boolean }> } }> };

export type MomentCollectionShortFragment = { __typename?: 'MomentCollection', id: string, title: string, slug: string, publicPassword: boolean };

export type CreateEmptyMomentcollectionMutationVariables = Exact<{
  title: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
}>;


export type CreateEmptyMomentcollectionMutation = { __typename?: 'Mutation', createMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, slug: string, publicPassword: boolean }> };

export type GetValorantMatchesForVideoQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetValorantMatchesForVideoQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, type: ValorantMatchType, startedAt: any, endedAt?: Maybe<any> }> }> };

export type GetValorantMatchesForVideoWithUserInfoQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetValorantMatchesForVideoWithUserInfoQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', puuid: string }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, type: ValorantMatchType, startedAt: any, endedAt?: Maybe<any> }> }> };

export type GetEditingVideoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEditingVideoQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any>, gamesPlayed: Array<{ __typename?: 'GamePlayed', startedAt: any, game: { __typename?: 'Game', id: string, name: string } }> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', startsAt: any, endsAt: any, id: string, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any>, type: string, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> }> } | { __typename?: 'ManualSignalMoment', startsAt: any, endsAt: any } | { __typename?: 'MultiPerspectiveMoment', startsAt: any, endsAt: any, id: string, title?: Maybe<string>, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> } | { __typename?: 'ValorantMoment', startsAt: any, endsAt: any }> }, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }>, reasons: Array<{ __typename?: 'CustomReason', reason: string } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }> }> }>, vod: Array<{ __typename?: 'RecordingVideo', url: string, resolution: string }> }> };

export type RelatedVideoFragment = { __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }>, reasons: Array<{ __typename?: 'CustomReason', reason: string } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }> }> };

export type RelatedTwitchVideoFragment = { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> };

export type TwitchEditingVideoFragment = { __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any>, gamesPlayed: Array<{ __typename?: 'GamePlayed', startedAt: any, game: { __typename?: 'Game', id: string, name: string } }> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', startsAt: any, endsAt: any, id: string, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any>, type: string, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> }> } | { __typename?: 'ManualSignalMoment', startsAt: any, endsAt: any } | { __typename?: 'MultiPerspectiveMoment', startsAt: any, endsAt: any, id: string, title?: Maybe<string>, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> } | { __typename?: 'ValorantMoment', startsAt: any, endsAt: any }> }, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }>, reasons: Array<{ __typename?: 'CustomReason', reason: string } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }> }> }>, vod: Array<{ __typename?: 'RecordingVideo', url: string, resolution: string }> };

export type VideoEditingStreamFragment = { __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any>, gamesPlayed: Array<{ __typename?: 'GamePlayed', startedAt: any, game: { __typename?: 'Game', id: string, name: string } }> };

export type GetEditingVideosQueryVariables = Exact<{
  videoIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEditingVideosQuery = { __typename?: 'Query', videos?: Maybe<{ __typename?: 'MixedVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any>, gamesPlayed: Array<{ __typename?: 'GamePlayed', startedAt: any, game: { __typename?: 'Game', id: string, name: string } }> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', startsAt: any, endsAt: any, id: string, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any>, type: string, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> }> } | { __typename?: 'ManualSignalMoment', startsAt: any, endsAt: any } | { __typename?: 'MultiPerspectiveMoment', startsAt: any, endsAt: any, id: string, title?: Maybe<string>, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> } | { __typename?: 'ValorantMoment', startsAt: any, endsAt: any }> }, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }>, reasons: Array<{ __typename?: 'CustomReason', reason: string } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }> }> }>, vod: Array<{ __typename?: 'RecordingVideo', url: string, resolution: string }> }> }> };

export type ChatMomentFragment = { __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any>, type: string, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> }> };

export type MultiMomentFragment = { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, published: boolean, publishedAt?: Maybe<any>, metadata?: Maybe<any> };

export type VideoDetailUserFragment = { __typename?: 'TwitchUser', id: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> };

export type CreateMultiPerspectiveMomentMutationVariables = Exact<{
  createMultiPerspectiveMomentInput: MultiPerspectiveMomentInput;
}>;


export type CreateMultiPerspectiveMomentMutation = { __typename?: 'Mutation', createMultiPerspectiveMoment?: Maybe<{ __typename?: 'MultiPerspectiveMoment', id: string }> };

export type GetVideoPlayerDataQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetVideoPlayerDataQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, vod: Array<{ __typename?: 'RecordingVideo', resolution: string, url: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any }> }> };

export type GetValorantDataForVideoQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetValorantDataForVideoQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', displayName?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string }> }>, relatedVideos: Array<{ __typename?: 'RelatedVideo', reasons: Array<{ __typename?: 'CustomReason' } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, type: ValorantMatchType, startedAt: any, roundResults: Array<{ __typename?: 'ValorantRoundResult', winningTeam?: Maybe<ValorantMatchTeam>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, tagLine?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, killer?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }>>> }>>> }> }> }> }> }> };

export type LinkRiotAccountMutationVariables = Exact<{
  channelId: Scalars['String'];
  riotId: Scalars['String'];
}>;


export type LinkRiotAccountMutation = { __typename?: 'Mutation', linkAccountToChannel: boolean };

export type GetEditPlayerQueryVariables = Exact<{
  editId: Scalars['String'];
}>;


export type GetEditPlayerQuery = { __typename?: 'Query', momentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> };

export type GetValorantMatchScoreboardQueryVariables = Exact<{
  matchId: Scalars['String'];
  matchStart: Scalars['Date'];
  matchEnd: Scalars['Date'];
}>;


export type GetValorantMatchScoreboardQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, team?: Maybe<ValorantMatchTeam>, stats?: Maybe<any>, tagLine?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, streams: { __typename?: 'TwitchStreamConnection', data: Array<{ __typename?: 'TwitchStream', video?: Maybe<{ __typename?: 'TwitchVideo', id: string }> }> } }> } }> }> };

export type CreateNewCollectionMutationVariables = Exact<{
  title: Scalars['String'];
  momentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateNewCollectionMutation = { __typename?: 'Mutation', createMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type GetMyMomentCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMomentCollectionsQuery = { __typename?: 'Query', momentCollections: { __typename?: 'MomentCollectionConnection', data: Array<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> } };

export type MomentCollectionFragment = { __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } };

export type UpdateMomentsInCollectionMutationVariables = Exact<{
  nextMomentIds: Array<Scalars['String']> | Scalars['String'];
  collectionId: Scalars['String'];
}>;


export type UpdateMomentsInCollectionMutation = { __typename?: 'Mutation', updateMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type GetMomentCollectionQueryVariables = Exact<{
  momentCollectionId?: Maybe<Scalars['String']>;
  organizationSlug?: Maybe<Scalars['String']>;
  momentCollectionSlug?: Maybe<Scalars['String']>;
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetMomentCollectionQuery = { __typename?: 'Query', momentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type UpdateMomentCollectionMutationVariables = Exact<{
  momentCollectionId: Scalars['String'];
  momentCollectionInput?: Maybe<PartialMomentCollectionInput>;
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateMomentCollectionMutation = { __typename?: 'Mutation', updateMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type GetVideoMomentsQueryVariables = Exact<{
  videoId: Scalars['String'];
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetVideoMomentsQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type PreviewMomentFragment = { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> };

export type SimplePreviewMomentFragment = { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> };

export type PreviewEditFragment = { __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> };

export type PreviewExportFragment = { __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> };

export type PreviewVideoFragment = { __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> };

export type GetMomentForViewerQueryVariables = Exact<{
  momentId: Scalars['String'];
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetMomentForViewerQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string }> };

export type SetMomentReadMutationVariables = Exact<{
  momentId: Scalars['String'];
}>;


export type SetMomentReadMutation = { __typename?: 'Mutation', setIsRead?: Maybe<boolean> };

export type SetEditApprovalMutationVariables = Exact<{
  editId: Scalars['String'];
  nextApproval: Scalars['Boolean'];
}>;


export type SetEditApprovalMutation = { __typename?: 'Mutation', updateMomentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, approved: boolean }> };

export type SearchResultFragment = { __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform };

export type GetSearchResultsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GetSearchResultsQuery = { __typename?: 'Query', channels?: Maybe<{ __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform }> }> };

export type GetRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionQuery = { __typename?: 'Query', viewer?: Maybe<{ __typename?: 'MmntsUser', id: string, settings?: Maybe<{ __typename?: 'UserSettings', region: { __typename?: 'RegionSetting', value: Region } }> }> };

export type UpdateRegionMutationVariables = Exact<{
  region: Region;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateUserSettings?: Maybe<{ __typename?: 'UserSettings', region: { __typename?: 'RegionSetting', value: Region } }> };

export type GetPostBuyMomentEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPostBuyMomentEditQuery = { __typename?: 'Query', momentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, updatedAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', url: string, resolution: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }>, moment: { __typename?: 'ChatMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } }> };

export type PostBuyEditFragment = { __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, updatedAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', url: string, resolution: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }>, moment: { __typename?: 'ChatMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> } } };

export type GetVideoChatMomentsQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetVideoChatMomentsQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string> }>, vod: Array<{ __typename?: 'RecordingVideo', url: string, resolution: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, thumbnailUrl?: Maybe<string>, startedAt: any, endedAt?: Maybe<any>, allowedChatMomentTypes: Array<string> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any> } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type DebugChatMomentFragment = { __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any> };

export type ChatMessageFragment = { __typename?: 'ChatMessage', id: string, text: string, timestamp: any, matching: Array<string>, shouldBeMatching?: Maybe<Array<string>> };

export type GetChannelChatQueryVariables = Exact<{
  providerId: Scalars['String'];
  from: Scalars['Date'];
  to: Scalars['Date'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetChannelChatQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', platform: StreamingPlatform, id: string, chatMessages: { __typename?: 'ChatMessageConnection', pagination: { __typename?: 'Pagination', endCursor: string, hasNextPage: boolean }, data: Array<{ __typename?: 'ChatMessage', id: string, text: string, timestamp: any, matching: Array<string>, shouldBeMatching?: Maybe<Array<string>> }> } }> };

export type UpdateChatMessageShouldBeMatchingMutationVariables = Exact<{
  id: Scalars['String'];
  matching?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateChatMessageShouldBeMatchingMutation = { __typename?: 'Mutation', setChatMessageShouldBeMatching?: Maybe<{ __typename?: 'ChatMessage', id: string, text: string, timestamp: any, matching: Array<string>, shouldBeMatching?: Maybe<Array<string>> }> };

export type GetOrganzationCampaignDetailsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetOrganzationCampaignDetailsQuery = { __typename?: 'Query', organization?: Maybe<{ __typename?: 'Organization', id: string, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, slug?: Maybe<string>, channelCampaignSegments: Array<{ __typename?: 'ChannelCampaignSegments', channel: { __typename?: 'TwitchUser', id: string, name: string }, segments: Array<{ __typename?: 'Timerange', from: any, to: any }> }> }> }> };

export type GetSpecificChatMomentsMutationVariables = Exact<{
  channelId: Scalars['String'];
  input: AnalyzeChannelInput;
  dryRun: Scalars['Boolean'];
}>;


export type GetSpecificChatMomentsMutation = { __typename?: 'Mutation', analyzeChannel: Array<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any> } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> };

export type CreateManualSignalMutationVariables = Exact<{
  input: ManualSignalInput;
}>;


export type CreateManualSignalMutation = { __typename?: 'Mutation', createManualSignal?: Maybe<{ __typename?: 'ManualSignalMoment', id: string }> };

export type GetValorantMatchesByVideoIdQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetValorantMatchesByVideoIdQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', user?: Maybe<{ __typename?: 'TwitchUser', linkedAccounts: Array<{ __typename?: 'RiotAccount', puuid: string }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType }>, relatedVideos: Array<{ __typename?: 'RelatedVideo', video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', displayName?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', puuid: string }> }> }, reasons: Array<{ __typename?: 'CustomReason' } | { __typename?: 'PlayedInValorantMatches', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string }> }> }> }> };

export type GetValorantMatchDetailsQueryVariables = Exact<{
  valorantMatchId: Scalars['String'];
}>;


export type GetValorantMatchDetailsQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, players: Array<{ __typename?: 'ValorantMatchPlayer', agent?: Maybe<ValorantAgent>, gameName?: Maybe<string>, stats?: Maybe<any>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string } }> }> };

export type GetValorantMatchByRoundsQueryVariables = Exact<{
  valorantMatchId: Scalars['String'];
}>;


export type GetValorantMatchByRoundsQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> }> };

export type GetRelatedVideoDataQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetRelatedVideoDataQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }> }> };

export type SimpleRelatedVideoInfoFragment = { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> };

export type GetVideosInfoQueryVariables = Exact<{
  videoIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetVideosInfoQuery = { __typename?: 'Query', videos?: Maybe<{ __typename?: 'MixedVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }> }> };

export type GetSignalPlayerVideoTimelineQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetSignalPlayerVideoTimelineQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any> } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> } }> };

export type GetMomentPreviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMomentPreviewQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', metadata?: Maybe<any>, id: string, title?: Maybe<string>, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }> } } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }> } } | { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }> } } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string }>, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }> } }> };

export type SignalRelatedVideoFragment = { __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> };

export type SignalReviewVideoFragment = { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> };

export type ConnectedMomentFragment = { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> };

type ReactionSignalDetail_ChatMoment_Fragment = { __typename?: 'ChatMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

type ReactionSignalDetail_ManualSignalMoment_Fragment = { __typename?: 'ManualSignalMoment', id: string };

type ReactionSignalDetail_MultiPerspectiveMoment_Fragment = { __typename?: 'MultiPerspectiveMoment', id: string };

type ReactionSignalDetail_ValorantMoment_Fragment = { __typename?: 'ValorantMoment', id: string };

export type ReactionSignalDetailFragment = ReactionSignalDetail_ChatMoment_Fragment | ReactionSignalDetail_ManualSignalMoment_Fragment | ReactionSignalDetail_MultiPerspectiveMoment_Fragment | ReactionSignalDetail_ValorantMoment_Fragment;

type ManualSignalDetail_ChatMoment_Fragment = { __typename?: 'ChatMoment', id: string };

type ManualSignalDetail_ManualSignalMoment_Fragment = { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

type ManualSignalDetail_MultiPerspectiveMoment_Fragment = { __typename?: 'MultiPerspectiveMoment', id: string };

type ManualSignalDetail_ValorantMoment_Fragment = { __typename?: 'ValorantMoment', id: string };

export type ManualSignalDetailFragment = ManualSignalDetail_ChatMoment_Fragment | ManualSignalDetail_ManualSignalMoment_Fragment | ManualSignalDetail_MultiPerspectiveMoment_Fragment | ManualSignalDetail_ValorantMoment_Fragment;

export type ValorantRoundKillFragment = { __typename?: 'ValorantMatchRoundKill', finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageItem?: Maybe<string>, damageType?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> };

type ValorantSignalDetail_ChatMoment_Fragment = { __typename?: 'ChatMoment', id: string };

type ValorantSignalDetail_ManualSignalMoment_Fragment = { __typename?: 'ManualSignalMoment', id: string };

type ValorantSignalDetail_MultiPerspectiveMoment_Fragment = { __typename?: 'MultiPerspectiveMoment', id: string };

type ValorantSignalDetail_ValorantMoment_Fragment = { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, match: { __typename?: 'ValorantMatch', id: string, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }, channel: { __typename?: 'TwitchUser', id: string }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageItem?: Maybe<string>, damageType?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }>, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

export type ValorantSignalDetailFragment = ValorantSignalDetail_ChatMoment_Fragment | ValorantSignalDetail_ManualSignalMoment_Fragment | ValorantSignalDetail_MultiPerspectiveMoment_Fragment | ValorantSignalDetail_ValorantMoment_Fragment;

export type GetSignalDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSignalDetailQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, match: { __typename?: 'ValorantMatch', id: string, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }, channel: { __typename?: 'TwitchUser', id: string }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageItem?: Maybe<string>, damageType?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }>, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> }> };

export type SetMomentRatingMutationVariables = Exact<{
  momentId: Scalars['String'];
  rating: Rating;
}>;


export type SetMomentRatingMutation = { __typename?: 'Mutation', rateMoment?: Maybe<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> };

export type CreateMultiPerspectiveMomentFromReactionSignalMutationVariables = Exact<{
  createMultiPerspectiveMomentInput: MultiPerspectiveMomentInput;
}>;


export type CreateMultiPerspectiveMomentFromReactionSignalMutation = { __typename?: 'Mutation', createMultiPerspectiveMoment?: Maybe<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, signals: Array<{ __typename?: 'ChatMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, match: { __typename?: 'ValorantMatch', id: string, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }, channel: { __typename?: 'TwitchUser', id: string }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageItem?: Maybe<string>, damageType?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }>, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> }>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

export type UpdateMultiPerspectiveMomentFromReactionSignalMutationVariables = Exact<{
  momentId: Scalars['String'];
  updateMultiPerspectiveMomentInput: PartialMultiPerspectiveMomentInput;
}>;


export type UpdateMultiPerspectiveMomentFromReactionSignalMutation = { __typename?: 'Mutation', updateMultiPerspectiveMoment?: Maybe<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, signals: Array<{ __typename?: 'ChatMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, channel: { __typename?: 'TwitchUser', id: string }, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, match: { __typename?: 'ValorantMatch', id: string, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }, channel: { __typename?: 'TwitchUser', id: string }, kills: Array<{ __typename?: 'ValorantMatchRoundKill', finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageItem?: Maybe<string>, damageType?: Maybe<string> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }> }>, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> }>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

export type GetConnectedMomentQueryVariables = Exact<{
  momentId: Scalars['String'];
}>;


export type GetConnectedMomentQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> } | { __typename?: 'ValorantMoment', id: string }> };

export type SetMultiPerspectiveMomentVideoOffsetMutationVariables = Exact<{
  fromVideoId: Scalars['String'];
  momentId: Scalars['String'];
  offsetsInput: OffsetsInput;
  toVideoId: Scalars['String'];
}>;


export type SetMultiPerspectiveMomentVideoOffsetMutation = { __typename?: 'Mutation', setMultiPerspectiveMomentVideoOffset?: Maybe<{ __typename?: 'MultiPerspectiveMoment', id: string }> };

export type MatchSyncFragmentFragment = { __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } };

export type GetValorantMatchSyncQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type GetValorantMatchSyncQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename: 'ValorantMatch', id: string, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> }> };

export type SetValorantMatchSyncMutationVariables = Exact<{
  matchId: Scalars['String'];
  videoId: Scalars['String'];
  matchStartTime: Scalars['Date'];
}>;


export type SetValorantMatchSyncMutation = { __typename?: 'Mutation', setValorantMatchVideoSync?: Maybe<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> };

export type DeleteValorantMatchSyncMutationVariables = Exact<{
  matchId: Scalars['String'];
  videoId: Scalars['String'];
}>;


export type DeleteValorantMatchSyncMutation = { __typename?: 'Mutation', deleteValorantMatchVideoSync?: Maybe<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> };

export type GetValorantMatchesByChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
  numVideos?: Maybe<Scalars['Int']>;
}>;


export type GetValorantMatchesByChannelQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', id: string, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, title: string, publishedAt: any, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }> }> } }> };

export type GetValorantMatchDetailsByChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
  numVideos?: Maybe<Scalars['Int']>;
}>;


export type GetValorantMatchDetailsByChannelQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', id: string, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> }> }> } }> };

export type GetValorantMatchDetailsByVideoQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetValorantMatchDetailsByVideoQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', user?: Maybe<{ __typename?: 'TwitchUser', linkedAccounts: Array<{ __typename?: 'RiotAccount', valorantUserInfo?: Maybe<{ __typename?: 'ValorantUserInfo', gameName?: Maybe<string>, tagLine?: Maybe<string> }> }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> }> }> };

export type GetValorantMatchPreviewQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type GetValorantMatchPreviewQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, map?: Maybe<ValorantMap>, winningTeam?: Maybe<ValorantMatchTeam>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, error?: Maybe<string>, video: { __typename?: 'TwitchVideo', id: string } }> }> };

export type ValorantMatchPreviewFragment = { __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, map?: Maybe<ValorantMap>, winningTeam?: Maybe<ValorantMatchTeam>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, error?: Maybe<string>, video: { __typename?: 'TwitchVideo', id: string } }> };

export type ValorantMatchPlayerPreviewFragment = { __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } };

export type GetValorantMatchPageDetailQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type GetValorantMatchPageDetailQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> }> };

export type ValorantMatchDetailFragment = { __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> };

export type ValorantRoundFragment = { __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> };

export type GetValorantMatchVideosQueryVariables = Exact<{
  matchId: Scalars['String'];
  matchStart: Scalars['Date'];
  matchEnd: Scalars['Date'];
}>;


export type GetValorantMatchVideosQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', players: Array<{ __typename?: 'ValorantMatchPlayer', account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, streams: { __typename?: 'TwitchStreamConnection', data: Array<{ __typename?: 'TwitchStream', id: string, startedAt: any, video?: Maybe<{ __typename?: 'TwitchVideo', id: string, mutedSegments?: Maybe<Array<{ __typename?: 'VideoSegment', duration: number, startsAt: number }>> }> }> } }> } }> }> };

export type GetValorantMatchDetailsByChannelCollectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
  timeframe: TimeRangeFilterInput;
}>;


export type GetValorantMatchDetailsByChannelCollectionQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, linkedAccounts: Array<{ __typename?: 'RiotAccount', valorantUserInfo?: Maybe<{ __typename?: 'ValorantUserInfo', gameName?: Maybe<string>, tagLine?: Maybe<string> }> }>, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, roundResults: Array<{ __typename?: 'ValorantRoundResult', roundNum?: Maybe<number>, roundResult?: Maybe<ValorantRoundResultType>, roundCeremony?: Maybe<ValorantRoundCeremony>, winningTeam?: Maybe<ValorantMatchTeam>, plantRoundTime?: Maybe<number>, plantSite?: Maybe<string>, defuseRoundTime?: Maybe<number>, bombPlanter?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, bombDefuser?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string> }>, playerStats?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchPlayerRoundStats', score?: Maybe<number>, player?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }>, kills?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundKill', timeSinceGameStartMillis?: Maybe<number>, timeSinceRoundStartMillis?: Maybe<number>, finishingDamage?: Maybe<{ __typename?: 'ValorantFinishingDamage', damageType?: Maybe<string>, damageItem?: Maybe<string>, isSecondaryFireMode?: Maybe<boolean> }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }>>>, damage?: Maybe<Array<Maybe<{ __typename?: 'ValorantMatchRoundDamage', damage?: Maybe<number>, receiver?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>>> }>>> }> }> }> } }> } }> };

export type GetLeaderBoardRankingsQueryVariables = Exact<{
  accountIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  before: Scalars['Date'];
}>;


export type GetLeaderBoardRankingsQuery = { __typename?: 'Query', valorantLeaderboard?: Maybe<{ __typename?: 'ValorantLeaderboardPlayerConnection', data: Array<{ __typename?: 'ValorantLeaderboardPlayer', leaderboardRank: number, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string }> }> }> }> };

export type GetLeaderBoardRankingsAfterQueryVariables = Exact<{
  accountIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  after: Scalars['Date'];
}>;


export type GetLeaderBoardRankingsAfterQuery = { __typename?: 'Query', valorantLeaderboard?: Maybe<{ __typename?: 'ValorantLeaderboardPlayerConnection', data: Array<{ __typename?: 'ValorantLeaderboardPlayer', leaderboardRank: number, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string }> }> }> }> };

export type GetVideoEditForAddonsQueryVariables = Exact<{
  editId: Scalars['String'];
}>;


export type GetVideoEditForAddonsQuery = { __typename?: 'Query', momentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', id: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, index: number, start: any, end: any, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>>, cropData: Array<{ __typename?: 'CropData', videoId: string, title: string, offset: number, muted: boolean }> }>, moment: { __typename?: 'ChatMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'ManualSignalMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'MultiPerspectiveMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'ValorantMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } }> };

export type GetVideoExportQueryVariables = Exact<{
  exportId: Scalars['String'];
}>;


export type GetVideoExportQuery = { __typename?: 'Query', videoExport?: Maybe<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, momentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', id: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, index: number, start: any, end: any, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }> }>, moment: { __typename?: 'ChatMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'ManualSignalMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'MultiPerspectiveMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } | { __typename?: 'ValorantMoment', id: string, video: { __typename?: 'TwitchVideo', id: string } } }> };

export type GetMomentsFromVideoSectionQueryVariables = Exact<{
  channelId: Scalars['String'];
  startTime: Scalars['Date'];
  endTime: Scalars['Date'];
}>;


export type GetMomentsFromVideoSectionQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, metadata?: Maybe<any> } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> }> };

export type GetAllChannelCollectionsQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetAllChannelCollectionsQuery = { __typename?: 'Query', channelCollections?: Maybe<{ __typename?: 'ChannelCollectionConnection', pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string }, data: Array<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string> }> }> };

export type ChannelCollectionRowFragment = { __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string> };

export type GetChannelCollectionChannelsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetChannelCollectionChannelsQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, viewCount?: Maybe<number> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } } }> };

export type ChannelCollectionDetailsFragment = { __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, viewCount?: Maybe<number> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } } };

export type ChannelRowPreviewFragment = { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, viewCount?: Maybe<number> };

export type UpdateChannelCollectionChannelsMutationVariables = Exact<{
  collectionId: Scalars['String'];
  channelIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateChannelCollectionChannelsMutation = { __typename?: 'Mutation', updateChannelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, viewCount?: Maybe<number> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } } }> };

export type UpdateChannelCollectionChannelsPreviewMutationVariables = Exact<{
  collectionId: Scalars['String'];
  channelIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateChannelCollectionChannelsPreviewMutation = { __typename?: 'Mutation', updateChannelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string }> } }> };

export type AdminSearchResultFragment = { __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform, dontJoinChat: boolean, autoSyncValorantMatches: boolean };

export type GetAdminSearchChannelQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetAdminSearchChannelQuery = { __typename?: 'Query', channels?: Maybe<{ __typename?: 'ChannelConnection', pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string, startCursor: string, hasPrevPage: boolean }, data: Array<{ __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform, dontJoinChat: boolean, autoSyncValorantMatches: boolean }> }> };

export type UpdateTwitchUserChatStatusMutationVariables = Exact<{
  id: Scalars['String'];
  dontJoinChat: Scalars['Boolean'];
}>;


export type UpdateTwitchUserChatStatusMutation = { __typename?: 'Mutation', updateTwitchUser?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform, dontJoinChat: boolean, autoSyncValorantMatches: boolean }> };

export type UpdateValorantSyncStatusMutationVariables = Exact<{
  id: Scalars['String'];
  autoSyncValorantMatches: Scalars['Boolean'];
}>;


export type UpdateValorantSyncStatusMutation = { __typename?: 'Mutation', updateTwitchUser?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform, dontJoinChat: boolean, autoSyncValorantMatches: boolean }> };

export type AdminTwitchUserSourceFragment = { __typename?: 'TwitchUserSource', id: string, name: string, views?: Maybe<number>, profilePictureUrl?: Maybe<string> };

export type GetTwitchUserSourceQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetTwitchUserSourceQuery = { __typename?: 'Query', twitchUserSourceByName?: Maybe<{ __typename?: 'TwitchUserSource', id: string, name: string, views?: Maybe<number>, profilePictureUrl?: Maybe<string> }> };

export type AddTwitchUserMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type AddTwitchUserMutation = { __typename?: 'Mutation', addTwitchUser?: Maybe<{ __typename?: 'TwitchUser', id: string, name: string, platform: StreamingPlatform, dontJoinChat: boolean, autoSyncValorantMatches: boolean }> };

export type ValorantLeaderboardPlayerFragment = { __typename?: 'ValorantLeaderboardPlayer', gameName?: Maybe<string>, tagLine?: Maybe<string>, rankedRating: number, numberOfWins: number, leaderboardRank: number, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }> };

export type GetValorantLeaderboardQueryVariables = Exact<{
  region: ValorantRegion;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetValorantLeaderboardQuery = { __typename?: 'Query', valorantLeaderboard?: Maybe<{ __typename?: 'ValorantLeaderboardPlayerConnection', data: Array<{ __typename?: 'ValorantLeaderboardPlayer', gameName?: Maybe<string>, tagLine?: Maybe<string>, rankedRating: number, numberOfWins: number, leaderboardRank: number, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

export type GetCurrentOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentOrganizationQuery = { __typename?: 'Query', viewer?: Maybe<{ __typename?: 'MmntsUser', id: string, organization?: Maybe<{ __typename?: 'Organization', id: string, slug: string, name: string, roster: { __typename?: 'TwitchUserConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, login?: Maybe<string> }> } }> }> };

export type RedeemBetaKeyMutationVariables = Exact<{
  betaKey: Scalars['String'];
}>;


export type RedeemBetaKeyMutation = { __typename?: 'Mutation', useBetaKey?: Maybe<{ __typename?: 'MmntsUser', id: string, organization?: Maybe<{ __typename?: 'Organization', id: string, name: string }> }> };

export type GetCampaignViewerQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCampaignViewerQuery = { __typename?: 'Query', campaign?: Maybe<{ __typename?: 'Campaign', id: string, title: string, slug?: Maybe<string>, channels?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string }> } }>, channelCampaignSegments: Array<{ __typename?: 'ChannelCampaignSegments', channel: { __typename?: 'TwitchUser', id: string }, segments: Array<{ __typename?: 'Timerange', to: any, from: any }> }>, segments?: Maybe<Array<{ __typename?: 'CampaignSegment', title?: Maybe<string>, starts: any, ends: any }>> }> };

export type GetCampaignViewerMomentsQueryVariables = Exact<{
  slug: Scalars['String'];
  channelIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  timeframe?: Maybe<TimeRangeFilterInput>;
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetCampaignViewerMomentsQuery = { __typename?: 'Query', campaign?: Maybe<{ __typename?: 'Campaign', id: string, moments?: Maybe<{ __typename?: 'GroupedMomentConnection', data: Array<{ __typename?: 'GroupedMoment', moment: { __typename?: 'ChatMoment', id: string, published: boolean } | { __typename?: 'ManualSignalMoment', id: string, published: boolean } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment', id: string, published: boolean } }> }> }> };

export type ChannelPreviewFragment = { __typename?: 'TwitchUser', id: string, profileImageUrl?: Maybe<string>, displayName?: Maybe<string> };

export type GetOrganizationCampaignsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetOrganizationCampaignsQuery = { __typename?: 'Query', organization?: Maybe<{ __typename?: 'Organization', id: string, campaigns: Array<{ __typename?: 'Campaign', id: string }> }> };

export type ChannelCollectionDetailQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type ChannelCollectionDetailQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> } }> };

export type GetChannelQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  platform: StreamingPlatform;
}>;


export type GetChannelQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', login?: Maybe<string>, displayName?: Maybe<string>, offlineImageUrl?: Maybe<string>, profileImageUrl?: Maybe<string>, viewCount?: Maybe<number>, id: string, name: string, linkedAccounts: Array<{ __typename: 'RiotAccount', id: string, valorantUserInfo?: Maybe<{ __typename?: 'ValorantUserInfo', gameName?: Maybe<string>, tagLine?: Maybe<string> }> }> }> };

export type GetChannelVideosQueryVariables = Exact<{
  channelId: Scalars['String'];
  platform: StreamingPlatform;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetChannelVideosQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', id: string, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, url?: Maybe<string>, thumbnailUrl?: Maybe<string>, title: string, publishedAt: any, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } } }> };

export type GetVideoDetailQueryVariables = Exact<{
  videoId: Scalars['String'];
}>;


export type GetVideoDetailQuery = { __typename?: 'Query', video?: Maybe<{ __typename?: 'TwitchVideo', id: string, url?: Maybe<string>, thumbnailUrl?: Maybe<string>, title: string, publishedAt: any, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }> };

export type GetMatchesQueryVariables = Exact<{
  accountIds: Array<Scalars['String']> | Scalars['String'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetMatchesQuery = { __typename?: 'Query', valorantMatches?: Maybe<{ __typename?: 'ValorantMatchConnection', data: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

export type GetMatchQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type GetMatchQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, map?: Maybe<ValorantMap> }> };

export type GetFeedSignalsQueryVariables = Exact<{
  includeValorant?: Maybe<Scalars['Boolean']>;
  includeChat?: Maybe<Scalars['Boolean']>;
  channelIds: Array<Scalars['String']> | Scalars['String'];
  minKills?: Maybe<Scalars['Int']>;
  reactionTypes?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  agents?: Maybe<Array<ValorantAgent> | ValorantAgent>;
  roundCeremony?: Maybe<ValorantRoundCeremony>;
  maps?: Maybe<Array<ValorantMap> | ValorantMap>;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  startsAt?: Maybe<TimeRangeFilterInput>;
  playersFilter?: Maybe<ValorantMomentPlayerFilter>;
  isUsed?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetFeedSignalsQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ValorantMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

export type GetSignalTypeQueryVariables = Exact<{
  signalId: Scalars['String'];
}>;


export type GetSignalTypeQuery = { __typename?: 'Query', moment?: Maybe<{ __typename: 'ChatMoment', id: string } | { __typename: 'ManualSignalMoment', id: string } | { __typename: 'MultiPerspectiveMoment', id: string } | { __typename: 'ValorantMoment', id: string }> };

export type SyncMatchVideoMutationVariables = Exact<{
  matchId: Scalars['String'];
  videoId: Scalars['String'];
}>;


export type SyncMatchVideoMutation = { __typename?: 'Mutation', createValorantMatchVideoSync: { __typename?: 'ValorantMatchVideoSync', status?: Maybe<ValorantMatchVideoSyncStatus>, error?: Maybe<string>, match: { __typename?: 'ValorantMatch', id: string }, video: { __typename?: 'TwitchVideo', id: string } } };

export type CollectionLoginMutationVariables = Exact<{
  organizationSlug: Scalars['String'];
  collectionSlug: Scalars['String'];
  password: Scalars['String'];
}>;


export type CollectionLoginMutation = { __typename?: 'Mutation', authenticateClient?: Maybe<{ __typename?: 'ClientToken', accessToken: string }> };

export type GetMomentCollectionBySlugQueryVariables = Exact<{
  organizationSlug: Scalars['String'];
  collectionSlug: Scalars['String'];
}>;


export type GetMomentCollectionBySlugQuery = { __typename?: 'Query', momentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string }> };

export type UpdatePartialMomentsInCollectionMutationVariables = Exact<{
  collectionId: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type UpdatePartialMomentsInCollectionMutation = { __typename?: 'Mutation', updateMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string, title: string, slug: string, publicPassword: boolean }> };

export type DeleteMomentCollectionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMomentCollectionMutation = { __typename?: 'Mutation', deleteMomentCollection?: Maybe<{ __typename?: 'MomentCollection', id: string }> };

export type GetEventCollectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type GetEventCollectionQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, streams: { __typename?: 'TwitchStreamConnection', data: Array<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any>, video?: Maybe<{ __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, reasons: Array<{ __typename?: 'CustomReason', reason: string } | { __typename?: 'PlayedInValorantMatches' }>, video: { __typename?: 'TwitchVideo', id: string } }> }> }> } }> } }> };

export type AddRelatedVideoMutationVariables = Exact<{
  primaryVideoId: Scalars['String'];
  secondaryVideoId: Scalars['String'];
  offset: Scalars['Float'];
  overlaps: Array<TimerangeInput> | TimerangeInput;
}>;


export type AddRelatedVideoMutation = { __typename?: 'Mutation', addRelatedVideo?: Maybe<{ __typename?: 'RelatedVideo', offset?: Maybe<number> }> };

export type UpdateRelatedVideoMutationVariables = Exact<{
  primaryVideoId: Scalars['String'];
  secondaryVideoId: Scalars['String'];
  offset: Scalars['Float'];
  overlaps: Array<TimerangeInput> | TimerangeInput;
}>;


export type UpdateRelatedVideoMutation = { __typename?: 'Mutation', updateRelatedVideo?: Maybe<{ __typename?: 'RelatedVideo', offset?: Maybe<number> }> };

export type GetContentFeedQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  rating?: Maybe<Rating>;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  startsAt?: Maybe<TimeRangeFilterInput>;
  sort?: Maybe<Sort>;
}>;


export type GetContentFeedQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ValorantMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

export type GetContentMomentDetailQueryVariables = Exact<{
  momentId: Scalars['String'];
}>;


export type GetContentMomentDetailQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment' } | { __typename?: 'ManualSignalMoment' } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, title?: Maybe<string>, channels: Array<{ __typename?: 'TwitchUser', id: string }>, edits: Array<{ __typename: 'MomentEdit', id: string }>, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, signals: Array<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string, combatScore: number, agent: ValorantAgent, startsAt: any, endsAt: any, isUnread: boolean, kills: Array<{ __typename: 'ValorantMatchRoundKill', killer?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, match: { __typename?: 'ValorantMatch', id: string, map?: Maybe<ValorantMap>, startedAt: any, endedAt?: Maybe<any>, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> }> } | { __typename?: 'ValorantMoment' }> };

export type GetMomentEditDetailsQueryVariables = Exact<{
  momentId: Scalars['String'];
  includeUnpublished?: Maybe<Scalars['Boolean']>;
  includeUnapproved?: Maybe<Scalars['Boolean']>;
}>;


export type GetMomentEditDetailsQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment' } | { __typename?: 'ManualSignalMoment' } | { __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, title?: Maybe<string>, startsAt: any, endsAt: any, isUnread: boolean, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, approved: boolean, published: boolean, publishedAt?: Maybe<any>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, createdAt: any, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, title: string, thumbnailUrl?: Maybe<string>, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }>, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }>, signals: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }>, channel: { __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }> } | { __typename?: 'ValorantMoment' }> };

export type ContentMomentFragment = { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, title?: Maybe<string>, channels: Array<{ __typename?: 'TwitchUser', id: string }>, edits: Array<{ __typename: 'MomentEdit', id: string }>, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, signals: Array<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string, combatScore: number, agent: ValorantAgent, startsAt: any, endsAt: any, isUnread: boolean, kills: Array<{ __typename: 'ValorantMatchRoundKill', killer?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, match: { __typename?: 'ValorantMatch', id: string, map?: Maybe<ValorantMap>, startedAt: any, endedAt?: Maybe<any>, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> }> };

export type FeedValorantMomentsQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  minKills?: Maybe<Scalars['Int']>;
  agents?: Maybe<Array<ValorantAgent> | ValorantAgent>;
  roundCeremony?: Maybe<ValorantRoundCeremony>;
  maps?: Maybe<Array<ValorantMap> | ValorantMap>;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Date']>;
  endedAt?: Maybe<Scalars['Date']>;
  startsAt?: Maybe<TimeRangeFilterInput>;
  playersFilter?: Maybe<ValorantMomentPlayerFilter>;
  isUsed?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FeedValorantMomentsQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ValorantMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

type FeedPreview_ChatMoment_Fragment = { __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } };

type FeedPreview_ManualSignalMoment_Fragment = { __typename?: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } };

type FeedPreview_MultiPerspectiveMoment_Fragment = { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } };

type FeedPreview_ValorantMoment_Fragment = { __typename?: 'ValorantMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } };

export type FeedPreviewFragment = FeedPreview_ChatMoment_Fragment | FeedPreview_ManualSignalMoment_Fragment | FeedPreview_MultiPerspectiveMoment_Fragment | FeedPreview_ValorantMoment_Fragment;

export type FeedValorantMomentMatchFragment = { __typename?: 'ValorantMatch', id: string, map?: Maybe<ValorantMap>, startedAt: any, endedAt?: Maybe<any>, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> };

export type FeedValorantMomentFragment = { __typename?: 'ValorantMoment', id: string, combatScore: number, agent: ValorantAgent, startsAt: any, endsAt: any, isUnread: boolean, kills: Array<{ __typename: 'ValorantMatchRoundKill', killer?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, match: { __typename?: 'ValorantMatch', id: string, map?: Maybe<ValorantMap>, startedAt: any, endedAt?: Maybe<any>, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> };

export type GetFeedValorantSignalQueryVariables = Exact<{
  signalId: Scalars['String'];
}>;


export type GetFeedValorantSignalQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment' } | { __typename?: 'ManualSignalMoment' } | { __typename?: 'MultiPerspectiveMoment' } | { __typename?: 'ValorantMoment', id: string, combatScore: number, agent: ValorantAgent, startsAt: any, endsAt: any, isUnread: boolean, kills: Array<{ __typename: 'ValorantMatchRoundKill', killer?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }>, victim?: Maybe<{ __typename?: 'RiotAccountInValorantMatch', account: { __typename?: 'RiotAccount', id: string } }> }>, channel: { __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, startedAt: any, endedAt?: Maybe<any> }> }, match: { __typename?: 'ValorantMatch', id: string, map?: Maybe<ValorantMap>, startedAt: any, endedAt?: Maybe<any>, videoSyncData: Array<{ __typename: 'ValorantMatchVideoSync', matchStartTime: any, error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, match: { __typename: 'ValorantMatch', id: string }, video: { __typename: 'TwitchVideo', id: string } }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, ratings: Array<{ __typename?: 'UserRating', rating: Rating }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> }> };

export type GetChannelCollectionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChannelCollectionQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string }> } }> };

export type GetChannelCollectionsQueryVariables = Exact<{
  first: Scalars['Int'];
  collectionIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetChannelCollectionsQuery = { __typename?: 'Query', channelCollections?: Maybe<{ __typename?: 'ChannelCollectionConnection', data: Array<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string }> } }> }> };

export type ChannelCollectionPreviewFragment = { __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string }> } };

export type ReactionDetailFragment = { __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string }> };

export type ReactionFeedDetailFragment = { __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> };

export type ManualFeedDetailFragment = { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> };

export type GetReactionFeedQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  types?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  first: Scalars['Int'];
  startsAt?: Maybe<TimeRangeFilterInput>;
  after?: Maybe<Scalars['String']>;
  sort?: Maybe<Sort>;
}>;


export type GetReactionFeedQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ManualSignalMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } } | { __typename?: 'ValorantMoment', id: string, startsAt: any, endsAt: any, video: { __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> } }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } }> };

export type GetReactionSignalQueryVariables = Exact<{
  signalId: Scalars['String'];
}>;


export type GetReactionSignalQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }> }> } | { __typename?: 'ManualSignalMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, type: string, metadata?: Maybe<any>, isUnread: boolean, video: { __typename?: 'TwitchVideo', id: string, relatedVideos: Array<{ __typename?: 'RelatedVideo', offset?: Maybe<number>, video: { __typename?: 'TwitchVideo', id: string }, overlaps: Array<{ __typename?: 'Timerange', from: any, to: any }> }>, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, type: ValorantMatchType, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', error?: Maybe<string>, status?: Maybe<ValorantMatchVideoSyncStatus>, matchStartTime: any, video: { __typename?: 'TwitchVideo', id: string } }> }> }, channel: { __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, linkedAccounts: Array<{ __typename?: 'RiotAccount', id: string, puuid: string }> }, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string, title?: Maybe<string>, startsAt: any, endsAt: any, tags: Array<string>, ratings: Array<{ __typename?: 'UserRating', rating: Rating, user: { __typename?: 'MmntsUser', id: string } }>, edits: Array<{ __typename?: 'MomentEdit', id: string, format: { __typename?: 'Format', aspectRatio: { __typename?: 'AspectRatio', width: number, height: number } } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string }> }> } | { __typename?: 'MultiPerspectiveMoment' } | { __typename?: 'ValorantMoment' }> };

export type GetChannelCollectionChatMomentsQueryVariables = Exact<{
  collectionId: Scalars['String'];
  timerange?: Maybe<TimeRangeFilterInput>;
}>;


export type GetChannelCollectionChatMomentsQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, title: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, valorantMatches: Array<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any> }>, moments: { __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', id: string, type: string, startsAt: any, endsAt: any, metadata?: Maybe<any>, isUnread: boolean, usedIn: Array<{ __typename?: 'MultiPerspectiveMoment', id: string }> } | { __typename?: 'ManualSignalMoment' } | { __typename?: 'MultiPerspectiveMoment' } | { __typename?: 'ValorantMoment' }> } }> } }> } }> };

export type GetMomentThumbnailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMomentThumbnailQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string, thumbnail?: Maybe<string> } | { __typename?: 'ManualSignalMoment', id: string, thumbnail?: Maybe<string> } | { __typename?: 'MultiPerspectiveMoment', id: string, thumbnail?: Maybe<string> } | { __typename?: 'ValorantMoment', id: string, thumbnail?: Maybe<string> }> };

export type GetVideosWithGameSectionsQueryVariables = Exact<{
  channelId: Scalars['String'];
  startTime: Scalars['Date'];
  endTime: Scalars['Date'];
}>;


export type GetVideosWithGameSectionsQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string, streams: { __typename?: 'TwitchStreamConnection', data: Array<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any>, id: string, gamesPlayed: Array<{ __typename?: 'GamePlayed', startedAt: any, game: { __typename?: 'Game', id: string } }>, video?: Maybe<{ __typename?: 'TwitchVideo', id: string }> }> } }> };

export type GetMomentDetailQueryVariables = Exact<{
  momentId: Scalars['String'];
}>;


export type GetMomentDetailQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment' } | { __typename?: 'ManualSignalMoment' } | { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, title?: Maybe<string>, published: boolean, publishedAt?: Maybe<any>, mainVideo: { __typename?: 'TwitchVideo', id: string }, offsets: Array<{ __typename?: 'VideoWithOffsets', fromVideo: { __typename?: 'TwitchVideo', id: string }, toVideo: { __typename?: 'TwitchVideo', id: string }, offsets: { __typename?: 'Offsets', audioOffset: number, videoOffset: number } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }>, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> } | { __typename?: 'ValorantMoment' }> };

export type VideoOffsetFragment = { __typename?: 'VideoWithOffsets', fromVideo: { __typename?: 'TwitchVideo', id: string }, toVideo: { __typename?: 'TwitchVideo', id: string }, offsets: { __typename?: 'Offsets', audioOffset: number, videoOffset: number } };

export type MultiPerspectiveMomentDetailFragment = { __typename?: 'MultiPerspectiveMoment', id: string, startsAt: any, endsAt: any, title?: Maybe<string>, published: boolean, publishedAt?: Maybe<any>, mainVideo: { __typename?: 'TwitchVideo', id: string }, offsets: Array<{ __typename?: 'VideoWithOffsets', fromVideo: { __typename?: 'TwitchVideo', id: string }, toVideo: { __typename?: 'TwitchVideo', id: string }, offsets: { __typename?: 'Offsets', audioOffset: number, videoOffset: number } }>, videos: Array<{ __typename?: 'TwitchVideo', id: string, user?: Maybe<{ __typename?: 'TwitchUser', id: string, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> }>, edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> };

export type MomentExportFragment = { __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> };

export type MomentEditFragment = { __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> };

export type TemplateCropFragment = { __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } };

export type TemplateFragment = { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> };

export type RectFragment = { __typename?: 'Rect', x: any, y: any, width: any, height: any };

export type AspectRatioFragment = { __typename?: 'AspectRatio', width: number, height: number };

export type CropDataFragment = { __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } };

export type SceneFragment = { __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> };

export type FormatFragment = { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> };

export type AddEditToMomentMutationVariables = Exact<{
  editInput: MomentEditInput;
  momentId: Scalars['String'];
}>;


export type AddEditToMomentMutation = { __typename?: 'Mutation', addMomentEditToMoment?: Maybe<{ __typename?: 'MomentEdit', id: string, moment: { __typename?: 'ChatMoment', edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> } | { __typename?: 'ManualSignalMoment', edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> } | { __typename?: 'MultiPerspectiveMoment', edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> } | { __typename?: 'ValorantMoment', edits: Array<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, published: boolean, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }>, exports: Array<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>>, videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>> }> }> }> } }> };

export type ExportMomentEditMutationVariables = Exact<{
  exportMomentEdit: MomentEditInput;
  exportMomentId: Scalars['String'];
}>;


export type ExportMomentEditMutation = { __typename?: 'Mutation', exportMoment?: Maybe<{ __typename?: 'VideoExport', id: string, status: RecordingStatus, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> };

export type ExportEditMutationVariables = Exact<{
  editId: Scalars['String'];
}>;


export type ExportEditMutation = { __typename?: 'Mutation', exportEdit?: Maybe<{ __typename?: 'VideoExport', status: RecordingStatus }> };

export type UpdateMomentEditMutationVariables = Exact<{
  editId: Scalars['String'];
  editInput: PartialMomentEditInput;
}>;


export type UpdateMomentEditMutation = { __typename?: 'Mutation', updateMomentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string }> };

export type GetMomentEditQueryVariables = Exact<{
  editId: Scalars['String'];
}>;


export type GetMomentEditQuery = { __typename?: 'Query', momentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, title?: Maybe<string>, format: { __typename?: 'Format', id: string, title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, templates: Array<{ __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }> }, scenes: Array<{ __typename?: 'Scene', id: string, start: any, end: any, index: number, cropData: Array<{ __typename?: 'CropData', title: string, videoId: string, offset: number, muted: boolean, cropRect: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }>, template: { __typename?: 'Template', title: string, crops: Array<{ __typename?: 'Crop', title: string, aspectRatio: { __typename?: 'AspectRatio', width: number, height: number }, position: { __typename?: 'Rect', x: any, y: any, width: any, height: any } }> }, overlays?: Maybe<Array<{ __typename?: 'Overlay', overlayType: OverlayType, data: any }>> }> }> };

export type AddSceneMutationVariables = Exact<{
  editId: Scalars['String'];
  sceneInput: SceneInput;
}>;


export type AddSceneMutation = { __typename?: 'Mutation', addSceneToMomentEdit?: Maybe<{ __typename?: 'Scene', id: string }> };

export type UpdateSceneMutationVariables = Exact<{
  sceneId: Scalars['String'];
  sceneInput: PartialSceneInput;
}>;


export type UpdateSceneMutation = { __typename?: 'Mutation', updateScene?: Maybe<{ __typename?: 'Scene', id: string }> };

export type RemoveSceneMutationVariables = Exact<{
  sceneId: Scalars['String'];
}>;


export type RemoveSceneMutation = { __typename?: 'Mutation', removeScene?: Maybe<{ __typename?: 'Scene', id: string }> };

export type SetMomentPublishedMutationVariables = Exact<{
  momentId: Scalars['String'];
  nextPublishStatus: Scalars['Boolean'];
}>;


export type SetMomentPublishedMutation = { __typename?: 'Mutation', updateMultiPerspectiveMoment?: Maybe<{ __typename?: 'MultiPerspectiveMoment', id: string, published: boolean, publishedAt?: Maybe<any> }> };

export type SetMomentEditPublishedMutationVariables = Exact<{
  editId: Scalars['String'];
  nextPublishStatus: Scalars['Boolean'];
}>;


export type SetMomentEditPublishedMutation = { __typename?: 'Mutation', updateMomentEdit?: Maybe<{ __typename?: 'MomentEdit', id: string, published: boolean, publishedAt?: Maybe<any> }> };

export type GetUserOrganizationRosterQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetUserOrganizationRosterQuery = { __typename?: 'Query', viewer?: Maybe<{ __typename?: 'MmntsUser', id: string, organization?: Maybe<{ __typename?: 'Organization', id: string, roster: { __typename?: 'TwitchUserConnection', pagination: { __typename?: 'Pagination', endCursor: string, hasNextPage: boolean }, data: Array<{ __typename?: 'TwitchUser', id: string, name: string, profileImageUrl?: Maybe<string>, broadcasterType?: Maybe<string> }> } }> }> };

export type GetOrganizationBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetOrganizationBySlugQuery = { __typename?: 'Query', organization?: Maybe<{ __typename?: 'Organization', id: string, name: string, slug: string }> };

export type GetValorantLeaderboardSnapshotQueryVariables = Exact<{
  twitchUserIds: Array<Scalars['String']> | Scalars['String'];
  snapshotTime: Scalars['Date'];
}>;


export type GetValorantLeaderboardSnapshotQuery = { __typename?: 'Query', valorantLeaderboard?: Maybe<{ __typename?: 'ValorantLeaderboardPlayerConnection', data: Array<{ __typename?: 'ValorantLeaderboardPlayer', leaderboardRank: number, gameName?: Maybe<string>, numberOfWins: number, competitiveTier: ValorantCompetitiveTier, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }> }> }> }> };

export type LeaderboardPlayerFragment = { __typename?: 'ValorantLeaderboardPlayer', leaderboardRank: number, gameName?: Maybe<string>, numberOfWins: number, competitiveTier: ValorantCompetitiveTier, account?: Maybe<{ __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', profileImageUrl?: Maybe<string>, id: string, name: string }> }> };

export type GetTwitchVideosQueryVariables = Exact<{
  userId: Scalars['String'];
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type GetTwitchVideosQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', id: string, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, stream?: Maybe<{ __typename?: 'TwitchStream', startedAt: any, endedAt?: Maybe<any> }> }> } }> };

export type MatchDetailsFragment = { __typename?: 'ValorantMatch', id: string, winningTeam?: Maybe<ValorantMatchTeam>, type: ValorantMatchType, players: Array<{ __typename?: 'ValorantMatchPlayer', team?: Maybe<ValorantMatchTeam>, stats?: Maybe<any>, gameName?: Maybe<string>, agent?: Maybe<ValorantAgent> }> };

export type GetValorantMatchesQueryVariables = Exact<{
  playerAccountIds: Array<Scalars['String']> | Scalars['String'];
  start: Scalars['Date'];
  end: Scalars['Date'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetValorantMatchesQuery = { __typename?: 'Query', valorantMatches?: Maybe<{ __typename?: 'ValorantMatchConnection', pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string }, data: Array<{ __typename?: 'ValorantMatch', id: string, type: ValorantMatchType, startedAt: any, endedAt?: Maybe<any>, winningTeam?: Maybe<ValorantMatchTeam>, players: Array<{ __typename?: 'ValorantMatchPlayer', agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, team?: Maybe<ValorantMatchTeam>, gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> }> }> };

export type ValorantMatchDiscoveryPreviewFragment = { __typename?: 'ValorantMatch', id: string, type: ValorantMatchType, startedAt: any, endedAt?: Maybe<any>, winningTeam?: Maybe<ValorantMatchTeam>, players: Array<{ __typename?: 'ValorantMatchPlayer', agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, team?: Maybe<ValorantMatchTeam>, gameName?: Maybe<string>, account: { __typename?: 'RiotAccount', id: string } }> };

export type GetValorantMatchHighlightQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type GetValorantMatchHighlightQuery = { __typename?: 'Query', valorantMatch?: Maybe<{ __typename?: 'ValorantMatch', id: string, startedAt: any, endedAt?: Maybe<any>, map?: Maybe<ValorantMap>, videoSyncData: Array<{ __typename?: 'ValorantMatchVideoSync', matchStartTime: any, status?: Maybe<ValorantMatchVideoSyncStatus>, video: { __typename?: 'TwitchVideo', id: string } }>, players: Array<{ __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, id: string }> } }> }> };

export type ValorantMatchPlayerHighlightFragment = { __typename?: 'ValorantMatchPlayer', gameName?: Maybe<string>, agent?: Maybe<ValorantAgent>, stats?: Maybe<any>, competitiveTier?: Maybe<ValorantCompetitiveTier>, team?: Maybe<ValorantMatchTeam>, account: { __typename?: 'RiotAccount', id: string, channel?: Maybe<{ __typename?: 'TwitchUser', displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, id: string }> } };

export type GetLinkedAccountsFromChannelCollectionQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetLinkedAccountsFromChannelCollectionQuery = { __typename?: 'Query', channelCollection?: Maybe<{ __typename?: 'ChannelCollection', id: string, slug?: Maybe<string>, channels: { __typename?: 'ChannelConnection', data: Array<{ __typename?: 'TwitchUser', id: string, viewCount?: Maybe<number>, displayName?: Maybe<string>, linkedAccounts: Array<{ __typename: 'RiotAccount', id: string }> }> } }> };

export type GetCurrentOrganizationRosterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentOrganizationRosterQuery = { __typename?: 'Query', viewer?: Maybe<{ __typename?: 'MmntsUser', id: string, organization?: Maybe<{ __typename?: 'Organization', id: string, slug: string, name: string, roster: { __typename?: 'TwitchUserConnection', data: Array<{ __typename?: 'TwitchUser', id: string, name: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> }> } }> }> };

export type RosterPreviewUserFragment = { __typename?: 'TwitchUser', id: string, name: string, login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string> };

export type GetRecentMomentsQueryVariables = Exact<{
  channelIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetRecentMomentsQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', pagination: { __typename?: 'Pagination', hasNextPage: boolean }, data: Array<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, signals: Array<{ __typename: 'ChatMoment', id: string } | { __typename: 'ManualSignalMoment', id: string } | { __typename: 'MultiPerspectiveMoment', id: string } | { __typename: 'ValorantMoment', id: string }> } | { __typename?: 'ValorantMoment', id: string }> }> };

export type GetMomentVideoPreviewQueryVariables = Exact<{
  momentId: Scalars['String'];
}>;


export type GetMomentVideoPreviewQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'ChatMoment', id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string, edits: Array<{ __typename?: 'MomentEdit', id: string, exports: Array<{ __typename?: 'VideoExport', id: string, output?: Maybe<{ __typename?: 'RecordingOutput', videos?: Maybe<Array<Maybe<{ __typename?: 'RecordingVideo', resolution: string, url: string }>>>, thumbnails?: Maybe<Array<Maybe<{ __typename?: 'RecordingThumbnail', index: number, url: string }>>> }> }> }> } | { __typename?: 'ValorantMoment', id: string }> };

export type GetChannelInfoQueryVariables = Exact<{
  channelName: Scalars['String'];
}>;


export type GetChannelInfoQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', login?: Maybe<string>, displayName?: Maybe<string>, profileImageUrl?: Maybe<string>, id: string }> };

export type GetChatMomentsForVideoQueryVariables = Exact<{
  channelId: Scalars['String'];
  videoStart: Scalars['Date'];
  videoEnd: Scalars['Date'];
}>;


export type GetChatMomentsForVideoQuery = { __typename?: 'Query', moments?: Maybe<{ __typename?: 'MomentConnection', data: Array<{ __typename?: 'ChatMoment', metadata?: Maybe<any>, id: string } | { __typename?: 'ManualSignalMoment', id: string } | { __typename?: 'MultiPerspectiveMoment', id: string } | { __typename?: 'ValorantMoment', id: string }> }> };

export type GetRecentChannelVideosQueryVariables = Exact<{
  channelName: Scalars['String'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type GetRecentChannelVideosQuery = { __typename?: 'Query', channel?: Maybe<{ __typename?: 'TwitchUser', id: string, videos: { __typename?: 'TwitchVideoConnection', data: Array<{ __typename?: 'TwitchVideo', id: string, url?: Maybe<string>, thumbnailUrl?: Maybe<string>, title: string, publishedAt: any, stream?: Maybe<{ __typename?: 'TwitchStream', id: string, endedAt?: Maybe<any> }> }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, endCursor: string } } }> };

export const ValorantMatchSignalFragmentDoc = gql`
    fragment ValorantMatchSignal on ValorantMoment {
  agent
  kills {
    victim {
      gameName
    }
  }
  valorantTags
}
    `;
export const MatchMomentFragmentDoc = gql`
    fragment MatchMoment on Moment {
  id
  __typename
  startsAt
  endsAt
  video {
    id
  }
  channel {
    id
    ... on TwitchUser {
      id
      displayName
      profileImageUrl
    }
  }
  ... on ValorantMoment {
    ...ValorantMatchSignal
  }
  ... on ChatMoment {
    type
    metadata
  }
}
    ${ValorantMatchSignalFragmentDoc}`;
export const ChannelPreviewFragmentDoc = gql`
    fragment ChannelPreview on TwitchUser {
  id
  profileImageUrl
  displayName
}
    `;
export const CampaignPreviewFragmentDoc = gql`
    fragment CampaignPreview on Campaign {
  id
  slug
  title
  start
  end
  channels {
    id
    channels(first: 1000) {
      data {
        ...ChannelPreview
      }
    }
  }
}
    ${ChannelPreviewFragmentDoc}`;
export const PreviewExportFragmentDoc = gql`
    fragment PreviewExport on VideoExport {
  id
  status
  createdAt
  output {
    videos {
      resolution
      url
    }
    thumbnails {
      index
      url
    }
  }
}
    `;
export const PreviewEditFragmentDoc = gql`
    fragment PreviewEdit on MomentEdit {
  id
  title
  approved
  published
  publishedAt
  format {
    id
    title
    aspectRatio {
      width
      height
    }
  }
  scenes {
    id
    start
    end
  }
  exports(first: 100, orderBy: {createdAt: DESC}) {
    ...PreviewExport
  }
}
    ${PreviewExportFragmentDoc}`;
export const MomentCollectionGridItemFragmentDoc = gql`
    fragment MomentCollectionGridItem on Moment {
  id
  published
  title
  channel {
    id
    name
    ... on TwitchUser {
      profileImageUrl
    }
  }
  edits(
    first: 100
    orderBy: {createdAt: DESC}
    filterBy: {includeUnpublished: $includeUnpublished, includeUnapproved: $includeUnapproved}
  ) {
    ...PreviewEdit
  }
}
    ${PreviewEditFragmentDoc}`;
export const MomentCollectionShortFragmentDoc = gql`
    fragment MomentCollectionShort on MomentCollection {
  id
  title
  slug
  publicPassword
}
    `;
export const VideoDetailUserFragmentDoc = gql`
    fragment VideoDetailUser on TwitchUser {
  id
  login
  displayName
  profileImageUrl
}
    `;
export const VideoEditingStreamFragmentDoc = gql`
    fragment VideoEditingStream on TwitchStream {
  id
  startedAt
  endedAt
  gamesPlayed {
    game {
      id
      name
    }
    startedAt
  }
}
    `;
export const MultiMomentFragmentDoc = gql`
    fragment MultiMoment on MultiPerspectiveMoment {
  id
  title
  startsAt
  endsAt
  published
  publishedAt
  metadata
}
    `;
export const ChatMomentFragmentDoc = gql`
    fragment ChatMoment on ChatMoment {
  id
  startsAt
  endsAt
  published
  publishedAt
  metadata
  type
  usedIn {
    ...MultiMoment
  }
}
    ${MultiMomentFragmentDoc}`;
export const RelatedTwitchVideoFragmentDoc = gql`
    fragment RelatedTwitchVideo on TwitchVideo {
  id
  user {
    id
    displayName
    profileImageUrl
  }
}
    `;
export const RelatedVideoFragmentDoc = gql`
    fragment RelatedVideo on RelatedVideo {
  video {
    ...RelatedTwitchVideo
  }
  overlaps {
    from
    to
  }
  offset
  reasons {
    ... on PlayedInValorantMatches {
      valorantMatches {
        id
        startedAt
        endedAt
      }
    }
    ... on CustomReason {
      reason
    }
  }
}
    ${RelatedTwitchVideoFragmentDoc}`;
export const TwitchEditingVideoFragmentDoc = gql`
    fragment TwitchEditingVideo on TwitchVideo {
  id
  title
  thumbnailUrl
  user {
    ...VideoDetailUser
  }
  stream {
    ...VideoEditingStream
  }
  moments(first: 40) {
    data {
      startsAt
      endsAt
      ...ChatMoment
      ...MultiMoment
    }
  }
  relatedVideos {
    ...RelatedVideo
  }
  vod {
    url
    resolution
  }
}
    ${VideoDetailUserFragmentDoc}
${VideoEditingStreamFragmentDoc}
${ChatMomentFragmentDoc}
${MultiMomentFragmentDoc}
${RelatedVideoFragmentDoc}`;
export const MomentCollectionFragmentDoc = gql`
    fragment MomentCollection on MomentCollection {
  id
  title
  moments(first: 1000) {
    data {
      id
    }
  }
}
    `;
export const SimplePreviewMomentFragmentDoc = gql`
    fragment SimplePreviewMoment on MultiPerspectiveMoment {
  id
  published
  title
  startsAt
  endsAt
  isUnread
  channel {
    ... on TwitchUser {
      id
      displayName
      profileImageUrl
    }
  }
  ratings {
    user {
      id
    }
    rating
  }
}
    `;
export const PreviewVideoFragmentDoc = gql`
    fragment PreviewVideo on TwitchVideo {
  id
  title
  thumbnailUrl
  user {
    ... on TwitchUser {
      id
      displayName
      profileImageUrl
    }
  }
  stream {
    id
    startedAt
    endedAt
  }
}
    `;
export const PreviewMomentFragmentDoc = gql`
    fragment PreviewMoment on MultiPerspectiveMoment {
  ...SimplePreviewMoment
  edits(
    first: 100
    orderBy: {createdAt: ASC}
    filterBy: {includeUnpublished: $includeUnpublished, includeUnapproved: $includeUnapproved}
  ) {
    ...PreviewEdit
  }
  videos {
    ...PreviewVideo
  }
  signals {
    id
  }
}
    ${SimplePreviewMomentFragmentDoc}
${PreviewEditFragmentDoc}
${PreviewVideoFragmentDoc}`;
export const SearchResultFragmentDoc = gql`
    fragment SearchResult on TwitchUser {
  id
  name
  platform
}
    `;
export const PostBuyEditFragmentDoc = gql`
    fragment PostBuyEdit on MomentEdit {
  id
  format {
    aspectRatio {
      width
      height
    }
  }
  scenes {
    id
    start
    end
  }
  exports(first: 1, orderBy: {updatedAt: DESC}) {
    id
    output {
      videos {
        url
        resolution
      }
      thumbnails {
        index
        url
      }
    }
    updatedAt
  }
  moment {
    id
    title
    channel {
      id
      ... on TwitchUser {
        id
        displayName
        profileImageUrl
      }
    }
  }
}
    `;
export const DebugChatMomentFragmentDoc = gql`
    fragment DebugChatMoment on ChatMoment {
  id
  type
  startsAt
  endsAt
  metadata
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on ChatMessage {
  id
  text
  timestamp
  matching
  shouldBeMatching
}
    `;
export const SimpleRelatedVideoInfoFragmentDoc = gql`
    fragment SimpleRelatedVideoInfo on Video {
  id
  ... on TwitchVideo {
    id
    user {
      id
      name
      displayName
      profileImageUrl
    }
  }
}
    `;
export const SignalRelatedVideoFragmentDoc = gql`
    fragment SignalRelatedVideo on RelatedVideo {
  video {
    id
  }
  overlaps {
    from
    to
  }
  offset
}
    `;
export const SignalReviewVideoFragmentDoc = gql`
    fragment SignalReviewVideo on Video {
  id
  relatedVideos {
    ...SignalRelatedVideo
  }
  valorantMatches {
    id
    startedAt
    endedAt
    type
    videoSyncData {
      video {
        id
      }
      error
      status
      matchStartTime
    }
  }
}
    ${SignalRelatedVideoFragmentDoc}`;
export const ConnectedMomentFragmentDoc = gql`
    fragment ConnectedMoment on MultiPerspectiveMoment {
  id
  title
  startsAt
  endsAt
  ratings {
    user {
      id
    }
    rating
  }
  tags
  videos {
    id
  }
}
    `;
export const ReactionSignalDetailFragmentDoc = gql`
    fragment ReactionSignalDetail on Moment {
  id
  ... on ChatMoment {
    id
    title
    startsAt
    endsAt
    channel {
      id
    }
    video {
      ...SignalReviewVideo
    }
    metadata
    usedIn {
      ...ConnectedMoment
    }
    isUnread
  }
}
    ${SignalReviewVideoFragmentDoc}
${ConnectedMomentFragmentDoc}`;
export const ValorantRoundKillFragmentDoc = gql`
    fragment ValorantRoundKill on ValorantMatchRoundKill {
  finishingDamage {
    damageItem
    damageType
  }
  victim {
    gameName
  }
}
    `;
export const ValorantSignalDetailFragmentDoc = gql`
    fragment ValorantSignalDetail on Moment {
  id
  ... on ValorantMoment {
    id
    title
    startsAt
    endsAt
    match {
      id
      videoSyncData {
        video {
          id
        }
        error
        status
        matchStartTime
      }
    }
    channel {
      id
    }
    kills {
      ...ValorantRoundKill
    }
    video {
      ...SignalReviewVideo
    }
    usedIn {
      ...ConnectedMoment
    }
    isUnread
  }
}
    ${ValorantRoundKillFragmentDoc}
${SignalReviewVideoFragmentDoc}
${ConnectedMomentFragmentDoc}`;
export const ValorantMatchPlayerPreviewFragmentDoc = gql`
    fragment ValorantMatchPlayerPreview on ValorantMatchPlayer {
  gameName
  agent
  stats
  competitiveTier
  team
  account {
    id
    channel {
      id
      name
    }
  }
}
    `;
export const ValorantMatchPreviewFragmentDoc = gql`
    fragment ValorantMatchPreview on ValorantMatch {
  id
  startedAt
  endedAt
  type
  map
  winningTeam
  players {
    ...ValorantMatchPlayerPreview
  }
  videoSyncData {
    video {
      id
    }
    matchStartTime
    status
    error
  }
}
    ${ValorantMatchPlayerPreviewFragmentDoc}`;
export const ValorantRoundFragmentDoc = gql`
    fragment ValorantRound on ValorantRoundResult {
  roundNum
  roundResult
  roundCeremony
  winningTeam
  bombPlanter {
    gameName
  }
  bombDefuser {
    gameName
  }
  plantRoundTime
  plantSite
  defuseRoundTime
  playerStats {
    player {
      account {
        id
      }
      gameName
    }
    kills {
      finishingDamage {
        damageType
        damageItem
        isSecondaryFireMode
      }
      victim {
        gameName
        account {
          id
        }
      }
      timeSinceGameStartMillis
      timeSinceRoundStartMillis
    }
    damage {
      damage
      receiver {
        account {
          id
        }
      }
    }
    score
  }
}
    `;
export const ValorantMatchDetailFragmentDoc = gql`
    fragment ValorantMatchDetail on ValorantMatch {
  id
  startedAt
  endedAt
  map
  videoSyncData {
    video {
      id
    }
    matchStartTime
    status
  }
  players {
    ...ValorantMatchPlayerPreview
  }
  roundResults {
    ...ValorantRound
  }
}
    ${ValorantMatchPlayerPreviewFragmentDoc}
${ValorantRoundFragmentDoc}`;
export const ChannelCollectionRowFragmentDoc = gql`
    fragment ChannelCollectionRow on ChannelCollection {
  id
  title
  slug
}
    `;
export const ChannelRowPreviewFragmentDoc = gql`
    fragment ChannelRowPreview on Channel {
  ... on TwitchUser {
    id
    displayName
    profileImageUrl
    viewCount
  }
}
    `;
export const ChannelCollectionDetailsFragmentDoc = gql`
    fragment ChannelCollectionDetails on ChannelCollection {
  id
  title
  slug
  channels(first: 300) {
    data {
      ...ChannelRowPreview
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${ChannelRowPreviewFragmentDoc}`;
export const AdminSearchResultFragmentDoc = gql`
    fragment AdminSearchResult on TwitchUser {
  id
  name
  platform
  dontJoinChat
  autoSyncValorantMatches
}
    `;
export const AdminTwitchUserSourceFragmentDoc = gql`
    fragment AdminTwitchUserSource on TwitchUserSource {
  id
  name
  views
  profilePictureUrl
}
    `;
export const ValorantLeaderboardPlayerFragmentDoc = gql`
    fragment ValorantLeaderboardPlayer on ValorantLeaderboardPlayer {
  account {
    id
    channel {
      ... on TwitchUser {
        id
        displayName
        profileImageUrl
      }
    }
  }
  gameName
  tagLine
  rankedRating
  numberOfWins
  leaderboardRank
}
    `;
export const MatchSyncFragmentFragmentDoc = gql`
    fragment MatchSyncFragment on ValorantMatchVideoSync {
  __typename
  matchStartTime
  match {
    __typename
    id
  }
  video {
    __typename
    id
  }
  error
  status
}
    `;
export const FeedValorantMomentMatchFragmentDoc = gql`
    fragment FeedValorantMomentMatch on ValorantMatch {
  id
  map
  startedAt
  endedAt
  videoSyncData {
    ...MatchSyncFragment
  }
}
    ${MatchSyncFragmentFragmentDoc}`;
export const FeedValorantMomentFragmentDoc = gql`
    fragment FeedValorantMoment on ValorantMoment {
  id
  combatScore
  kills {
    __typename
    killer {
      account {
        id
      }
    }
    victim {
      account {
        id
      }
    }
  }
  agent
  startsAt
  endsAt
  channel {
    id
    name
    ... on TwitchUser {
      profileImageUrl
    }
  }
  video {
    id
    ... on TwitchVideo {
      stream {
        id
        startedAt
        endedAt
      }
    }
  }
  match {
    ...FeedValorantMomentMatch
  }
  usedIn {
    id
    ratings {
      rating
    }
    edits(
      first: 10
      orderBy: {createdAt: ASC}
      filterBy: {includeUnpublished: false, includeUnapproved: true}
    ) {
      id
      format {
        aspectRatio {
          width
          height
        }
      }
    }
  }
  isUnread
}
    ${FeedValorantMomentMatchFragmentDoc}`;
export const ReactionDetailFragmentDoc = gql`
    fragment ReactionDetail on ChatMoment {
  id
  type
  startsAt
  endsAt
  metadata
  usedIn {
    id
  }
  isUnread
}
    `;
export const ReactionFeedDetailFragmentDoc = gql`
    fragment ReactionFeedDetail on ChatMoment {
  ...ReactionDetail
  video {
    id
  }
  channel {
    ... on TwitchUser {
      id
      name
      profileImageUrl
      linkedAccounts {
        ... on RiotAccount {
          id
          puuid
        }
      }
    }
  }
  usedIn {
    id
    title
    ratings {
      user {
        id
      }
      rating
    }
    edits(
      first: 10
      orderBy: {createdAt: ASC}
      filterBy: {includeUnpublished: false, includeUnapproved: true}
    ) {
      id
      format {
        aspectRatio {
          width
          height
        }
      }
    }
  }
}
    ${ReactionDetailFragmentDoc}`;
export const ManualSignalDetailFragmentDoc = gql`
    fragment ManualSignalDetail on Moment {
  id
  ... on ManualSignalMoment {
    id
    title
    startsAt
    endsAt
    type
    channel {
      id
    }
    video {
      ...SignalReviewVideo
    }
    metadata
    usedIn {
      ...ConnectedMoment
    }
    isUnread
  }
}
    ${SignalReviewVideoFragmentDoc}
${ConnectedMomentFragmentDoc}`;
export const ManualFeedDetailFragmentDoc = gql`
    fragment ManualFeedDetail on ManualSignalMoment {
  ...ManualSignalDetail
  video {
    id
  }
  channel {
    ... on TwitchUser {
      id
      name
      profileImageUrl
      linkedAccounts {
        ... on RiotAccount {
          id
          puuid
        }
      }
    }
  }
  usedIn {
    id
    title
    ratings {
      user {
        id
      }
      rating
    }
    edits(
      first: 10
      orderBy: {createdAt: ASC}
      filterBy: {includeUnpublished: false, includeUnapproved: true}
    ) {
      id
      format {
        aspectRatio {
          width
          height
        }
      }
    }
  }
}
    ${ManualSignalDetailFragmentDoc}`;
export const ContentMomentFragmentDoc = gql`
    fragment ContentMoment on MultiPerspectiveMoment {
  id
  startsAt
  endsAt
  title
  channels {
    id
  }
  edits(
    first: 10
    orderBy: {createdAt: DESC}
    filterBy: {includeUnpublished: true, includeUnapproved: true}
  ) {
    id
    __typename
  }
  ratings {
    rating
  }
  channel {
    id
    name
    ... on TwitchUser {
      profileImageUrl
    }
  }
  video {
    id
    ... on TwitchVideo {
      stream {
        id
        startedAt
        endedAt
      }
    }
  }
  signals {
    id
    ... on ValorantMoment {
      ...FeedValorantMoment
    }
    ... on ChatMoment {
      ...ReactionFeedDetail
    }
    ... on ManualSignalMoment {
      ...ManualFeedDetail
    }
  }
}
    ${FeedValorantMomentFragmentDoc}
${ReactionFeedDetailFragmentDoc}
${ManualFeedDetailFragmentDoc}`;
export const FeedPreviewFragmentDoc = gql`
    fragment FeedPreview on Moment {
  id
  startsAt
  endsAt
  video {
    id
    ... on TwitchVideo {
      stream {
        id
        endedAt
      }
    }
  }
}
    `;
export const ChannelCollectionPreviewFragmentDoc = gql`
    fragment ChannelCollectionPreview on ChannelCollection {
  id
  title
  slug
  channels(first: 300) {
    data {
      id
    }
  }
}
    `;
export const VideoOffsetFragmentDoc = gql`
    fragment VideoOffset on VideoWithOffsets {
  fromVideo {
    id
  }
  toVideo {
    id
  }
  offsets {
    audioOffset
    videoOffset
  }
}
    `;
export const AspectRatioFragmentDoc = gql`
    fragment AspectRatio on AspectRatio {
  width
  height
}
    `;
export const RectFragmentDoc = gql`
    fragment Rect on Rect {
  x
  y
  width
  height
}
    `;
export const TemplateCropFragmentDoc = gql`
    fragment TemplateCrop on Crop {
  title
  aspectRatio {
    ...AspectRatio
  }
  position {
    ...Rect
  }
}
    ${AspectRatioFragmentDoc}
${RectFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment Template on Template {
  title
  crops {
    ...TemplateCrop
  }
}
    ${TemplateCropFragmentDoc}`;
export const FormatFragmentDoc = gql`
    fragment Format on Format {
  id
  title
  aspectRatio {
    ...AspectRatio
  }
  templates {
    ...Template
  }
}
    ${AspectRatioFragmentDoc}
${TemplateFragmentDoc}`;
export const CropDataFragmentDoc = gql`
    fragment CropData on CropData {
  title
  videoId
  offset
  muted
  cropRect {
    ...Rect
  }
}
    ${RectFragmentDoc}`;
export const SceneFragmentDoc = gql`
    fragment Scene on Scene {
  id
  start
  end
  index
  cropData {
    ...CropData
  }
  template {
    ...Template
  }
  overlays {
    overlayType
    data
  }
}
    ${CropDataFragmentDoc}
${TemplateFragmentDoc}`;
export const MomentExportFragmentDoc = gql`
    fragment MomentExport on VideoExport {
  id
  status
  output {
    thumbnails {
      index
      url
    }
    videos {
      resolution
      url
    }
  }
}
    `;
export const MomentEditFragmentDoc = gql`
    fragment MomentEdit on MomentEdit {
  id
  title
  published
  format {
    ...Format
  }
  scenes {
    ...Scene
  }
  exports(first: 100, orderBy: {createdAt: DESC}) {
    ...MomentExport
  }
}
    ${FormatFragmentDoc}
${SceneFragmentDoc}
${MomentExportFragmentDoc}`;
export const MultiPerspectiveMomentDetailFragmentDoc = gql`
    fragment MultiPerspectiveMomentDetail on MultiPerspectiveMoment {
  id
  startsAt
  endsAt
  title
  published
  publishedAt
  mainVideo {
    id
  }
  offsets {
    ...VideoOffset
  }
  videos {
    id
    ... on TwitchVideo {
      user {
        id
        displayName
        profileImageUrl
      }
    }
  }
  edits(
    first: 100
    orderBy: {createdAt: DESC}
    filterBy: {includeUnpublished: true, includeUnapproved: true}
  ) {
    ...MomentEdit
  }
}
    ${VideoOffsetFragmentDoc}
${MomentEditFragmentDoc}`;
export const LeaderboardPlayerFragmentDoc = gql`
    fragment LeaderboardPlayer on ValorantLeaderboardPlayer {
  account {
    id
    channel {
      id
      name
      ... on TwitchUser {
        profileImageUrl
      }
    }
  }
  leaderboardRank
  gameName
  numberOfWins
  competitiveTier
}
    `;
export const MatchDetailsFragmentDoc = gql`
    fragment MatchDetails on ValorantMatch {
  id
  winningTeam
  type
  players {
    team
    stats
    gameName
    agent
  }
}
    `;
export const ValorantMatchDiscoveryPreviewFragmentDoc = gql`
    fragment ValorantMatchDiscoveryPreview on ValorantMatch {
  id
  type
  startedAt
  endedAt
  players {
    agent
    stats
    team
    gameName
    account {
      id
    }
  }
  winningTeam
}
    `;
export const ValorantMatchPlayerHighlightFragmentDoc = gql`
    fragment ValorantMatchPlayerHighlight on ValorantMatchPlayer {
  gameName
  agent
  stats
  competitiveTier
  team
  account {
    id
    channel {
      id
      ... on TwitchUser {
        displayName
        profileImageUrl
      }
    }
  }
}
    `;
export const RosterPreviewUserFragmentDoc = gql`
    fragment RosterPreviewUser on TwitchUser {
  id
  name
  login
  displayName
  profileImageUrl
}
    `;
export const GetTwitchUserBasicsDocument = gql`
    query getTwitchUserBasics($userId: String!) {
  channel(filter: {id: $userId, platform: TWITCH}) {
    id
    ... on TwitchUser {
      displayName
      profileImageUrl
    }
  }
}
    `;

/**
 * __useGetTwitchUserBasicsQuery__
 *
 * To run a query within a React component, call `useGetTwitchUserBasicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwitchUserBasicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwitchUserBasicsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTwitchUserBasicsQuery(baseOptions: Apollo.QueryHookOptions<GetTwitchUserBasicsQuery, GetTwitchUserBasicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwitchUserBasicsQuery, GetTwitchUserBasicsQueryVariables>(GetTwitchUserBasicsDocument, options);
      }
export function useGetTwitchUserBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwitchUserBasicsQuery, GetTwitchUserBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwitchUserBasicsQuery, GetTwitchUserBasicsQueryVariables>(GetTwitchUserBasicsDocument, options);
        }
export type GetTwitchUserBasicsQueryHookResult = ReturnType<typeof useGetTwitchUserBasicsQuery>;
export type GetTwitchUserBasicsLazyQueryHookResult = ReturnType<typeof useGetTwitchUserBasicsLazyQuery>;
export type GetTwitchUserBasicsQueryResult = Apollo.QueryResult<GetTwitchUserBasicsQuery, GetTwitchUserBasicsQueryVariables>;
export const GetVideoSrcUrlsDocument = gql`
    query getVideoSrcUrls($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    ... on TwitchVideo {
      stream {
        startedAt
        endedAt
      }
      vod {
        resolution
        url
      }
    }
  }
}
    `;

/**
 * __useGetVideoSrcUrlsQuery__
 *
 * To run a query within a React component, call `useGetVideoSrcUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoSrcUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoSrcUrlsQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetVideoSrcUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetVideoSrcUrlsQuery, GetVideoSrcUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoSrcUrlsQuery, GetVideoSrcUrlsQueryVariables>(GetVideoSrcUrlsDocument, options);
      }
export function useGetVideoSrcUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoSrcUrlsQuery, GetVideoSrcUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoSrcUrlsQuery, GetVideoSrcUrlsQueryVariables>(GetVideoSrcUrlsDocument, options);
        }
export type GetVideoSrcUrlsQueryHookResult = ReturnType<typeof useGetVideoSrcUrlsQuery>;
export type GetVideoSrcUrlsLazyQueryHookResult = ReturnType<typeof useGetVideoSrcUrlsLazyQuery>;
export type GetVideoSrcUrlsQueryResult = Apollo.QueryResult<GetVideoSrcUrlsQuery, GetVideoSrcUrlsQueryVariables>;
export const GetMatchMomentCollectionDocument = gql`
    query getMatchMomentCollection($slug: String!) {
  momentCollection(filter: {slug: $slug}) {
    id
    moments(first: 100) {
      data {
        ...MatchMoment
      }
    }
  }
}
    ${MatchMomentFragmentDoc}`;

/**
 * __useGetMatchMomentCollectionQuery__
 *
 * To run a query within a React component, call `useGetMatchMomentCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchMomentCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchMomentCollectionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetMatchMomentCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetMatchMomentCollectionQuery, GetMatchMomentCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchMomentCollectionQuery, GetMatchMomentCollectionQueryVariables>(GetMatchMomentCollectionDocument, options);
      }
export function useGetMatchMomentCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchMomentCollectionQuery, GetMatchMomentCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchMomentCollectionQuery, GetMatchMomentCollectionQueryVariables>(GetMatchMomentCollectionDocument, options);
        }
export type GetMatchMomentCollectionQueryHookResult = ReturnType<typeof useGetMatchMomentCollectionQuery>;
export type GetMatchMomentCollectionLazyQueryHookResult = ReturnType<typeof useGetMatchMomentCollectionLazyQuery>;
export type GetMatchMomentCollectionQueryResult = Apollo.QueryResult<GetMatchMomentCollectionQuery, GetMatchMomentCollectionQueryVariables>;
export const UpdateMatchMomentCollectionDocument = gql`
    mutation updateMatchMomentCollection($momentCollectionId: String!, $momentCollectionInput: PartialMomentCollectionInput) {
  updateMomentCollection(id: $momentCollectionId, input: $momentCollectionInput) {
    id
    title
    moments(first: 100) {
      data {
        id
        ...MatchMoment
      }
    }
  }
}
    ${MatchMomentFragmentDoc}`;
export type UpdateMatchMomentCollectionMutationFn = Apollo.MutationFunction<UpdateMatchMomentCollectionMutation, UpdateMatchMomentCollectionMutationVariables>;

/**
 * __useUpdateMatchMomentCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMatchMomentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchMomentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchMomentCollectionMutation, { data, loading, error }] = useUpdateMatchMomentCollectionMutation({
 *   variables: {
 *      momentCollectionId: // value for 'momentCollectionId'
 *      momentCollectionInput: // value for 'momentCollectionInput'
 *   },
 * });
 */
export function useUpdateMatchMomentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchMomentCollectionMutation, UpdateMatchMomentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchMomentCollectionMutation, UpdateMatchMomentCollectionMutationVariables>(UpdateMatchMomentCollectionDocument, options);
      }
export type UpdateMatchMomentCollectionMutationHookResult = ReturnType<typeof useUpdateMatchMomentCollectionMutation>;
export type UpdateMatchMomentCollectionMutationResult = Apollo.MutationResult<UpdateMatchMomentCollectionMutation>;
export type UpdateMatchMomentCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMatchMomentCollectionMutation, UpdateMatchMomentCollectionMutationVariables>;
export const GetCampaignPreviewDocument = gql`
    query getCampaignPreview($campaignId: String!) {
  campaign(filter: {id: $campaignId}) {
    ...CampaignPreview
  }
}
    ${CampaignPreviewFragmentDoc}`;

/**
 * __useGetCampaignPreviewQuery__
 *
 * To run a query within a React component, call `useGetCampaignPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPreviewQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPreviewQuery, GetCampaignPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPreviewQuery, GetCampaignPreviewQueryVariables>(GetCampaignPreviewDocument, options);
      }
export function useGetCampaignPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPreviewQuery, GetCampaignPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPreviewQuery, GetCampaignPreviewQueryVariables>(GetCampaignPreviewDocument, options);
        }
export type GetCampaignPreviewQueryHookResult = ReturnType<typeof useGetCampaignPreviewQuery>;
export type GetCampaignPreviewLazyQueryHookResult = ReturnType<typeof useGetCampaignPreviewLazyQuery>;
export type GetCampaignPreviewQueryResult = Apollo.QueryResult<GetCampaignPreviewQuery, GetCampaignPreviewQueryVariables>;
export const GetCampaignMomentsDocument = gql`
    query getCampaignMoments($slug: String!, $channelIds: [String!], $timeframe: TimeRangeFilterInput, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  campaign(filter: {slug: $slug}) {
    id
    moments(
      groupBy: NONE
      first: 300
      filterBy: {channelIds: $channelIds, startsAt: $timeframe}
    ) {
      data {
        moment {
          id
          ...PreviewMoment
        }
      }
    }
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetCampaignMomentsQuery__
 *
 * To run a query within a React component, call `useGetCampaignMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignMomentsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channelIds: // value for 'channelIds'
 *      timeframe: // value for 'timeframe'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetCampaignMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignMomentsQuery, GetCampaignMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignMomentsQuery, GetCampaignMomentsQueryVariables>(GetCampaignMomentsDocument, options);
      }
export function useGetCampaignMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignMomentsQuery, GetCampaignMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignMomentsQuery, GetCampaignMomentsQueryVariables>(GetCampaignMomentsDocument, options);
        }
export type GetCampaignMomentsQueryHookResult = ReturnType<typeof useGetCampaignMomentsQuery>;
export type GetCampaignMomentsLazyQueryHookResult = ReturnType<typeof useGetCampaignMomentsLazyQuery>;
export type GetCampaignMomentsQueryResult = Apollo.QueryResult<GetCampaignMomentsQuery, GetCampaignMomentsQueryVariables>;
export const GetMomentCollectionDetailDocument = gql`
    query getMomentCollectionDetail($id: String!, $first: Int!, $after: String, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  momentCollection(filter: {id: $id}) {
    id
    moments(first: $first, after: $after) {
      data {
        id
        ...MomentCollectionGridItem
      }
    }
  }
}
    ${MomentCollectionGridItemFragmentDoc}`;

/**
 * __useGetMomentCollectionDetailQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetMomentCollectionDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMomentCollectionDetailQuery, GetMomentCollectionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionDetailQuery, GetMomentCollectionDetailQueryVariables>(GetMomentCollectionDetailDocument, options);
      }
export function useGetMomentCollectionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionDetailQuery, GetMomentCollectionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionDetailQuery, GetMomentCollectionDetailQueryVariables>(GetMomentCollectionDetailDocument, options);
        }
export type GetMomentCollectionDetailQueryHookResult = ReturnType<typeof useGetMomentCollectionDetailQuery>;
export type GetMomentCollectionDetailLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionDetailLazyQuery>;
export type GetMomentCollectionDetailQueryResult = Apollo.QueryResult<GetMomentCollectionDetailQuery, GetMomentCollectionDetailQueryVariables>;
export const GetMomentCollectionIdsDocument = gql`
    query getMomentCollectionIds($id: String!, $first: Int!) {
  momentCollection(filter: {id: $id}) {
    id
    moments(first: $first) {
      data {
        id
      }
    }
  }
}
    `;

/**
 * __useGetMomentCollectionIdsQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetMomentCollectionIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMomentCollectionIdsQuery, GetMomentCollectionIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionIdsQuery, GetMomentCollectionIdsQueryVariables>(GetMomentCollectionIdsDocument, options);
      }
export function useGetMomentCollectionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionIdsQuery, GetMomentCollectionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionIdsQuery, GetMomentCollectionIdsQueryVariables>(GetMomentCollectionIdsDocument, options);
        }
export type GetMomentCollectionIdsQueryHookResult = ReturnType<typeof useGetMomentCollectionIdsQuery>;
export type GetMomentCollectionIdsLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionIdsLazyQuery>;
export type GetMomentCollectionIdsQueryResult = Apollo.QueryResult<GetMomentCollectionIdsQuery, GetMomentCollectionIdsQueryVariables>;
export const GetOrganizationCollectionsListDocument = gql`
    query getOrganizationCollectionsList($slug: String!) {
  organization(by: {slug: $slug}) {
    id
    collections(first: 100) {
      data {
        ...MomentCollectionShort
      }
    }
  }
}
    ${MomentCollectionShortFragmentDoc}`;

/**
 * __useGetOrganizationCollectionsListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCollectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCollectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCollectionsListQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationCollectionsListQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCollectionsListQuery, GetOrganizationCollectionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCollectionsListQuery, GetOrganizationCollectionsListQueryVariables>(GetOrganizationCollectionsListDocument, options);
      }
export function useGetOrganizationCollectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCollectionsListQuery, GetOrganizationCollectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCollectionsListQuery, GetOrganizationCollectionsListQueryVariables>(GetOrganizationCollectionsListDocument, options);
        }
export type GetOrganizationCollectionsListQueryHookResult = ReturnType<typeof useGetOrganizationCollectionsListQuery>;
export type GetOrganizationCollectionsListLazyQueryHookResult = ReturnType<typeof useGetOrganizationCollectionsListLazyQuery>;
export type GetOrganizationCollectionsListQueryResult = Apollo.QueryResult<GetOrganizationCollectionsListQuery, GetOrganizationCollectionsListQueryVariables>;
export const CreateEmptyMomentcollectionDocument = gql`
    mutation CreateEmptyMomentcollection($title: String!, $organizationId: String) {
  createMomentCollection(
    input: {title: $title, momentIds: [], organizationId: $organizationId}
  ) {
    ...MomentCollectionShort
  }
}
    ${MomentCollectionShortFragmentDoc}`;
export type CreateEmptyMomentcollectionMutationFn = Apollo.MutationFunction<CreateEmptyMomentcollectionMutation, CreateEmptyMomentcollectionMutationVariables>;

/**
 * __useCreateEmptyMomentcollectionMutation__
 *
 * To run a mutation, you first call `useCreateEmptyMomentcollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmptyMomentcollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmptyMomentcollectionMutation, { data, loading, error }] = useCreateEmptyMomentcollectionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateEmptyMomentcollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmptyMomentcollectionMutation, CreateEmptyMomentcollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmptyMomentcollectionMutation, CreateEmptyMomentcollectionMutationVariables>(CreateEmptyMomentcollectionDocument, options);
      }
export type CreateEmptyMomentcollectionMutationHookResult = ReturnType<typeof useCreateEmptyMomentcollectionMutation>;
export type CreateEmptyMomentcollectionMutationResult = Apollo.MutationResult<CreateEmptyMomentcollectionMutation>;
export type CreateEmptyMomentcollectionMutationOptions = Apollo.BaseMutationOptions<CreateEmptyMomentcollectionMutation, CreateEmptyMomentcollectionMutationVariables>;
export const GetValorantMatchesForVideoDocument = gql`
    query getValorantMatchesForVideo($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    valorantMatches {
      id
      type
      startedAt
      endedAt
    }
  }
}
    `;

/**
 * __useGetValorantMatchesForVideoQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchesForVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchesForVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchesForVideoQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetValorantMatchesForVideoQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchesForVideoQuery, GetValorantMatchesForVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchesForVideoQuery, GetValorantMatchesForVideoQueryVariables>(GetValorantMatchesForVideoDocument, options);
      }
export function useGetValorantMatchesForVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchesForVideoQuery, GetValorantMatchesForVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchesForVideoQuery, GetValorantMatchesForVideoQueryVariables>(GetValorantMatchesForVideoDocument, options);
        }
export type GetValorantMatchesForVideoQueryHookResult = ReturnType<typeof useGetValorantMatchesForVideoQuery>;
export type GetValorantMatchesForVideoLazyQueryHookResult = ReturnType<typeof useGetValorantMatchesForVideoLazyQuery>;
export type GetValorantMatchesForVideoQueryResult = Apollo.QueryResult<GetValorantMatchesForVideoQuery, GetValorantMatchesForVideoQueryVariables>;
export const GetValorantMatchesForVideoWithUserInfoDocument = gql`
    query getValorantMatchesForVideoWithUserInfo($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    ... on TwitchVideo {
      id
      user {
        id
        displayName
        profileImageUrl
        linkedAccounts {
          ... on RiotAccount {
            puuid
          }
        }
      }
    }
    valorantMatches {
      id
      type
      startedAt
      endedAt
    }
  }
}
    `;

/**
 * __useGetValorantMatchesForVideoWithUserInfoQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchesForVideoWithUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchesForVideoWithUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchesForVideoWithUserInfoQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetValorantMatchesForVideoWithUserInfoQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchesForVideoWithUserInfoQuery, GetValorantMatchesForVideoWithUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchesForVideoWithUserInfoQuery, GetValorantMatchesForVideoWithUserInfoQueryVariables>(GetValorantMatchesForVideoWithUserInfoDocument, options);
      }
export function useGetValorantMatchesForVideoWithUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchesForVideoWithUserInfoQuery, GetValorantMatchesForVideoWithUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchesForVideoWithUserInfoQuery, GetValorantMatchesForVideoWithUserInfoQueryVariables>(GetValorantMatchesForVideoWithUserInfoDocument, options);
        }
export type GetValorantMatchesForVideoWithUserInfoQueryHookResult = ReturnType<typeof useGetValorantMatchesForVideoWithUserInfoQuery>;
export type GetValorantMatchesForVideoWithUserInfoLazyQueryHookResult = ReturnType<typeof useGetValorantMatchesForVideoWithUserInfoLazyQuery>;
export type GetValorantMatchesForVideoWithUserInfoQueryResult = Apollo.QueryResult<GetValorantMatchesForVideoWithUserInfoQuery, GetValorantMatchesForVideoWithUserInfoQueryVariables>;
export const GetEditingVideoDocument = gql`
    query getEditingVideo($id: String!) {
  video(id: $id, platform: TWITCH) {
    id
    ...TwitchEditingVideo
  }
}
    ${TwitchEditingVideoFragmentDoc}`;

/**
 * __useGetEditingVideoQuery__
 *
 * To run a query within a React component, call `useGetEditingVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditingVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditingVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditingVideoQuery(baseOptions: Apollo.QueryHookOptions<GetEditingVideoQuery, GetEditingVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditingVideoQuery, GetEditingVideoQueryVariables>(GetEditingVideoDocument, options);
      }
export function useGetEditingVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditingVideoQuery, GetEditingVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditingVideoQuery, GetEditingVideoQueryVariables>(GetEditingVideoDocument, options);
        }
export type GetEditingVideoQueryHookResult = ReturnType<typeof useGetEditingVideoQuery>;
export type GetEditingVideoLazyQueryHookResult = ReturnType<typeof useGetEditingVideoLazyQuery>;
export type GetEditingVideoQueryResult = Apollo.QueryResult<GetEditingVideoQuery, GetEditingVideoQueryVariables>;
export const GetEditingVideosDocument = gql`
    query getEditingVideos($videoIds: [String!]!) {
  videos(first: 100, filter: {videoIds: $videoIds}) {
    data {
      ...TwitchEditingVideo
    }
  }
}
    ${TwitchEditingVideoFragmentDoc}`;

/**
 * __useGetEditingVideosQuery__
 *
 * To run a query within a React component, call `useGetEditingVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditingVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditingVideosQuery({
 *   variables: {
 *      videoIds: // value for 'videoIds'
 *   },
 * });
 */
export function useGetEditingVideosQuery(baseOptions: Apollo.QueryHookOptions<GetEditingVideosQuery, GetEditingVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditingVideosQuery, GetEditingVideosQueryVariables>(GetEditingVideosDocument, options);
      }
export function useGetEditingVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditingVideosQuery, GetEditingVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditingVideosQuery, GetEditingVideosQueryVariables>(GetEditingVideosDocument, options);
        }
export type GetEditingVideosQueryHookResult = ReturnType<typeof useGetEditingVideosQuery>;
export type GetEditingVideosLazyQueryHookResult = ReturnType<typeof useGetEditingVideosLazyQuery>;
export type GetEditingVideosQueryResult = Apollo.QueryResult<GetEditingVideosQuery, GetEditingVideosQueryVariables>;
export const CreateMultiPerspectiveMomentDocument = gql`
    mutation CreateMultiPerspectiveMoment($createMultiPerspectiveMomentInput: MultiPerspectiveMomentInput!) {
  createMultiPerspectiveMoment(input: $createMultiPerspectiveMomentInput) {
    id
  }
}
    `;
export type CreateMultiPerspectiveMomentMutationFn = Apollo.MutationFunction<CreateMultiPerspectiveMomentMutation, CreateMultiPerspectiveMomentMutationVariables>;

/**
 * __useCreateMultiPerspectiveMomentMutation__
 *
 * To run a mutation, you first call `useCreateMultiPerspectiveMomentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiPerspectiveMomentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiPerspectiveMomentMutation, { data, loading, error }] = useCreateMultiPerspectiveMomentMutation({
 *   variables: {
 *      createMultiPerspectiveMomentInput: // value for 'createMultiPerspectiveMomentInput'
 *   },
 * });
 */
export function useCreateMultiPerspectiveMomentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiPerspectiveMomentMutation, CreateMultiPerspectiveMomentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiPerspectiveMomentMutation, CreateMultiPerspectiveMomentMutationVariables>(CreateMultiPerspectiveMomentDocument, options);
      }
export type CreateMultiPerspectiveMomentMutationHookResult = ReturnType<typeof useCreateMultiPerspectiveMomentMutation>;
export type CreateMultiPerspectiveMomentMutationResult = Apollo.MutationResult<CreateMultiPerspectiveMomentMutation>;
export type CreateMultiPerspectiveMomentMutationOptions = Apollo.BaseMutationOptions<CreateMultiPerspectiveMomentMutation, CreateMultiPerspectiveMomentMutationVariables>;
export const GetVideoPlayerDataDocument = gql`
    query getVideoPlayerData($videoId: String!) {
  video(id: $videoId, platform: TWITCH) {
    ... on TwitchVideo {
      id
      vod {
        resolution
        url
      }
      stream {
        startedAt
      }
    }
  }
}
    `;

/**
 * __useGetVideoPlayerDataQuery__
 *
 * To run a query within a React component, call `useGetVideoPlayerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoPlayerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoPlayerDataQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetVideoPlayerDataQuery(baseOptions: Apollo.QueryHookOptions<GetVideoPlayerDataQuery, GetVideoPlayerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoPlayerDataQuery, GetVideoPlayerDataQueryVariables>(GetVideoPlayerDataDocument, options);
      }
export function useGetVideoPlayerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoPlayerDataQuery, GetVideoPlayerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoPlayerDataQuery, GetVideoPlayerDataQueryVariables>(GetVideoPlayerDataDocument, options);
        }
export type GetVideoPlayerDataQueryHookResult = ReturnType<typeof useGetVideoPlayerDataQuery>;
export type GetVideoPlayerDataLazyQueryHookResult = ReturnType<typeof useGetVideoPlayerDataLazyQuery>;
export type GetVideoPlayerDataQueryResult = Apollo.QueryResult<GetVideoPlayerDataQuery, GetVideoPlayerDataQueryVariables>;
export const GetValorantDataForVideoDocument = gql`
    query getValorantDataForVideo($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    ... on TwitchVideo {
      id
      user {
        displayName
        linkedAccounts {
          ... on RiotAccount {
            id
          }
        }
      }
    }
    relatedVideos {
      reasons {
        ... on PlayedInValorantMatches {
          valorantMatches {
            id
            type
            startedAt
            roundResults {
              playerStats {
                player {
                  gameName
                  tagLine
                  account {
                    id
                  }
                }
                kills {
                  killer {
                    gameName
                  }
                  victim {
                    gameName
                  }
                  timeSinceGameStartMillis
                }
              }
              winningTeam
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetValorantDataForVideoQuery__
 *
 * To run a query within a React component, call `useGetValorantDataForVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantDataForVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantDataForVideoQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetValorantDataForVideoQuery(baseOptions: Apollo.QueryHookOptions<GetValorantDataForVideoQuery, GetValorantDataForVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantDataForVideoQuery, GetValorantDataForVideoQueryVariables>(GetValorantDataForVideoDocument, options);
      }
export function useGetValorantDataForVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantDataForVideoQuery, GetValorantDataForVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantDataForVideoQuery, GetValorantDataForVideoQueryVariables>(GetValorantDataForVideoDocument, options);
        }
export type GetValorantDataForVideoQueryHookResult = ReturnType<typeof useGetValorantDataForVideoQuery>;
export type GetValorantDataForVideoLazyQueryHookResult = ReturnType<typeof useGetValorantDataForVideoLazyQuery>;
export type GetValorantDataForVideoQueryResult = Apollo.QueryResult<GetValorantDataForVideoQuery, GetValorantDataForVideoQueryVariables>;
export const LinkRiotAccountDocument = gql`
    mutation linkRiotAccount($channelId: String!, $riotId: String!) {
  linkAccountToChannel(
    account: {id: $riotId, type: RIOT_ACCOUNT}
    channelId: $channelId
  )
}
    `;
export type LinkRiotAccountMutationFn = Apollo.MutationFunction<LinkRiotAccountMutation, LinkRiotAccountMutationVariables>;

/**
 * __useLinkRiotAccountMutation__
 *
 * To run a mutation, you first call `useLinkRiotAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRiotAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRiotAccountMutation, { data, loading, error }] = useLinkRiotAccountMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      riotId: // value for 'riotId'
 *   },
 * });
 */
export function useLinkRiotAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkRiotAccountMutation, LinkRiotAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkRiotAccountMutation, LinkRiotAccountMutationVariables>(LinkRiotAccountDocument, options);
      }
export type LinkRiotAccountMutationHookResult = ReturnType<typeof useLinkRiotAccountMutation>;
export type LinkRiotAccountMutationResult = Apollo.MutationResult<LinkRiotAccountMutation>;
export type LinkRiotAccountMutationOptions = Apollo.BaseMutationOptions<LinkRiotAccountMutation, LinkRiotAccountMutationVariables>;
export const GetEditPlayerDocument = gql`
    query getEditPlayer($editId: String!) {
  momentEdit(filter: {id: $editId}) {
    id
    exports(first: 1, orderBy: {createdAt: DESC}) {
      id
      status
      output {
        videos {
          resolution
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetEditPlayerQuery__
 *
 * To run a query within a React component, call `useGetEditPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPlayerQuery({
 *   variables: {
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useGetEditPlayerQuery(baseOptions: Apollo.QueryHookOptions<GetEditPlayerQuery, GetEditPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPlayerQuery, GetEditPlayerQueryVariables>(GetEditPlayerDocument, options);
      }
export function useGetEditPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPlayerQuery, GetEditPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPlayerQuery, GetEditPlayerQueryVariables>(GetEditPlayerDocument, options);
        }
export type GetEditPlayerQueryHookResult = ReturnType<typeof useGetEditPlayerQuery>;
export type GetEditPlayerLazyQueryHookResult = ReturnType<typeof useGetEditPlayerLazyQuery>;
export type GetEditPlayerQueryResult = Apollo.QueryResult<GetEditPlayerQuery, GetEditPlayerQueryVariables>;
export const GetValorantMatchScoreboardDocument = gql`
    query getValorantMatchScoreboard($matchId: String!, $matchStart: Date!, $matchEnd: Date!) {
  valorantMatch(id: $matchId) {
    id
    players {
      gameName
      agent
      team
      stats
      tagLine
      account {
        id
        channel {
          ... on TwitchUser {
            id
            streams(first: 1, filterBy: {overlaps: {from: $matchStart, to: $matchEnd}}) {
              data {
                video {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetValorantMatchScoreboardQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchScoreboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchScoreboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchScoreboardQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      matchStart: // value for 'matchStart'
 *      matchEnd: // value for 'matchEnd'
 *   },
 * });
 */
export function useGetValorantMatchScoreboardQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchScoreboardQuery, GetValorantMatchScoreboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchScoreboardQuery, GetValorantMatchScoreboardQueryVariables>(GetValorantMatchScoreboardDocument, options);
      }
export function useGetValorantMatchScoreboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchScoreboardQuery, GetValorantMatchScoreboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchScoreboardQuery, GetValorantMatchScoreboardQueryVariables>(GetValorantMatchScoreboardDocument, options);
        }
export type GetValorantMatchScoreboardQueryHookResult = ReturnType<typeof useGetValorantMatchScoreboardQuery>;
export type GetValorantMatchScoreboardLazyQueryHookResult = ReturnType<typeof useGetValorantMatchScoreboardLazyQuery>;
export type GetValorantMatchScoreboardQueryResult = Apollo.QueryResult<GetValorantMatchScoreboardQuery, GetValorantMatchScoreboardQueryVariables>;
export const CreateNewCollectionDocument = gql`
    mutation createNewCollection($title: String!, $momentIds: [String!]!) {
  createMomentCollection(input: {title: $title, momentIds: $momentIds}) {
    id
    title
    moments(first: 100) {
      data {
        id
      }
    }
  }
}
    `;
export type CreateNewCollectionMutationFn = Apollo.MutationFunction<CreateNewCollectionMutation, CreateNewCollectionMutationVariables>;

/**
 * __useCreateNewCollectionMutation__
 *
 * To run a mutation, you first call `useCreateNewCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCollectionMutation, { data, loading, error }] = useCreateNewCollectionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      momentIds: // value for 'momentIds'
 *   },
 * });
 */
export function useCreateNewCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCollectionMutation, CreateNewCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCollectionMutation, CreateNewCollectionMutationVariables>(CreateNewCollectionDocument, options);
      }
export type CreateNewCollectionMutationHookResult = ReturnType<typeof useCreateNewCollectionMutation>;
export type CreateNewCollectionMutationResult = Apollo.MutationResult<CreateNewCollectionMutation>;
export type CreateNewCollectionMutationOptions = Apollo.BaseMutationOptions<CreateNewCollectionMutation, CreateNewCollectionMutationVariables>;
export const GetMyMomentCollectionsDocument = gql`
    query getMyMomentCollections {
  momentCollections(first: 100) {
    data {
      id
      ...MomentCollection
    }
  }
}
    ${MomentCollectionFragmentDoc}`;

/**
 * __useGetMyMomentCollectionsQuery__
 *
 * To run a query within a React component, call `useGetMyMomentCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMomentCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMomentCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMomentCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMomentCollectionsQuery, GetMyMomentCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMomentCollectionsQuery, GetMyMomentCollectionsQueryVariables>(GetMyMomentCollectionsDocument, options);
      }
export function useGetMyMomentCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMomentCollectionsQuery, GetMyMomentCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMomentCollectionsQuery, GetMyMomentCollectionsQueryVariables>(GetMyMomentCollectionsDocument, options);
        }
export type GetMyMomentCollectionsQueryHookResult = ReturnType<typeof useGetMyMomentCollectionsQuery>;
export type GetMyMomentCollectionsLazyQueryHookResult = ReturnType<typeof useGetMyMomentCollectionsLazyQuery>;
export type GetMyMomentCollectionsQueryResult = Apollo.QueryResult<GetMyMomentCollectionsQuery, GetMyMomentCollectionsQueryVariables>;
export const UpdateMomentsInCollectionDocument = gql`
    mutation updateMomentsInCollection($nextMomentIds: [String!]!, $collectionId: String!) {
  updateMomentCollection(id: $collectionId, input: {momentIds: $nextMomentIds}) {
    ...MomentCollection
  }
}
    ${MomentCollectionFragmentDoc}`;
export type UpdateMomentsInCollectionMutationFn = Apollo.MutationFunction<UpdateMomentsInCollectionMutation, UpdateMomentsInCollectionMutationVariables>;

/**
 * __useUpdateMomentsInCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMomentsInCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMomentsInCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMomentsInCollectionMutation, { data, loading, error }] = useUpdateMomentsInCollectionMutation({
 *   variables: {
 *      nextMomentIds: // value for 'nextMomentIds'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useUpdateMomentsInCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMomentsInCollectionMutation, UpdateMomentsInCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMomentsInCollectionMutation, UpdateMomentsInCollectionMutationVariables>(UpdateMomentsInCollectionDocument, options);
      }
export type UpdateMomentsInCollectionMutationHookResult = ReturnType<typeof useUpdateMomentsInCollectionMutation>;
export type UpdateMomentsInCollectionMutationResult = Apollo.MutationResult<UpdateMomentsInCollectionMutation>;
export type UpdateMomentsInCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMomentsInCollectionMutation, UpdateMomentsInCollectionMutationVariables>;
export const GetMomentCollectionDocument = gql`
    query getMomentCollection($momentCollectionId: String, $organizationSlug: String, $momentCollectionSlug: String, $includeUnpublished: Boolean, $includeUnapproved: Boolean) {
  momentCollection(
    filter: {id: $momentCollectionId, organizationSlug: $organizationSlug, slug: $momentCollectionSlug}
  ) {
    id
    title
    moments(first: 100) {
      data {
        id
        ...PreviewMoment
      }
    }
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetMomentCollectionQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionQuery({
 *   variables: {
 *      momentCollectionId: // value for 'momentCollectionId'
 *      organizationSlug: // value for 'organizationSlug'
 *      momentCollectionSlug: // value for 'momentCollectionSlug'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetMomentCollectionQuery(baseOptions?: Apollo.QueryHookOptions<GetMomentCollectionQuery, GetMomentCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionQuery, GetMomentCollectionQueryVariables>(GetMomentCollectionDocument, options);
      }
export function useGetMomentCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionQuery, GetMomentCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionQuery, GetMomentCollectionQueryVariables>(GetMomentCollectionDocument, options);
        }
export type GetMomentCollectionQueryHookResult = ReturnType<typeof useGetMomentCollectionQuery>;
export type GetMomentCollectionLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionLazyQuery>;
export type GetMomentCollectionQueryResult = Apollo.QueryResult<GetMomentCollectionQuery, GetMomentCollectionQueryVariables>;
export const UpdateMomentCollectionDocument = gql`
    mutation updateMomentCollection($momentCollectionId: String!, $momentCollectionInput: PartialMomentCollectionInput, $includeUnpublished: Boolean = true, $includeUnapproved: Boolean = true) {
  updateMomentCollection(id: $momentCollectionId, input: $momentCollectionInput) {
    id
    title
    moments(first: 100) {
      data {
        id
        ...PreviewMoment
      }
    }
  }
}
    ${PreviewMomentFragmentDoc}`;
export type UpdateMomentCollectionMutationFn = Apollo.MutationFunction<UpdateMomentCollectionMutation, UpdateMomentCollectionMutationVariables>;

/**
 * __useUpdateMomentCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMomentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMomentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMomentCollectionMutation, { data, loading, error }] = useUpdateMomentCollectionMutation({
 *   variables: {
 *      momentCollectionId: // value for 'momentCollectionId'
 *      momentCollectionInput: // value for 'momentCollectionInput'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useUpdateMomentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMomentCollectionMutation, UpdateMomentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMomentCollectionMutation, UpdateMomentCollectionMutationVariables>(UpdateMomentCollectionDocument, options);
      }
export type UpdateMomentCollectionMutationHookResult = ReturnType<typeof useUpdateMomentCollectionMutation>;
export type UpdateMomentCollectionMutationResult = Apollo.MutationResult<UpdateMomentCollectionMutation>;
export type UpdateMomentCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMomentCollectionMutation, UpdateMomentCollectionMutationVariables>;
export const GetVideoMomentsDocument = gql`
    query getVideoMoments($videoId: String!, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  video(platform: TWITCH, id: $videoId) {
    id
    ... on TwitchVideo {
      moments(first: 100) {
        data {
          id
          ...PreviewMoment
        }
      }
    }
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetVideoMomentsQuery__
 *
 * To run a query within a React component, call `useGetVideoMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoMomentsQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetVideoMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetVideoMomentsQuery, GetVideoMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoMomentsQuery, GetVideoMomentsQueryVariables>(GetVideoMomentsDocument, options);
      }
export function useGetVideoMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoMomentsQuery, GetVideoMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoMomentsQuery, GetVideoMomentsQueryVariables>(GetVideoMomentsDocument, options);
        }
export type GetVideoMomentsQueryHookResult = ReturnType<typeof useGetVideoMomentsQuery>;
export type GetVideoMomentsLazyQueryHookResult = ReturnType<typeof useGetVideoMomentsLazyQuery>;
export type GetVideoMomentsQueryResult = Apollo.QueryResult<GetVideoMomentsQuery, GetVideoMomentsQueryVariables>;
export const GetMomentForViewerDocument = gql`
    query getMomentForViewer($momentId: String!, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  moment(filter: {id: $momentId}) {
    id
    ...PreviewMoment
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetMomentForViewerQuery__
 *
 * To run a query within a React component, call `useGetMomentForViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentForViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentForViewerQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetMomentForViewerQuery(baseOptions: Apollo.QueryHookOptions<GetMomentForViewerQuery, GetMomentForViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentForViewerQuery, GetMomentForViewerQueryVariables>(GetMomentForViewerDocument, options);
      }
export function useGetMomentForViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentForViewerQuery, GetMomentForViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentForViewerQuery, GetMomentForViewerQueryVariables>(GetMomentForViewerDocument, options);
        }
export type GetMomentForViewerQueryHookResult = ReturnType<typeof useGetMomentForViewerQuery>;
export type GetMomentForViewerLazyQueryHookResult = ReturnType<typeof useGetMomentForViewerLazyQuery>;
export type GetMomentForViewerQueryResult = Apollo.QueryResult<GetMomentForViewerQuery, GetMomentForViewerQueryVariables>;
export const SetMomentReadDocument = gql`
    mutation setMomentRead($momentId: String!) {
  setIsRead(contentType: MOMENT, contentId: $momentId)
}
    `;
export type SetMomentReadMutationFn = Apollo.MutationFunction<SetMomentReadMutation, SetMomentReadMutationVariables>;

/**
 * __useSetMomentReadMutation__
 *
 * To run a mutation, you first call `useSetMomentReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMomentReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMomentReadMutation, { data, loading, error }] = useSetMomentReadMutation({
 *   variables: {
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useSetMomentReadMutation(baseOptions?: Apollo.MutationHookOptions<SetMomentReadMutation, SetMomentReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMomentReadMutation, SetMomentReadMutationVariables>(SetMomentReadDocument, options);
      }
export type SetMomentReadMutationHookResult = ReturnType<typeof useSetMomentReadMutation>;
export type SetMomentReadMutationResult = Apollo.MutationResult<SetMomentReadMutation>;
export type SetMomentReadMutationOptions = Apollo.BaseMutationOptions<SetMomentReadMutation, SetMomentReadMutationVariables>;
export const SetEditApprovalDocument = gql`
    mutation setEditApproval($editId: String!, $nextApproval: Boolean!) {
  updateMomentEdit(id: $editId, input: {approved: $nextApproval}) {
    id
    approved
  }
}
    `;
export type SetEditApprovalMutationFn = Apollo.MutationFunction<SetEditApprovalMutation, SetEditApprovalMutationVariables>;

/**
 * __useSetEditApprovalMutation__
 *
 * To run a mutation, you first call `useSetEditApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEditApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEditApprovalMutation, { data, loading, error }] = useSetEditApprovalMutation({
 *   variables: {
 *      editId: // value for 'editId'
 *      nextApproval: // value for 'nextApproval'
 *   },
 * });
 */
export function useSetEditApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SetEditApprovalMutation, SetEditApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEditApprovalMutation, SetEditApprovalMutationVariables>(SetEditApprovalDocument, options);
      }
export type SetEditApprovalMutationHookResult = ReturnType<typeof useSetEditApprovalMutation>;
export type SetEditApprovalMutationResult = Apollo.MutationResult<SetEditApprovalMutation>;
export type SetEditApprovalMutationOptions = Apollo.BaseMutationOptions<SetEditApprovalMutation, SetEditApprovalMutationVariables>;
export const GetSearchResultsDocument = gql`
    query getSearchResults($search: String!) {
  channels(first: 10, filterBy: {name: {contains: $search}}, orderBy: {name: ASC}) {
    data {
      ...SearchResult
    }
  }
}
    ${SearchResultFragmentDoc}`;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
      }
export function useGetSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>;
export const GetRegionDocument = gql`
    query getRegion {
  viewer {
    id
    settings {
      region {
        value
      }
    }
  }
}
    `;

/**
 * __useGetRegionQuery__
 *
 * To run a query within a React component, call `useGetRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionQuery, GetRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionQuery, GetRegionQueryVariables>(GetRegionDocument, options);
      }
export function useGetRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionQuery, GetRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionQuery, GetRegionQueryVariables>(GetRegionDocument, options);
        }
export type GetRegionQueryHookResult = ReturnType<typeof useGetRegionQuery>;
export type GetRegionLazyQueryHookResult = ReturnType<typeof useGetRegionLazyQuery>;
export type GetRegionQueryResult = Apollo.QueryResult<GetRegionQuery, GetRegionQueryVariables>;
export const UpdateRegionDocument = gql`
    mutation updateRegion($region: Region!) {
  updateUserSettings(input: {region: {value: $region}}) {
    region {
      value
    }
  }
}
    `;
export type UpdateRegionMutationFn = Apollo.MutationFunction<UpdateRegionMutation, UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionMutation, UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const GetPostBuyMomentEditDocument = gql`
    query getPostBuyMomentEdit($id: String!) {
  momentEdit(filter: {id: $id}) {
    ...PostBuyEdit
  }
}
    ${PostBuyEditFragmentDoc}`;

/**
 * __useGetPostBuyMomentEditQuery__
 *
 * To run a query within a React component, call `useGetPostBuyMomentEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostBuyMomentEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostBuyMomentEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostBuyMomentEditQuery(baseOptions: Apollo.QueryHookOptions<GetPostBuyMomentEditQuery, GetPostBuyMomentEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostBuyMomentEditQuery, GetPostBuyMomentEditQueryVariables>(GetPostBuyMomentEditDocument, options);
      }
export function useGetPostBuyMomentEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostBuyMomentEditQuery, GetPostBuyMomentEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostBuyMomentEditQuery, GetPostBuyMomentEditQueryVariables>(GetPostBuyMomentEditDocument, options);
        }
export type GetPostBuyMomentEditQueryHookResult = ReturnType<typeof useGetPostBuyMomentEditQuery>;
export type GetPostBuyMomentEditLazyQueryHookResult = ReturnType<typeof useGetPostBuyMomentEditLazyQuery>;
export type GetPostBuyMomentEditQueryResult = Apollo.QueryResult<GetPostBuyMomentEditQuery, GetPostBuyMomentEditQueryVariables>;
export const GetVideoChatMomentsDocument = gql`
    query getVideoChatMoments($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    id
    ... on TwitchVideo {
      user {
        id
        displayName
      }
      vod {
        url
        resolution
      }
      stream {
        id
        thumbnailUrl
        startedAt
        endedAt
        allowedChatMomentTypes
      }
      moments(first: 100) {
        data {
          id
          ... on ChatMoment {
            ...DebugChatMoment
          }
        }
      }
    }
  }
}
    ${DebugChatMomentFragmentDoc}`;

/**
 * __useGetVideoChatMomentsQuery__
 *
 * To run a query within a React component, call `useGetVideoChatMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoChatMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoChatMomentsQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetVideoChatMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetVideoChatMomentsQuery, GetVideoChatMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoChatMomentsQuery, GetVideoChatMomentsQueryVariables>(GetVideoChatMomentsDocument, options);
      }
export function useGetVideoChatMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoChatMomentsQuery, GetVideoChatMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoChatMomentsQuery, GetVideoChatMomentsQueryVariables>(GetVideoChatMomentsDocument, options);
        }
export type GetVideoChatMomentsQueryHookResult = ReturnType<typeof useGetVideoChatMomentsQuery>;
export type GetVideoChatMomentsLazyQueryHookResult = ReturnType<typeof useGetVideoChatMomentsLazyQuery>;
export type GetVideoChatMomentsQueryResult = Apollo.QueryResult<GetVideoChatMomentsQuery, GetVideoChatMomentsQueryVariables>;
export const GetChannelChatDocument = gql`
    query getChannelChat($providerId: String!, $from: Date!, $to: Date!, $first: Int!, $after: String) {
  channel(filter: {platform: TWITCH, id: $providerId}) {
    platform
    id
    chatMessages(from: $from, to: $to, first: $first, after: $after) {
      pagination {
        endCursor
        hasNextPage
      }
      data {
        ...ChatMessage
      }
    }
  }
}
    ${ChatMessageFragmentDoc}`;

/**
 * __useGetChannelChatQuery__
 *
 * To run a query within a React component, call `useGetChannelChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelChatQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChannelChatQuery(baseOptions: Apollo.QueryHookOptions<GetChannelChatQuery, GetChannelChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelChatQuery, GetChannelChatQueryVariables>(GetChannelChatDocument, options);
      }
export function useGetChannelChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelChatQuery, GetChannelChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelChatQuery, GetChannelChatQueryVariables>(GetChannelChatDocument, options);
        }
export type GetChannelChatQueryHookResult = ReturnType<typeof useGetChannelChatQuery>;
export type GetChannelChatLazyQueryHookResult = ReturnType<typeof useGetChannelChatLazyQuery>;
export type GetChannelChatQueryResult = Apollo.QueryResult<GetChannelChatQuery, GetChannelChatQueryVariables>;
export const UpdateChatMessageShouldBeMatchingDocument = gql`
    mutation updateChatMessageShouldBeMatching($id: String!, $matching: [String!]) {
  setChatMessageShouldBeMatching(id: $id, shouldBeMatching: $matching) {
    ...ChatMessage
  }
}
    ${ChatMessageFragmentDoc}`;
export type UpdateChatMessageShouldBeMatchingMutationFn = Apollo.MutationFunction<UpdateChatMessageShouldBeMatchingMutation, UpdateChatMessageShouldBeMatchingMutationVariables>;

/**
 * __useUpdateChatMessageShouldBeMatchingMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageShouldBeMatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageShouldBeMatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMessageShouldBeMatchingMutation, { data, loading, error }] = useUpdateChatMessageShouldBeMatchingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      matching: // value for 'matching'
 *   },
 * });
 */
export function useUpdateChatMessageShouldBeMatchingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMessageShouldBeMatchingMutation, UpdateChatMessageShouldBeMatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMessageShouldBeMatchingMutation, UpdateChatMessageShouldBeMatchingMutationVariables>(UpdateChatMessageShouldBeMatchingDocument, options);
      }
export type UpdateChatMessageShouldBeMatchingMutationHookResult = ReturnType<typeof useUpdateChatMessageShouldBeMatchingMutation>;
export type UpdateChatMessageShouldBeMatchingMutationResult = Apollo.MutationResult<UpdateChatMessageShouldBeMatchingMutation>;
export type UpdateChatMessageShouldBeMatchingMutationOptions = Apollo.BaseMutationOptions<UpdateChatMessageShouldBeMatchingMutation, UpdateChatMessageShouldBeMatchingMutationVariables>;
export const GetOrganzationCampaignDetailsDocument = gql`
    query getOrganzationCampaignDetails($slug: String!) {
  organization(by: {slug: $slug}) {
    id
    campaigns {
      id
      title
      slug
      channelCampaignSegments {
        channel {
          id
          name
        }
        segments {
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganzationCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganzationCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganzationCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganzationCampaignDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganzationCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganzationCampaignDetailsQuery, GetOrganzationCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganzationCampaignDetailsQuery, GetOrganzationCampaignDetailsQueryVariables>(GetOrganzationCampaignDetailsDocument, options);
      }
export function useGetOrganzationCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganzationCampaignDetailsQuery, GetOrganzationCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganzationCampaignDetailsQuery, GetOrganzationCampaignDetailsQueryVariables>(GetOrganzationCampaignDetailsDocument, options);
        }
export type GetOrganzationCampaignDetailsQueryHookResult = ReturnType<typeof useGetOrganzationCampaignDetailsQuery>;
export type GetOrganzationCampaignDetailsLazyQueryHookResult = ReturnType<typeof useGetOrganzationCampaignDetailsLazyQuery>;
export type GetOrganzationCampaignDetailsQueryResult = Apollo.QueryResult<GetOrganzationCampaignDetailsQuery, GetOrganzationCampaignDetailsQueryVariables>;
export const GetSpecificChatMomentsDocument = gql`
    mutation getSpecificChatMoments($channelId: String!, $input: AnalyzeChannelInput!, $dryRun: Boolean!) {
  analyzeChannel(channelId: $channelId, input: $input, dryRun: $dryRun) {
    id
    ... on ChatMoment {
      ...DebugChatMoment
    }
  }
}
    ${DebugChatMomentFragmentDoc}`;
export type GetSpecificChatMomentsMutationFn = Apollo.MutationFunction<GetSpecificChatMomentsMutation, GetSpecificChatMomentsMutationVariables>;

/**
 * __useGetSpecificChatMomentsMutation__
 *
 * To run a mutation, you first call `useGetSpecificChatMomentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificChatMomentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSpecificChatMomentsMutation, { data, loading, error }] = useGetSpecificChatMomentsMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useGetSpecificChatMomentsMutation(baseOptions?: Apollo.MutationHookOptions<GetSpecificChatMomentsMutation, GetSpecificChatMomentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSpecificChatMomentsMutation, GetSpecificChatMomentsMutationVariables>(GetSpecificChatMomentsDocument, options);
      }
export type GetSpecificChatMomentsMutationHookResult = ReturnType<typeof useGetSpecificChatMomentsMutation>;
export type GetSpecificChatMomentsMutationResult = Apollo.MutationResult<GetSpecificChatMomentsMutation>;
export type GetSpecificChatMomentsMutationOptions = Apollo.BaseMutationOptions<GetSpecificChatMomentsMutation, GetSpecificChatMomentsMutationVariables>;
export const CreateManualSignalDocument = gql`
    mutation createManualSignal($input: ManualSignalInput!) {
  createManualSignal(input: $input) {
    id
  }
}
    `;
export type CreateManualSignalMutationFn = Apollo.MutationFunction<CreateManualSignalMutation, CreateManualSignalMutationVariables>;

/**
 * __useCreateManualSignalMutation__
 *
 * To run a mutation, you first call `useCreateManualSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualSignalMutation, { data, loading, error }] = useCreateManualSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualSignalMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualSignalMutation, CreateManualSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualSignalMutation, CreateManualSignalMutationVariables>(CreateManualSignalDocument, options);
      }
export type CreateManualSignalMutationHookResult = ReturnType<typeof useCreateManualSignalMutation>;
export type CreateManualSignalMutationResult = Apollo.MutationResult<CreateManualSignalMutation>;
export type CreateManualSignalMutationOptions = Apollo.BaseMutationOptions<CreateManualSignalMutation, CreateManualSignalMutationVariables>;
export const GetValorantMatchesByVideoIdDocument = gql`
    query getValorantMatchesByVideoId($videoId: String!) {
  video(id: $videoId, platform: TWITCH) {
    ... on TwitchVideo {
      user {
        linkedAccounts {
          ... on RiotAccount {
            puuid
          }
        }
      }
      valorantMatches {
        id
        startedAt
        endedAt
        type
      }
      relatedVideos {
        video {
          ... on TwitchVideo {
            id
            user {
              displayName
              linkedAccounts {
                ... on RiotAccount {
                  puuid
                }
              }
            }
          }
        }
        reasons {
          ... on PlayedInValorantMatches {
            valorantMatches {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetValorantMatchesByVideoIdQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchesByVideoIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchesByVideoIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchesByVideoIdQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetValorantMatchesByVideoIdQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchesByVideoIdQuery, GetValorantMatchesByVideoIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchesByVideoIdQuery, GetValorantMatchesByVideoIdQueryVariables>(GetValorantMatchesByVideoIdDocument, options);
      }
export function useGetValorantMatchesByVideoIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchesByVideoIdQuery, GetValorantMatchesByVideoIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchesByVideoIdQuery, GetValorantMatchesByVideoIdQueryVariables>(GetValorantMatchesByVideoIdDocument, options);
        }
export type GetValorantMatchesByVideoIdQueryHookResult = ReturnType<typeof useGetValorantMatchesByVideoIdQuery>;
export type GetValorantMatchesByVideoIdLazyQueryHookResult = ReturnType<typeof useGetValorantMatchesByVideoIdLazyQuery>;
export type GetValorantMatchesByVideoIdQueryResult = Apollo.QueryResult<GetValorantMatchesByVideoIdQuery, GetValorantMatchesByVideoIdQueryVariables>;
export const GetValorantMatchDetailsDocument = gql`
    query getValorantMatchDetails($valorantMatchId: String!) {
  valorantMatch(id: $valorantMatchId) {
    id
    startedAt
    players {
      account {
        id
      }
      agent
      gameName
      stats
      team
    }
  }
}
    `;

/**
 * __useGetValorantMatchDetailsQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchDetailsQuery({
 *   variables: {
 *      valorantMatchId: // value for 'valorantMatchId'
 *   },
 * });
 */
export function useGetValorantMatchDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchDetailsQuery, GetValorantMatchDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchDetailsQuery, GetValorantMatchDetailsQueryVariables>(GetValorantMatchDetailsDocument, options);
      }
export function useGetValorantMatchDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchDetailsQuery, GetValorantMatchDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchDetailsQuery, GetValorantMatchDetailsQueryVariables>(GetValorantMatchDetailsDocument, options);
        }
export type GetValorantMatchDetailsQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsQuery>;
export type GetValorantMatchDetailsLazyQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsLazyQuery>;
export type GetValorantMatchDetailsQueryResult = Apollo.QueryResult<GetValorantMatchDetailsQuery, GetValorantMatchDetailsQueryVariables>;
export const GetValorantMatchByRoundsDocument = gql`
    query getValorantMatchByRounds($valorantMatchId: String!) {
  valorantMatch(id: $valorantMatchId) {
    id
    startedAt
    endedAt
    roundResults {
      ...ValorantRound
    }
  }
}
    ${ValorantRoundFragmentDoc}`;

/**
 * __useGetValorantMatchByRoundsQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchByRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchByRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchByRoundsQuery({
 *   variables: {
 *      valorantMatchId: // value for 'valorantMatchId'
 *   },
 * });
 */
export function useGetValorantMatchByRoundsQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchByRoundsQuery, GetValorantMatchByRoundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchByRoundsQuery, GetValorantMatchByRoundsQueryVariables>(GetValorantMatchByRoundsDocument, options);
      }
export function useGetValorantMatchByRoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchByRoundsQuery, GetValorantMatchByRoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchByRoundsQuery, GetValorantMatchByRoundsQueryVariables>(GetValorantMatchByRoundsDocument, options);
        }
export type GetValorantMatchByRoundsQueryHookResult = ReturnType<typeof useGetValorantMatchByRoundsQuery>;
export type GetValorantMatchByRoundsLazyQueryHookResult = ReturnType<typeof useGetValorantMatchByRoundsLazyQuery>;
export type GetValorantMatchByRoundsQueryResult = Apollo.QueryResult<GetValorantMatchByRoundsQuery, GetValorantMatchByRoundsQueryVariables>;
export const GetRelatedVideoDataDocument = gql`
    query getRelatedVideoData($videoId: String!) {
  video(platform: TWITCH, id: $videoId) {
    id
    relatedVideos {
      video {
        ...SimpleRelatedVideoInfo
      }
      offset
      overlaps {
        from
        to
      }
    }
  }
}
    ${SimpleRelatedVideoInfoFragmentDoc}`;

/**
 * __useGetRelatedVideoDataQuery__
 *
 * To run a query within a React component, call `useGetRelatedVideoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedVideoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedVideoDataQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetRelatedVideoDataQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedVideoDataQuery, GetRelatedVideoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedVideoDataQuery, GetRelatedVideoDataQueryVariables>(GetRelatedVideoDataDocument, options);
      }
export function useGetRelatedVideoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedVideoDataQuery, GetRelatedVideoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedVideoDataQuery, GetRelatedVideoDataQueryVariables>(GetRelatedVideoDataDocument, options);
        }
export type GetRelatedVideoDataQueryHookResult = ReturnType<typeof useGetRelatedVideoDataQuery>;
export type GetRelatedVideoDataLazyQueryHookResult = ReturnType<typeof useGetRelatedVideoDataLazyQuery>;
export type GetRelatedVideoDataQueryResult = Apollo.QueryResult<GetRelatedVideoDataQuery, GetRelatedVideoDataQueryVariables>;
export const GetVideosInfoDocument = gql`
    query getVideosInfo($videoIds: [String!]!) {
  videos(first: 100, filter: {videoIds: $videoIds}) {
    data {
      ...SimpleRelatedVideoInfo
    }
  }
}
    ${SimpleRelatedVideoInfoFragmentDoc}`;

/**
 * __useGetVideosInfoQuery__
 *
 * To run a query within a React component, call `useGetVideosInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosInfoQuery({
 *   variables: {
 *      videoIds: // value for 'videoIds'
 *   },
 * });
 */
export function useGetVideosInfoQuery(baseOptions: Apollo.QueryHookOptions<GetVideosInfoQuery, GetVideosInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideosInfoQuery, GetVideosInfoQueryVariables>(GetVideosInfoDocument, options);
      }
export function useGetVideosInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideosInfoQuery, GetVideosInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideosInfoQuery, GetVideosInfoQueryVariables>(GetVideosInfoDocument, options);
        }
export type GetVideosInfoQueryHookResult = ReturnType<typeof useGetVideosInfoQuery>;
export type GetVideosInfoLazyQueryHookResult = ReturnType<typeof useGetVideosInfoLazyQuery>;
export type GetVideosInfoQueryResult = Apollo.QueryResult<GetVideosInfoQuery, GetVideosInfoQueryVariables>;
export const GetSignalPlayerVideoTimelineDocument = gql`
    query getSignalPlayerVideoTimeline($videoId: String!) {
  video(id: $videoId, platform: TWITCH) {
    id
    ... on TwitchVideo {
      id
      stream {
        id
        startedAt
        endedAt
      }
      user {
        id
        displayName
        profileImageUrl
      }
      moments(first: 40) {
        data {
          id
          ... on ChatMoment {
            id
            startsAt
            endsAt
            type
            metadata
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSignalPlayerVideoTimelineQuery__
 *
 * To run a query within a React component, call `useGetSignalPlayerVideoTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalPlayerVideoTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalPlayerVideoTimelineQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetSignalPlayerVideoTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetSignalPlayerVideoTimelineQuery, GetSignalPlayerVideoTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalPlayerVideoTimelineQuery, GetSignalPlayerVideoTimelineQueryVariables>(GetSignalPlayerVideoTimelineDocument, options);
      }
export function useGetSignalPlayerVideoTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalPlayerVideoTimelineQuery, GetSignalPlayerVideoTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalPlayerVideoTimelineQuery, GetSignalPlayerVideoTimelineQueryVariables>(GetSignalPlayerVideoTimelineDocument, options);
        }
export type GetSignalPlayerVideoTimelineQueryHookResult = ReturnType<typeof useGetSignalPlayerVideoTimelineQuery>;
export type GetSignalPlayerVideoTimelineLazyQueryHookResult = ReturnType<typeof useGetSignalPlayerVideoTimelineLazyQuery>;
export type GetSignalPlayerVideoTimelineQueryResult = Apollo.QueryResult<GetSignalPlayerVideoTimelineQuery, GetSignalPlayerVideoTimelineQueryVariables>;
export const GetMomentPreviewDocument = gql`
    query getMomentPreview($id: String!) {
  moment(filter: {id: $id}) {
    id
    title
    startsAt
    endsAt
    video {
      ... on TwitchVideo {
        id
        user {
          id
        }
        stream {
          startedAt
          endedAt
        }
      }
    }
    ... on ChatMoment {
      metadata
    }
  }
}
    `;

/**
 * __useGetMomentPreviewQuery__
 *
 * To run a query within a React component, call `useGetMomentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMomentPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetMomentPreviewQuery, GetMomentPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentPreviewQuery, GetMomentPreviewQueryVariables>(GetMomentPreviewDocument, options);
      }
export function useGetMomentPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentPreviewQuery, GetMomentPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentPreviewQuery, GetMomentPreviewQueryVariables>(GetMomentPreviewDocument, options);
        }
export type GetMomentPreviewQueryHookResult = ReturnType<typeof useGetMomentPreviewQuery>;
export type GetMomentPreviewLazyQueryHookResult = ReturnType<typeof useGetMomentPreviewLazyQuery>;
export type GetMomentPreviewQueryResult = Apollo.QueryResult<GetMomentPreviewQuery, GetMomentPreviewQueryVariables>;
export const GetSignalDetailDocument = gql`
    query getSignalDetail($id: String!) {
  moment(filter: {id: $id}) {
    id
    ...ReactionSignalDetail
    ...ManualSignalDetail
    ...ValorantSignalDetail
  }
}
    ${ReactionSignalDetailFragmentDoc}
${ManualSignalDetailFragmentDoc}
${ValorantSignalDetailFragmentDoc}`;

/**
 * __useGetSignalDetailQuery__
 *
 * To run a query within a React component, call `useGetSignalDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignalDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSignalDetailQuery, GetSignalDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalDetailQuery, GetSignalDetailQueryVariables>(GetSignalDetailDocument, options);
      }
export function useGetSignalDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalDetailQuery, GetSignalDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalDetailQuery, GetSignalDetailQueryVariables>(GetSignalDetailDocument, options);
        }
export type GetSignalDetailQueryHookResult = ReturnType<typeof useGetSignalDetailQuery>;
export type GetSignalDetailLazyQueryHookResult = ReturnType<typeof useGetSignalDetailLazyQuery>;
export type GetSignalDetailQueryResult = Apollo.QueryResult<GetSignalDetailQuery, GetSignalDetailQueryVariables>;
export const SetMomentRatingDocument = gql`
    mutation setMomentRating($momentId: String!, $rating: Rating!) {
  rateMoment(momentId: $momentId, input: {rating: $rating}) {
    user {
      id
    }
    rating
  }
}
    `;
export type SetMomentRatingMutationFn = Apollo.MutationFunction<SetMomentRatingMutation, SetMomentRatingMutationVariables>;

/**
 * __useSetMomentRatingMutation__
 *
 * To run a mutation, you first call `useSetMomentRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMomentRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMomentRatingMutation, { data, loading, error }] = useSetMomentRatingMutation({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useSetMomentRatingMutation(baseOptions?: Apollo.MutationHookOptions<SetMomentRatingMutation, SetMomentRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMomentRatingMutation, SetMomentRatingMutationVariables>(SetMomentRatingDocument, options);
      }
export type SetMomentRatingMutationHookResult = ReturnType<typeof useSetMomentRatingMutation>;
export type SetMomentRatingMutationResult = Apollo.MutationResult<SetMomentRatingMutation>;
export type SetMomentRatingMutationOptions = Apollo.BaseMutationOptions<SetMomentRatingMutation, SetMomentRatingMutationVariables>;
export const CreateMultiPerspectiveMomentFromReactionSignalDocument = gql`
    mutation createMultiPerspectiveMomentFromReactionSignal($createMultiPerspectiveMomentInput: MultiPerspectiveMomentInput!) {
  createMultiPerspectiveMoment(input: $createMultiPerspectiveMomentInput) {
    id
    ...ConnectedMoment
    ... on MultiPerspectiveMoment {
      signals {
        id
        ...ReactionSignalDetail
        ...ManualSignalDetail
        ...ValorantSignalDetail
      }
    }
  }
}
    ${ConnectedMomentFragmentDoc}
${ReactionSignalDetailFragmentDoc}
${ManualSignalDetailFragmentDoc}
${ValorantSignalDetailFragmentDoc}`;
export type CreateMultiPerspectiveMomentFromReactionSignalMutationFn = Apollo.MutationFunction<CreateMultiPerspectiveMomentFromReactionSignalMutation, CreateMultiPerspectiveMomentFromReactionSignalMutationVariables>;

/**
 * __useCreateMultiPerspectiveMomentFromReactionSignalMutation__
 *
 * To run a mutation, you first call `useCreateMultiPerspectiveMomentFromReactionSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiPerspectiveMomentFromReactionSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiPerspectiveMomentFromReactionSignalMutation, { data, loading, error }] = useCreateMultiPerspectiveMomentFromReactionSignalMutation({
 *   variables: {
 *      createMultiPerspectiveMomentInput: // value for 'createMultiPerspectiveMomentInput'
 *   },
 * });
 */
export function useCreateMultiPerspectiveMomentFromReactionSignalMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiPerspectiveMomentFromReactionSignalMutation, CreateMultiPerspectiveMomentFromReactionSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiPerspectiveMomentFromReactionSignalMutation, CreateMultiPerspectiveMomentFromReactionSignalMutationVariables>(CreateMultiPerspectiveMomentFromReactionSignalDocument, options);
      }
export type CreateMultiPerspectiveMomentFromReactionSignalMutationHookResult = ReturnType<typeof useCreateMultiPerspectiveMomentFromReactionSignalMutation>;
export type CreateMultiPerspectiveMomentFromReactionSignalMutationResult = Apollo.MutationResult<CreateMultiPerspectiveMomentFromReactionSignalMutation>;
export type CreateMultiPerspectiveMomentFromReactionSignalMutationOptions = Apollo.BaseMutationOptions<CreateMultiPerspectiveMomentFromReactionSignalMutation, CreateMultiPerspectiveMomentFromReactionSignalMutationVariables>;
export const UpdateMultiPerspectiveMomentFromReactionSignalDocument = gql`
    mutation updateMultiPerspectiveMomentFromReactionSignal($momentId: String!, $updateMultiPerspectiveMomentInput: PartialMultiPerspectiveMomentInput!) {
  updateMultiPerspectiveMoment(
    id: $momentId
    input: $updateMultiPerspectiveMomentInput
  ) {
    id
    ...ConnectedMoment
    ... on MultiPerspectiveMoment {
      signals {
        id
        ...ReactionSignalDetail
        ...ValorantSignalDetail
      }
    }
  }
}
    ${ConnectedMomentFragmentDoc}
${ReactionSignalDetailFragmentDoc}
${ValorantSignalDetailFragmentDoc}`;
export type UpdateMultiPerspectiveMomentFromReactionSignalMutationFn = Apollo.MutationFunction<UpdateMultiPerspectiveMomentFromReactionSignalMutation, UpdateMultiPerspectiveMomentFromReactionSignalMutationVariables>;

/**
 * __useUpdateMultiPerspectiveMomentFromReactionSignalMutation__
 *
 * To run a mutation, you first call `useUpdateMultiPerspectiveMomentFromReactionSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultiPerspectiveMomentFromReactionSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultiPerspectiveMomentFromReactionSignalMutation, { data, loading, error }] = useUpdateMultiPerspectiveMomentFromReactionSignalMutation({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      updateMultiPerspectiveMomentInput: // value for 'updateMultiPerspectiveMomentInput'
 *   },
 * });
 */
export function useUpdateMultiPerspectiveMomentFromReactionSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultiPerspectiveMomentFromReactionSignalMutation, UpdateMultiPerspectiveMomentFromReactionSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultiPerspectiveMomentFromReactionSignalMutation, UpdateMultiPerspectiveMomentFromReactionSignalMutationVariables>(UpdateMultiPerspectiveMomentFromReactionSignalDocument, options);
      }
export type UpdateMultiPerspectiveMomentFromReactionSignalMutationHookResult = ReturnType<typeof useUpdateMultiPerspectiveMomentFromReactionSignalMutation>;
export type UpdateMultiPerspectiveMomentFromReactionSignalMutationResult = Apollo.MutationResult<UpdateMultiPerspectiveMomentFromReactionSignalMutation>;
export type UpdateMultiPerspectiveMomentFromReactionSignalMutationOptions = Apollo.BaseMutationOptions<UpdateMultiPerspectiveMomentFromReactionSignalMutation, UpdateMultiPerspectiveMomentFromReactionSignalMutationVariables>;
export const GetConnectedMomentDocument = gql`
    query getConnectedMoment($momentId: String!) {
  moment(filter: {id: $momentId}) {
    id
    ...ConnectedMoment
  }
}
    ${ConnectedMomentFragmentDoc}`;

/**
 * __useGetConnectedMomentQuery__
 *
 * To run a query within a React component, call `useGetConnectedMomentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedMomentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedMomentQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useGetConnectedMomentQuery(baseOptions: Apollo.QueryHookOptions<GetConnectedMomentQuery, GetConnectedMomentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedMomentQuery, GetConnectedMomentQueryVariables>(GetConnectedMomentDocument, options);
      }
export function useGetConnectedMomentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedMomentQuery, GetConnectedMomentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedMomentQuery, GetConnectedMomentQueryVariables>(GetConnectedMomentDocument, options);
        }
export type GetConnectedMomentQueryHookResult = ReturnType<typeof useGetConnectedMomentQuery>;
export type GetConnectedMomentLazyQueryHookResult = ReturnType<typeof useGetConnectedMomentLazyQuery>;
export type GetConnectedMomentQueryResult = Apollo.QueryResult<GetConnectedMomentQuery, GetConnectedMomentQueryVariables>;
export const SetMultiPerspectiveMomentVideoOffsetDocument = gql`
    mutation setMultiPerspectiveMomentVideoOffset($fromVideoId: String!, $momentId: String!, $offsetsInput: OffsetsInput!, $toVideoId: String!) {
  setMultiPerspectiveMomentVideoOffset(
    fromVideoId: $fromVideoId
    momentId: $momentId
    offsets: $offsetsInput
    toVideoId: $toVideoId
  ) {
    id
  }
}
    `;
export type SetMultiPerspectiveMomentVideoOffsetMutationFn = Apollo.MutationFunction<SetMultiPerspectiveMomentVideoOffsetMutation, SetMultiPerspectiveMomentVideoOffsetMutationVariables>;

/**
 * __useSetMultiPerspectiveMomentVideoOffsetMutation__
 *
 * To run a mutation, you first call `useSetMultiPerspectiveMomentVideoOffsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMultiPerspectiveMomentVideoOffsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMultiPerspectiveMomentVideoOffsetMutation, { data, loading, error }] = useSetMultiPerspectiveMomentVideoOffsetMutation({
 *   variables: {
 *      fromVideoId: // value for 'fromVideoId'
 *      momentId: // value for 'momentId'
 *      offsetsInput: // value for 'offsetsInput'
 *      toVideoId: // value for 'toVideoId'
 *   },
 * });
 */
export function useSetMultiPerspectiveMomentVideoOffsetMutation(baseOptions?: Apollo.MutationHookOptions<SetMultiPerspectiveMomentVideoOffsetMutation, SetMultiPerspectiveMomentVideoOffsetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMultiPerspectiveMomentVideoOffsetMutation, SetMultiPerspectiveMomentVideoOffsetMutationVariables>(SetMultiPerspectiveMomentVideoOffsetDocument, options);
      }
export type SetMultiPerspectiveMomentVideoOffsetMutationHookResult = ReturnType<typeof useSetMultiPerspectiveMomentVideoOffsetMutation>;
export type SetMultiPerspectiveMomentVideoOffsetMutationResult = Apollo.MutationResult<SetMultiPerspectiveMomentVideoOffsetMutation>;
export type SetMultiPerspectiveMomentVideoOffsetMutationOptions = Apollo.BaseMutationOptions<SetMultiPerspectiveMomentVideoOffsetMutation, SetMultiPerspectiveMomentVideoOffsetMutationVariables>;
export const GetValorantMatchSyncDocument = gql`
    query getValorantMatchSync($matchId: String!) {
  valorantMatch(id: $matchId) {
    __typename
    id
    videoSyncData {
      ...MatchSyncFragment
    }
  }
}
    ${MatchSyncFragmentFragmentDoc}`;

/**
 * __useGetValorantMatchSyncQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchSyncQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetValorantMatchSyncQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchSyncQuery, GetValorantMatchSyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchSyncQuery, GetValorantMatchSyncQueryVariables>(GetValorantMatchSyncDocument, options);
      }
export function useGetValorantMatchSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchSyncQuery, GetValorantMatchSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchSyncQuery, GetValorantMatchSyncQueryVariables>(GetValorantMatchSyncDocument, options);
        }
export type GetValorantMatchSyncQueryHookResult = ReturnType<typeof useGetValorantMatchSyncQuery>;
export type GetValorantMatchSyncLazyQueryHookResult = ReturnType<typeof useGetValorantMatchSyncLazyQuery>;
export type GetValorantMatchSyncQueryResult = Apollo.QueryResult<GetValorantMatchSyncQuery, GetValorantMatchSyncQueryVariables>;
export const SetValorantMatchSyncDocument = gql`
    mutation setValorantMatchSync($matchId: String!, $videoId: String!, $matchStartTime: Date!) {
  setValorantMatchVideoSync(
    valorantMatchId: $matchId
    videoId: $videoId
    matchStartTime: $matchStartTime
  ) {
    ...MatchSyncFragment
  }
}
    ${MatchSyncFragmentFragmentDoc}`;
export type SetValorantMatchSyncMutationFn = Apollo.MutationFunction<SetValorantMatchSyncMutation, SetValorantMatchSyncMutationVariables>;

/**
 * __useSetValorantMatchSyncMutation__
 *
 * To run a mutation, you first call `useSetValorantMatchSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetValorantMatchSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setValorantMatchSyncMutation, { data, loading, error }] = useSetValorantMatchSyncMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      videoId: // value for 'videoId'
 *      matchStartTime: // value for 'matchStartTime'
 *   },
 * });
 */
export function useSetValorantMatchSyncMutation(baseOptions?: Apollo.MutationHookOptions<SetValorantMatchSyncMutation, SetValorantMatchSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetValorantMatchSyncMutation, SetValorantMatchSyncMutationVariables>(SetValorantMatchSyncDocument, options);
      }
export type SetValorantMatchSyncMutationHookResult = ReturnType<typeof useSetValorantMatchSyncMutation>;
export type SetValorantMatchSyncMutationResult = Apollo.MutationResult<SetValorantMatchSyncMutation>;
export type SetValorantMatchSyncMutationOptions = Apollo.BaseMutationOptions<SetValorantMatchSyncMutation, SetValorantMatchSyncMutationVariables>;
export const DeleteValorantMatchSyncDocument = gql`
    mutation deleteValorantMatchSync($matchId: String!, $videoId: String!) {
  deleteValorantMatchVideoSync(valorantMatchId: $matchId, videoId: $videoId) {
    ...MatchSyncFragment
  }
}
    ${MatchSyncFragmentFragmentDoc}`;
export type DeleteValorantMatchSyncMutationFn = Apollo.MutationFunction<DeleteValorantMatchSyncMutation, DeleteValorantMatchSyncMutationVariables>;

/**
 * __useDeleteValorantMatchSyncMutation__
 *
 * To run a mutation, you first call `useDeleteValorantMatchSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteValorantMatchSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteValorantMatchSyncMutation, { data, loading, error }] = useDeleteValorantMatchSyncMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useDeleteValorantMatchSyncMutation(baseOptions?: Apollo.MutationHookOptions<DeleteValorantMatchSyncMutation, DeleteValorantMatchSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteValorantMatchSyncMutation, DeleteValorantMatchSyncMutationVariables>(DeleteValorantMatchSyncDocument, options);
      }
export type DeleteValorantMatchSyncMutationHookResult = ReturnType<typeof useDeleteValorantMatchSyncMutation>;
export type DeleteValorantMatchSyncMutationResult = Apollo.MutationResult<DeleteValorantMatchSyncMutation>;
export type DeleteValorantMatchSyncMutationOptions = Apollo.BaseMutationOptions<DeleteValorantMatchSyncMutation, DeleteValorantMatchSyncMutationVariables>;
export const GetValorantMatchesByChannelDocument = gql`
    query getValorantMatchesByChannel($channelId: String!, $numVideos: Int = 10) {
  channel(filter: {id: $channelId, platform: TWITCH}) {
    id
    videos(first: $numVideos) {
      data {
        id
        title
        publishedAt
        valorantMatches {
          id
          startedAt
          endedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetValorantMatchesByChannelQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchesByChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchesByChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchesByChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      numVideos: // value for 'numVideos'
 *   },
 * });
 */
export function useGetValorantMatchesByChannelQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchesByChannelQuery, GetValorantMatchesByChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchesByChannelQuery, GetValorantMatchesByChannelQueryVariables>(GetValorantMatchesByChannelDocument, options);
      }
export function useGetValorantMatchesByChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchesByChannelQuery, GetValorantMatchesByChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchesByChannelQuery, GetValorantMatchesByChannelQueryVariables>(GetValorantMatchesByChannelDocument, options);
        }
export type GetValorantMatchesByChannelQueryHookResult = ReturnType<typeof useGetValorantMatchesByChannelQuery>;
export type GetValorantMatchesByChannelLazyQueryHookResult = ReturnType<typeof useGetValorantMatchesByChannelLazyQuery>;
export type GetValorantMatchesByChannelQueryResult = Apollo.QueryResult<GetValorantMatchesByChannelQuery, GetValorantMatchesByChannelQueryVariables>;
export const GetValorantMatchDetailsByChannelDocument = gql`
    query getValorantMatchDetailsByChannel($channelId: String!, $numVideos: Int = 10) {
  channel(filter: {id: $channelId, platform: TWITCH}) {
    id
    videos(first: $numVideos) {
      data {
        valorantMatches {
          ...ValorantMatchDetail
        }
      }
    }
  }
}
    ${ValorantMatchDetailFragmentDoc}`;

/**
 * __useGetValorantMatchDetailsByChannelQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchDetailsByChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchDetailsByChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchDetailsByChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      numVideos: // value for 'numVideos'
 *   },
 * });
 */
export function useGetValorantMatchDetailsByChannelQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchDetailsByChannelQuery, GetValorantMatchDetailsByChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchDetailsByChannelQuery, GetValorantMatchDetailsByChannelQueryVariables>(GetValorantMatchDetailsByChannelDocument, options);
      }
export function useGetValorantMatchDetailsByChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchDetailsByChannelQuery, GetValorantMatchDetailsByChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchDetailsByChannelQuery, GetValorantMatchDetailsByChannelQueryVariables>(GetValorantMatchDetailsByChannelDocument, options);
        }
export type GetValorantMatchDetailsByChannelQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByChannelQuery>;
export type GetValorantMatchDetailsByChannelLazyQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByChannelLazyQuery>;
export type GetValorantMatchDetailsByChannelQueryResult = Apollo.QueryResult<GetValorantMatchDetailsByChannelQuery, GetValorantMatchDetailsByChannelQueryVariables>;
export const GetValorantMatchDetailsByVideoDocument = gql`
    query getValorantMatchDetailsByVideo($videoId: String!) {
  video(id: $videoId, platform: TWITCH) {
    ... on TwitchVideo {
      user {
        linkedAccounts {
          ... on RiotAccount {
            valorantUserInfo {
              gameName
              tagLine
            }
          }
        }
      }
    }
    valorantMatches {
      ...ValorantMatchDetail
    }
  }
}
    ${ValorantMatchDetailFragmentDoc}`;

/**
 * __useGetValorantMatchDetailsByVideoQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchDetailsByVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchDetailsByVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchDetailsByVideoQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetValorantMatchDetailsByVideoQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchDetailsByVideoQuery, GetValorantMatchDetailsByVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchDetailsByVideoQuery, GetValorantMatchDetailsByVideoQueryVariables>(GetValorantMatchDetailsByVideoDocument, options);
      }
export function useGetValorantMatchDetailsByVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchDetailsByVideoQuery, GetValorantMatchDetailsByVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchDetailsByVideoQuery, GetValorantMatchDetailsByVideoQueryVariables>(GetValorantMatchDetailsByVideoDocument, options);
        }
export type GetValorantMatchDetailsByVideoQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByVideoQuery>;
export type GetValorantMatchDetailsByVideoLazyQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByVideoLazyQuery>;
export type GetValorantMatchDetailsByVideoQueryResult = Apollo.QueryResult<GetValorantMatchDetailsByVideoQuery, GetValorantMatchDetailsByVideoQueryVariables>;
export const GetValorantMatchPreviewDocument = gql`
    query getValorantMatchPreview($matchId: String!) {
  valorantMatch(id: $matchId) {
    ...ValorantMatchPreview
  }
}
    ${ValorantMatchPreviewFragmentDoc}`;

/**
 * __useGetValorantMatchPreviewQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchPreviewQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetValorantMatchPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchPreviewQuery, GetValorantMatchPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchPreviewQuery, GetValorantMatchPreviewQueryVariables>(GetValorantMatchPreviewDocument, options);
      }
export function useGetValorantMatchPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchPreviewQuery, GetValorantMatchPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchPreviewQuery, GetValorantMatchPreviewQueryVariables>(GetValorantMatchPreviewDocument, options);
        }
export type GetValorantMatchPreviewQueryHookResult = ReturnType<typeof useGetValorantMatchPreviewQuery>;
export type GetValorantMatchPreviewLazyQueryHookResult = ReturnType<typeof useGetValorantMatchPreviewLazyQuery>;
export type GetValorantMatchPreviewQueryResult = Apollo.QueryResult<GetValorantMatchPreviewQuery, GetValorantMatchPreviewQueryVariables>;
export const GetValorantMatchPageDetailDocument = gql`
    query getValorantMatchPageDetail($matchId: String!) {
  valorantMatch(id: $matchId) {
    ...ValorantMatchDetail
  }
}
    ${ValorantMatchDetailFragmentDoc}`;

/**
 * __useGetValorantMatchPageDetailQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchPageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchPageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchPageDetailQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetValorantMatchPageDetailQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchPageDetailQuery, GetValorantMatchPageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchPageDetailQuery, GetValorantMatchPageDetailQueryVariables>(GetValorantMatchPageDetailDocument, options);
      }
export function useGetValorantMatchPageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchPageDetailQuery, GetValorantMatchPageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchPageDetailQuery, GetValorantMatchPageDetailQueryVariables>(GetValorantMatchPageDetailDocument, options);
        }
export type GetValorantMatchPageDetailQueryHookResult = ReturnType<typeof useGetValorantMatchPageDetailQuery>;
export type GetValorantMatchPageDetailLazyQueryHookResult = ReturnType<typeof useGetValorantMatchPageDetailLazyQuery>;
export type GetValorantMatchPageDetailQueryResult = Apollo.QueryResult<GetValorantMatchPageDetailQuery, GetValorantMatchPageDetailQueryVariables>;
export const GetValorantMatchVideosDocument = gql`
    query getValorantMatchVideos($matchId: String!, $matchStart: Date!, $matchEnd: Date!) {
  valorantMatch(id: $matchId) {
    players {
      account {
        id
        channel {
          ... on TwitchUser {
            id
            displayName
            profileImageUrl
            streams(first: 1, filterBy: {overlaps: {from: $matchStart, to: $matchEnd}}) {
              data {
                id
                startedAt
                video {
                  id
                  ... on TwitchVideo {
                    mutedSegments {
                      duration
                      startsAt
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetValorantMatchVideosQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchVideosQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      matchStart: // value for 'matchStart'
 *      matchEnd: // value for 'matchEnd'
 *   },
 * });
 */
export function useGetValorantMatchVideosQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchVideosQuery, GetValorantMatchVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchVideosQuery, GetValorantMatchVideosQueryVariables>(GetValorantMatchVideosDocument, options);
      }
export function useGetValorantMatchVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchVideosQuery, GetValorantMatchVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchVideosQuery, GetValorantMatchVideosQueryVariables>(GetValorantMatchVideosDocument, options);
        }
export type GetValorantMatchVideosQueryHookResult = ReturnType<typeof useGetValorantMatchVideosQuery>;
export type GetValorantMatchVideosLazyQueryHookResult = ReturnType<typeof useGetValorantMatchVideosLazyQuery>;
export type GetValorantMatchVideosQueryResult = Apollo.QueryResult<GetValorantMatchVideosQuery, GetValorantMatchVideosQueryVariables>;
export const GetValorantMatchDetailsByChannelCollectionDocument = gql`
    query getValorantMatchDetailsByChannelCollection($collectionId: String!, $timeframe: TimeRangeFilterInput!) {
  channelCollection(filter: {id: $collectionId}) {
    id
    title
    slug
    channels(first: 100) {
      data {
        ... on TwitchUser {
          id
          name
          linkedAccounts {
            ... on RiotAccount {
              valorantUserInfo {
                gameName
                tagLine
              }
            }
          }
          videos(first: 100, filterBy: {publishedAt: $timeframe}) {
            data {
              valorantMatches {
                ...ValorantMatchDetail
              }
            }
          }
        }
      }
    }
  }
}
    ${ValorantMatchDetailFragmentDoc}`;

/**
 * __useGetValorantMatchDetailsByChannelCollectionQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchDetailsByChannelCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchDetailsByChannelCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchDetailsByChannelCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useGetValorantMatchDetailsByChannelCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchDetailsByChannelCollectionQuery, GetValorantMatchDetailsByChannelCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchDetailsByChannelCollectionQuery, GetValorantMatchDetailsByChannelCollectionQueryVariables>(GetValorantMatchDetailsByChannelCollectionDocument, options);
      }
export function useGetValorantMatchDetailsByChannelCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchDetailsByChannelCollectionQuery, GetValorantMatchDetailsByChannelCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchDetailsByChannelCollectionQuery, GetValorantMatchDetailsByChannelCollectionQueryVariables>(GetValorantMatchDetailsByChannelCollectionDocument, options);
        }
export type GetValorantMatchDetailsByChannelCollectionQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByChannelCollectionQuery>;
export type GetValorantMatchDetailsByChannelCollectionLazyQueryHookResult = ReturnType<typeof useGetValorantMatchDetailsByChannelCollectionLazyQuery>;
export type GetValorantMatchDetailsByChannelCollectionQueryResult = Apollo.QueryResult<GetValorantMatchDetailsByChannelCollectionQuery, GetValorantMatchDetailsByChannelCollectionQueryVariables>;
export const GetLeaderBoardRankingsDocument = gql`
    query getLeaderBoardRankings($accountIds: [String!], $before: Date!) {
  valorantLeaderboard(
    region: NA
    first: 10
    filterBy: {playerAccountIds: $accountIds}
    snapshotTakenAt: {before: $before}
  ) {
    data {
      account {
        id
        channel {
          id
        }
      }
      leaderboardRank
    }
  }
}
    `;

/**
 * __useGetLeaderBoardRankingsQuery__
 *
 * To run a query within a React component, call `useGetLeaderBoardRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderBoardRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderBoardRankingsQuery({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetLeaderBoardRankingsQuery(baseOptions: Apollo.QueryHookOptions<GetLeaderBoardRankingsQuery, GetLeaderBoardRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaderBoardRankingsQuery, GetLeaderBoardRankingsQueryVariables>(GetLeaderBoardRankingsDocument, options);
      }
export function useGetLeaderBoardRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderBoardRankingsQuery, GetLeaderBoardRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaderBoardRankingsQuery, GetLeaderBoardRankingsQueryVariables>(GetLeaderBoardRankingsDocument, options);
        }
export type GetLeaderBoardRankingsQueryHookResult = ReturnType<typeof useGetLeaderBoardRankingsQuery>;
export type GetLeaderBoardRankingsLazyQueryHookResult = ReturnType<typeof useGetLeaderBoardRankingsLazyQuery>;
export type GetLeaderBoardRankingsQueryResult = Apollo.QueryResult<GetLeaderBoardRankingsQuery, GetLeaderBoardRankingsQueryVariables>;
export const GetLeaderBoardRankingsAfterDocument = gql`
    query getLeaderBoardRankingsAfter($accountIds: [String!], $after: Date!) {
  valorantLeaderboard(
    region: NA
    first: 10
    filterBy: {playerAccountIds: $accountIds}
    snapshotTakenAt: {after: $after}
  ) {
    data {
      account {
        id
        channel {
          id
        }
      }
      leaderboardRank
    }
  }
}
    `;

/**
 * __useGetLeaderBoardRankingsAfterQuery__
 *
 * To run a query within a React component, call `useGetLeaderBoardRankingsAfterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderBoardRankingsAfterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderBoardRankingsAfterQuery({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetLeaderBoardRankingsAfterQuery(baseOptions: Apollo.QueryHookOptions<GetLeaderBoardRankingsAfterQuery, GetLeaderBoardRankingsAfterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaderBoardRankingsAfterQuery, GetLeaderBoardRankingsAfterQueryVariables>(GetLeaderBoardRankingsAfterDocument, options);
      }
export function useGetLeaderBoardRankingsAfterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderBoardRankingsAfterQuery, GetLeaderBoardRankingsAfterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaderBoardRankingsAfterQuery, GetLeaderBoardRankingsAfterQueryVariables>(GetLeaderBoardRankingsAfterDocument, options);
        }
export type GetLeaderBoardRankingsAfterQueryHookResult = ReturnType<typeof useGetLeaderBoardRankingsAfterQuery>;
export type GetLeaderBoardRankingsAfterLazyQueryHookResult = ReturnType<typeof useGetLeaderBoardRankingsAfterLazyQuery>;
export type GetLeaderBoardRankingsAfterQueryResult = Apollo.QueryResult<GetLeaderBoardRankingsAfterQuery, GetLeaderBoardRankingsAfterQueryVariables>;
export const GetVideoEditForAddonsDocument = gql`
    query getVideoEditForAddons($editId: String!) {
  momentEdit(filter: {id: $editId}) {
    id
    format {
      id
      aspectRatio {
        width
        height
      }
    }
    scenes {
      id
      index
      start
      end
      overlays {
        overlayType
        data
      }
      cropData {
        videoId
        title
        offset
        muted
      }
    }
    moment {
      id
      video {
        id
      }
    }
  }
}
    `;

/**
 * __useGetVideoEditForAddonsQuery__
 *
 * To run a query within a React component, call `useGetVideoEditForAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoEditForAddonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoEditForAddonsQuery({
 *   variables: {
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useGetVideoEditForAddonsQuery(baseOptions: Apollo.QueryHookOptions<GetVideoEditForAddonsQuery, GetVideoEditForAddonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoEditForAddonsQuery, GetVideoEditForAddonsQueryVariables>(GetVideoEditForAddonsDocument, options);
      }
export function useGetVideoEditForAddonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoEditForAddonsQuery, GetVideoEditForAddonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoEditForAddonsQuery, GetVideoEditForAddonsQueryVariables>(GetVideoEditForAddonsDocument, options);
        }
export type GetVideoEditForAddonsQueryHookResult = ReturnType<typeof useGetVideoEditForAddonsQuery>;
export type GetVideoEditForAddonsLazyQueryHookResult = ReturnType<typeof useGetVideoEditForAddonsLazyQuery>;
export type GetVideoEditForAddonsQueryResult = Apollo.QueryResult<GetVideoEditForAddonsQuery, GetVideoEditForAddonsQueryVariables>;
export const GetVideoExportDocument = gql`
    query getVideoExport($exportId: String!) {
  videoExport(id: $exportId) {
    id
    status
    momentEdit {
      id
      format {
        id
        aspectRatio {
          width
          height
        }
      }
      scenes {
        id
        index
        start
        end
        overlays {
          overlayType
          data
        }
      }
    }
    moment {
      id
      video {
        id
      }
    }
  }
}
    `;

/**
 * __useGetVideoExportQuery__
 *
 * To run a query within a React component, call `useGetVideoExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoExportQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetVideoExportQuery(baseOptions: Apollo.QueryHookOptions<GetVideoExportQuery, GetVideoExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoExportQuery, GetVideoExportQueryVariables>(GetVideoExportDocument, options);
      }
export function useGetVideoExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoExportQuery, GetVideoExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoExportQuery, GetVideoExportQueryVariables>(GetVideoExportDocument, options);
        }
export type GetVideoExportQueryHookResult = ReturnType<typeof useGetVideoExportQuery>;
export type GetVideoExportLazyQueryHookResult = ReturnType<typeof useGetVideoExportLazyQuery>;
export type GetVideoExportQueryResult = Apollo.QueryResult<GetVideoExportQuery, GetVideoExportQueryVariables>;
export const GetMomentsFromVideoSectionDocument = gql`
    query getMomentsFromVideoSection($channelId: String!, $startTime: Date!, $endTime: Date!) {
  moments(
    first: 100
    filter: {channelIds: [$channelId], startsAt: {from: $startTime, to: $endTime}, chat: {include: true}, manual: {include: true}}
    orderBy: {startsAt: ASC}
  ) {
    data {
      id
      ... on ChatMoment {
        id
        metadata
      }
    }
  }
}
    `;

/**
 * __useGetMomentsFromVideoSectionQuery__
 *
 * To run a query within a React component, call `useGetMomentsFromVideoSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentsFromVideoSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentsFromVideoSectionQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetMomentsFromVideoSectionQuery(baseOptions: Apollo.QueryHookOptions<GetMomentsFromVideoSectionQuery, GetMomentsFromVideoSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentsFromVideoSectionQuery, GetMomentsFromVideoSectionQueryVariables>(GetMomentsFromVideoSectionDocument, options);
      }
export function useGetMomentsFromVideoSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentsFromVideoSectionQuery, GetMomentsFromVideoSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentsFromVideoSectionQuery, GetMomentsFromVideoSectionQueryVariables>(GetMomentsFromVideoSectionDocument, options);
        }
export type GetMomentsFromVideoSectionQueryHookResult = ReturnType<typeof useGetMomentsFromVideoSectionQuery>;
export type GetMomentsFromVideoSectionLazyQueryHookResult = ReturnType<typeof useGetMomentsFromVideoSectionLazyQuery>;
export type GetMomentsFromVideoSectionQueryResult = Apollo.QueryResult<GetMomentsFromVideoSectionQuery, GetMomentsFromVideoSectionQueryVariables>;
export const GetAllChannelCollectionsDocument = gql`
    query getAllChannelCollections($first: Int!, $after: String) {
  channelCollections(first: $first, after: $after) {
    pagination {
      hasNextPage
      endCursor
    }
    data {
      ...ChannelCollectionRow
    }
  }
}
    ${ChannelCollectionRowFragmentDoc}`;

/**
 * __useGetAllChannelCollectionsQuery__
 *
 * To run a query within a React component, call `useGetAllChannelCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChannelCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChannelCollectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAllChannelCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllChannelCollectionsQuery, GetAllChannelCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChannelCollectionsQuery, GetAllChannelCollectionsQueryVariables>(GetAllChannelCollectionsDocument, options);
      }
export function useGetAllChannelCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChannelCollectionsQuery, GetAllChannelCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChannelCollectionsQuery, GetAllChannelCollectionsQueryVariables>(GetAllChannelCollectionsDocument, options);
        }
export type GetAllChannelCollectionsQueryHookResult = ReturnType<typeof useGetAllChannelCollectionsQuery>;
export type GetAllChannelCollectionsLazyQueryHookResult = ReturnType<typeof useGetAllChannelCollectionsLazyQuery>;
export type GetAllChannelCollectionsQueryResult = Apollo.QueryResult<GetAllChannelCollectionsQuery, GetAllChannelCollectionsQueryVariables>;
export const GetChannelCollectionChannelsDocument = gql`
    query getChannelCollectionChannels($slug: String!) {
  channelCollection(filter: {slug: $slug}) {
    ...ChannelCollectionDetails
  }
}
    ${ChannelCollectionDetailsFragmentDoc}`;

/**
 * __useGetChannelCollectionChannelsQuery__
 *
 * To run a query within a React component, call `useGetChannelCollectionChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelCollectionChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelCollectionChannelsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetChannelCollectionChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelCollectionChannelsQuery, GetChannelCollectionChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelCollectionChannelsQuery, GetChannelCollectionChannelsQueryVariables>(GetChannelCollectionChannelsDocument, options);
      }
export function useGetChannelCollectionChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelCollectionChannelsQuery, GetChannelCollectionChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelCollectionChannelsQuery, GetChannelCollectionChannelsQueryVariables>(GetChannelCollectionChannelsDocument, options);
        }
export type GetChannelCollectionChannelsQueryHookResult = ReturnType<typeof useGetChannelCollectionChannelsQuery>;
export type GetChannelCollectionChannelsLazyQueryHookResult = ReturnType<typeof useGetChannelCollectionChannelsLazyQuery>;
export type GetChannelCollectionChannelsQueryResult = Apollo.QueryResult<GetChannelCollectionChannelsQuery, GetChannelCollectionChannelsQueryVariables>;
export const UpdateChannelCollectionChannelsDocument = gql`
    mutation updateChannelCollectionChannels($collectionId: String!, $channelIds: [String!]!) {
  updateChannelCollection(id: $collectionId, input: {channelIds: $channelIds}) {
    ...ChannelCollectionDetails
  }
}
    ${ChannelCollectionDetailsFragmentDoc}`;
export type UpdateChannelCollectionChannelsMutationFn = Apollo.MutationFunction<UpdateChannelCollectionChannelsMutation, UpdateChannelCollectionChannelsMutationVariables>;

/**
 * __useUpdateChannelCollectionChannelsMutation__
 *
 * To run a mutation, you first call `useUpdateChannelCollectionChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelCollectionChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelCollectionChannelsMutation, { data, loading, error }] = useUpdateChannelCollectionChannelsMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function useUpdateChannelCollectionChannelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelCollectionChannelsMutation, UpdateChannelCollectionChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelCollectionChannelsMutation, UpdateChannelCollectionChannelsMutationVariables>(UpdateChannelCollectionChannelsDocument, options);
      }
export type UpdateChannelCollectionChannelsMutationHookResult = ReturnType<typeof useUpdateChannelCollectionChannelsMutation>;
export type UpdateChannelCollectionChannelsMutationResult = Apollo.MutationResult<UpdateChannelCollectionChannelsMutation>;
export type UpdateChannelCollectionChannelsMutationOptions = Apollo.BaseMutationOptions<UpdateChannelCollectionChannelsMutation, UpdateChannelCollectionChannelsMutationVariables>;
export const UpdateChannelCollectionChannelsPreviewDocument = gql`
    mutation updateChannelCollectionChannelsPreview($collectionId: String!, $channelIds: [String!]!) {
  updateChannelCollection(id: $collectionId, input: {channelIds: $channelIds}) {
    ...ChannelCollectionPreview
  }
}
    ${ChannelCollectionPreviewFragmentDoc}`;
export type UpdateChannelCollectionChannelsPreviewMutationFn = Apollo.MutationFunction<UpdateChannelCollectionChannelsPreviewMutation, UpdateChannelCollectionChannelsPreviewMutationVariables>;

/**
 * __useUpdateChannelCollectionChannelsPreviewMutation__
 *
 * To run a mutation, you first call `useUpdateChannelCollectionChannelsPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelCollectionChannelsPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelCollectionChannelsPreviewMutation, { data, loading, error }] = useUpdateChannelCollectionChannelsPreviewMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function useUpdateChannelCollectionChannelsPreviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelCollectionChannelsPreviewMutation, UpdateChannelCollectionChannelsPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelCollectionChannelsPreviewMutation, UpdateChannelCollectionChannelsPreviewMutationVariables>(UpdateChannelCollectionChannelsPreviewDocument, options);
      }
export type UpdateChannelCollectionChannelsPreviewMutationHookResult = ReturnType<typeof useUpdateChannelCollectionChannelsPreviewMutation>;
export type UpdateChannelCollectionChannelsPreviewMutationResult = Apollo.MutationResult<UpdateChannelCollectionChannelsPreviewMutation>;
export type UpdateChannelCollectionChannelsPreviewMutationOptions = Apollo.BaseMutationOptions<UpdateChannelCollectionChannelsPreviewMutation, UpdateChannelCollectionChannelsPreviewMutationVariables>;
export const GetAdminSearchChannelDocument = gql`
    query getAdminSearchChannel($first: Int!, $after: String, $search: String) {
  channels(
    first: $first
    after: $after
    filterBy: {name: {contains: $search}}
    orderBy: {name: ASC}
  ) {
    pagination {
      hasNextPage
      endCursor
      startCursor
      hasPrevPage
    }
    data {
      ...AdminSearchResult
    }
  }
}
    ${AdminSearchResultFragmentDoc}`;

/**
 * __useGetAdminSearchChannelQuery__
 *
 * To run a query within a React component, call `useGetAdminSearchChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminSearchChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminSearchChannelQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAdminSearchChannelQuery(baseOptions: Apollo.QueryHookOptions<GetAdminSearchChannelQuery, GetAdminSearchChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminSearchChannelQuery, GetAdminSearchChannelQueryVariables>(GetAdminSearchChannelDocument, options);
      }
export function useGetAdminSearchChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminSearchChannelQuery, GetAdminSearchChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminSearchChannelQuery, GetAdminSearchChannelQueryVariables>(GetAdminSearchChannelDocument, options);
        }
export type GetAdminSearchChannelQueryHookResult = ReturnType<typeof useGetAdminSearchChannelQuery>;
export type GetAdminSearchChannelLazyQueryHookResult = ReturnType<typeof useGetAdminSearchChannelLazyQuery>;
export type GetAdminSearchChannelQueryResult = Apollo.QueryResult<GetAdminSearchChannelQuery, GetAdminSearchChannelQueryVariables>;
export const UpdateTwitchUserChatStatusDocument = gql`
    mutation updateTwitchUserChatStatus($id: String!, $dontJoinChat: Boolean!) {
  updateTwitchUser(id: $id, input: {dontJoinChat: $dontJoinChat}) {
    ...AdminSearchResult
  }
}
    ${AdminSearchResultFragmentDoc}`;
export type UpdateTwitchUserChatStatusMutationFn = Apollo.MutationFunction<UpdateTwitchUserChatStatusMutation, UpdateTwitchUserChatStatusMutationVariables>;

/**
 * __useUpdateTwitchUserChatStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTwitchUserChatStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwitchUserChatStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTwitchUserChatStatusMutation, { data, loading, error }] = useUpdateTwitchUserChatStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dontJoinChat: // value for 'dontJoinChat'
 *   },
 * });
 */
export function useUpdateTwitchUserChatStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTwitchUserChatStatusMutation, UpdateTwitchUserChatStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTwitchUserChatStatusMutation, UpdateTwitchUserChatStatusMutationVariables>(UpdateTwitchUserChatStatusDocument, options);
      }
export type UpdateTwitchUserChatStatusMutationHookResult = ReturnType<typeof useUpdateTwitchUserChatStatusMutation>;
export type UpdateTwitchUserChatStatusMutationResult = Apollo.MutationResult<UpdateTwitchUserChatStatusMutation>;
export type UpdateTwitchUserChatStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTwitchUserChatStatusMutation, UpdateTwitchUserChatStatusMutationVariables>;
export const UpdateValorantSyncStatusDocument = gql`
    mutation updateValorantSyncStatus($id: String!, $autoSyncValorantMatches: Boolean!) {
  updateTwitchUser(
    id: $id
    input: {autoSyncValorantMatches: $autoSyncValorantMatches}
  ) {
    ...AdminSearchResult
  }
}
    ${AdminSearchResultFragmentDoc}`;
export type UpdateValorantSyncStatusMutationFn = Apollo.MutationFunction<UpdateValorantSyncStatusMutation, UpdateValorantSyncStatusMutationVariables>;

/**
 * __useUpdateValorantSyncStatusMutation__
 *
 * To run a mutation, you first call `useUpdateValorantSyncStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateValorantSyncStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateValorantSyncStatusMutation, { data, loading, error }] = useUpdateValorantSyncStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      autoSyncValorantMatches: // value for 'autoSyncValorantMatches'
 *   },
 * });
 */
export function useUpdateValorantSyncStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateValorantSyncStatusMutation, UpdateValorantSyncStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateValorantSyncStatusMutation, UpdateValorantSyncStatusMutationVariables>(UpdateValorantSyncStatusDocument, options);
      }
export type UpdateValorantSyncStatusMutationHookResult = ReturnType<typeof useUpdateValorantSyncStatusMutation>;
export type UpdateValorantSyncStatusMutationResult = Apollo.MutationResult<UpdateValorantSyncStatusMutation>;
export type UpdateValorantSyncStatusMutationOptions = Apollo.BaseMutationOptions<UpdateValorantSyncStatusMutation, UpdateValorantSyncStatusMutationVariables>;
export const GetTwitchUserSourceDocument = gql`
    query getTwitchUserSource($name: String!) {
  twitchUserSourceByName(name: $name) {
    ...AdminTwitchUserSource
  }
}
    ${AdminTwitchUserSourceFragmentDoc}`;

/**
 * __useGetTwitchUserSourceQuery__
 *
 * To run a query within a React component, call `useGetTwitchUserSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwitchUserSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwitchUserSourceQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTwitchUserSourceQuery(baseOptions: Apollo.QueryHookOptions<GetTwitchUserSourceQuery, GetTwitchUserSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwitchUserSourceQuery, GetTwitchUserSourceQueryVariables>(GetTwitchUserSourceDocument, options);
      }
export function useGetTwitchUserSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwitchUserSourceQuery, GetTwitchUserSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwitchUserSourceQuery, GetTwitchUserSourceQueryVariables>(GetTwitchUserSourceDocument, options);
        }
export type GetTwitchUserSourceQueryHookResult = ReturnType<typeof useGetTwitchUserSourceQuery>;
export type GetTwitchUserSourceLazyQueryHookResult = ReturnType<typeof useGetTwitchUserSourceLazyQuery>;
export type GetTwitchUserSourceQueryResult = Apollo.QueryResult<GetTwitchUserSourceQuery, GetTwitchUserSourceQueryVariables>;
export const AddTwitchUserDocument = gql`
    mutation addTwitchUser($id: String!, $name: String!) {
  addTwitchUser(id: $id, name: $name) {
    ...AdminSearchResult
  }
}
    ${AdminSearchResultFragmentDoc}`;
export type AddTwitchUserMutationFn = Apollo.MutationFunction<AddTwitchUserMutation, AddTwitchUserMutationVariables>;

/**
 * __useAddTwitchUserMutation__
 *
 * To run a mutation, you first call `useAddTwitchUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTwitchUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTwitchUserMutation, { data, loading, error }] = useAddTwitchUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddTwitchUserMutation(baseOptions?: Apollo.MutationHookOptions<AddTwitchUserMutation, AddTwitchUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTwitchUserMutation, AddTwitchUserMutationVariables>(AddTwitchUserDocument, options);
      }
export type AddTwitchUserMutationHookResult = ReturnType<typeof useAddTwitchUserMutation>;
export type AddTwitchUserMutationResult = Apollo.MutationResult<AddTwitchUserMutation>;
export type AddTwitchUserMutationOptions = Apollo.BaseMutationOptions<AddTwitchUserMutation, AddTwitchUserMutationVariables>;
export const GetValorantLeaderboardDocument = gql`
    query getValorantLeaderboard($region: ValorantRegion!, $first: Int!, $after: String) {
  valorantLeaderboard(region: $region, first: $first, after: $after) {
    data {
      ...ValorantLeaderboardPlayer
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${ValorantLeaderboardPlayerFragmentDoc}`;

/**
 * __useGetValorantLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetValorantLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantLeaderboardQuery({
 *   variables: {
 *      region: // value for 'region'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetValorantLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetValorantLeaderboardQuery, GetValorantLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantLeaderboardQuery, GetValorantLeaderboardQueryVariables>(GetValorantLeaderboardDocument, options);
      }
export function useGetValorantLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantLeaderboardQuery, GetValorantLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantLeaderboardQuery, GetValorantLeaderboardQueryVariables>(GetValorantLeaderboardDocument, options);
        }
export type GetValorantLeaderboardQueryHookResult = ReturnType<typeof useGetValorantLeaderboardQuery>;
export type GetValorantLeaderboardLazyQueryHookResult = ReturnType<typeof useGetValorantLeaderboardLazyQuery>;
export type GetValorantLeaderboardQueryResult = Apollo.QueryResult<GetValorantLeaderboardQuery, GetValorantLeaderboardQueryVariables>;
export const GetCurrentOrganizationDocument = gql`
    query getCurrentOrganization {
  viewer {
    id
    organization {
      id
      slug
      name
      roster(first: 100) {
        data {
          id
          name
          login
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentOrganizationQuery__
 *
 * To run a query within a React component, call `useGetCurrentOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>(GetCurrentOrganizationDocument, options);
      }
export function useGetCurrentOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>(GetCurrentOrganizationDocument, options);
        }
export type GetCurrentOrganizationQueryHookResult = ReturnType<typeof useGetCurrentOrganizationQuery>;
export type GetCurrentOrganizationLazyQueryHookResult = ReturnType<typeof useGetCurrentOrganizationLazyQuery>;
export type GetCurrentOrganizationQueryResult = Apollo.QueryResult<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>;
export const RedeemBetaKeyDocument = gql`
    mutation redeemBetaKey($betaKey: String!) {
  useBetaKey(betaKey: $betaKey) {
    id
    organization {
      id
      name
    }
  }
}
    `;
export type RedeemBetaKeyMutationFn = Apollo.MutationFunction<RedeemBetaKeyMutation, RedeemBetaKeyMutationVariables>;

/**
 * __useRedeemBetaKeyMutation__
 *
 * To run a mutation, you first call `useRedeemBetaKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemBetaKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemBetaKeyMutation, { data, loading, error }] = useRedeemBetaKeyMutation({
 *   variables: {
 *      betaKey: // value for 'betaKey'
 *   },
 * });
 */
export function useRedeemBetaKeyMutation(baseOptions?: Apollo.MutationHookOptions<RedeemBetaKeyMutation, RedeemBetaKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemBetaKeyMutation, RedeemBetaKeyMutationVariables>(RedeemBetaKeyDocument, options);
      }
export type RedeemBetaKeyMutationHookResult = ReturnType<typeof useRedeemBetaKeyMutation>;
export type RedeemBetaKeyMutationResult = Apollo.MutationResult<RedeemBetaKeyMutation>;
export type RedeemBetaKeyMutationOptions = Apollo.BaseMutationOptions<RedeemBetaKeyMutation, RedeemBetaKeyMutationVariables>;
export const GetCampaignViewerDocument = gql`
    query getCampaignViewer($slug: String!) {
  campaign(filter: {slug: $slug}) {
    id
    title
    slug
    channels {
      id
      title
      channels(first: 100) {
        data {
          id
          name
        }
      }
    }
    channelCampaignSegments {
      channel {
        id
      }
      segments {
        to
        from
      }
    }
    segments {
      title
      starts
      ends
    }
  }
}
    `;

/**
 * __useGetCampaignViewerQuery__
 *
 * To run a query within a React component, call `useGetCampaignViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignViewerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCampaignViewerQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignViewerQuery, GetCampaignViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignViewerQuery, GetCampaignViewerQueryVariables>(GetCampaignViewerDocument, options);
      }
export function useGetCampaignViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignViewerQuery, GetCampaignViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignViewerQuery, GetCampaignViewerQueryVariables>(GetCampaignViewerDocument, options);
        }
export type GetCampaignViewerQueryHookResult = ReturnType<typeof useGetCampaignViewerQuery>;
export type GetCampaignViewerLazyQueryHookResult = ReturnType<typeof useGetCampaignViewerLazyQuery>;
export type GetCampaignViewerQueryResult = Apollo.QueryResult<GetCampaignViewerQuery, GetCampaignViewerQueryVariables>;
export const GetCampaignViewerMomentsDocument = gql`
    query getCampaignViewerMoments($slug: String!, $channelIds: [String!], $timeframe: TimeRangeFilterInput, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  campaign(filter: {slug: $slug}) {
    id
    moments(
      groupBy: NONE
      first: 200
      filterBy: {channelIds: $channelIds, startsAt: $timeframe}
    ) {
      data {
        moment {
          id
          published
          ...PreviewMoment
        }
      }
    }
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetCampaignViewerMomentsQuery__
 *
 * To run a query within a React component, call `useGetCampaignViewerMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignViewerMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignViewerMomentsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      channelIds: // value for 'channelIds'
 *      timeframe: // value for 'timeframe'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetCampaignViewerMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignViewerMomentsQuery, GetCampaignViewerMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignViewerMomentsQuery, GetCampaignViewerMomentsQueryVariables>(GetCampaignViewerMomentsDocument, options);
      }
export function useGetCampaignViewerMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignViewerMomentsQuery, GetCampaignViewerMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignViewerMomentsQuery, GetCampaignViewerMomentsQueryVariables>(GetCampaignViewerMomentsDocument, options);
        }
export type GetCampaignViewerMomentsQueryHookResult = ReturnType<typeof useGetCampaignViewerMomentsQuery>;
export type GetCampaignViewerMomentsLazyQueryHookResult = ReturnType<typeof useGetCampaignViewerMomentsLazyQuery>;
export type GetCampaignViewerMomentsQueryResult = Apollo.QueryResult<GetCampaignViewerMomentsQuery, GetCampaignViewerMomentsQueryVariables>;
export const GetOrganizationCampaignsDocument = gql`
    query getOrganizationCampaigns($slug: String!) {
  organization(by: {slug: $slug}) {
    id
    campaigns {
      id
    }
  }
}
    `;

/**
 * __useGetOrganizationCampaignsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCampaignsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCampaignsQuery, GetOrganizationCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCampaignsQuery, GetOrganizationCampaignsQueryVariables>(GetOrganizationCampaignsDocument, options);
      }
export function useGetOrganizationCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCampaignsQuery, GetOrganizationCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCampaignsQuery, GetOrganizationCampaignsQueryVariables>(GetOrganizationCampaignsDocument, options);
        }
export type GetOrganizationCampaignsQueryHookResult = ReturnType<typeof useGetOrganizationCampaignsQuery>;
export type GetOrganizationCampaignsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCampaignsLazyQuery>;
export type GetOrganizationCampaignsQueryResult = Apollo.QueryResult<GetOrganizationCampaignsQuery, GetOrganizationCampaignsQueryVariables>;
export const ChannelCollectionDetailDocument = gql`
    query ChannelCollectionDetail($id: String) {
  channelCollection(filter: {id: $id}) {
    id
    title
    channels(first: 300) {
      data {
        id
        ... on TwitchUser {
          id
          login
          displayName
          profileImageUrl
        }
      }
    }
  }
}
    `;

/**
 * __useChannelCollectionDetailQuery__
 *
 * To run a query within a React component, call `useChannelCollectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelCollectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelCollectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChannelCollectionDetailQuery(baseOptions?: Apollo.QueryHookOptions<ChannelCollectionDetailQuery, ChannelCollectionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelCollectionDetailQuery, ChannelCollectionDetailQueryVariables>(ChannelCollectionDetailDocument, options);
      }
export function useChannelCollectionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelCollectionDetailQuery, ChannelCollectionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelCollectionDetailQuery, ChannelCollectionDetailQueryVariables>(ChannelCollectionDetailDocument, options);
        }
export type ChannelCollectionDetailQueryHookResult = ReturnType<typeof useChannelCollectionDetailQuery>;
export type ChannelCollectionDetailLazyQueryHookResult = ReturnType<typeof useChannelCollectionDetailLazyQuery>;
export type ChannelCollectionDetailQueryResult = Apollo.QueryResult<ChannelCollectionDetailQuery, ChannelCollectionDetailQueryVariables>;
export const GetChannelDocument = gql`
    query getChannel($name: String, $platform: StreamingPlatform!) {
  channel(filter: {name: $name, platform: $platform}) {
    id
    name
    ... on TwitchUser {
      login
      displayName
      offlineImageUrl
      profileImageUrl
      viewCount
    }
    linkedAccounts {
      ... on RiotAccount {
        id
        __typename
        valorantUserInfo {
          gameName
          tagLine
        }
      }
    }
  }
}
    `;

/**
 * __useGetChannelQuery__
 *
 * To run a query within a React component, call `useGetChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelQuery({
 *   variables: {
 *      name: // value for 'name'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetChannelQuery(baseOptions: Apollo.QueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
      }
export function useGetChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export type GetChannelQueryHookResult = ReturnType<typeof useGetChannelQuery>;
export type GetChannelLazyQueryHookResult = ReturnType<typeof useGetChannelLazyQuery>;
export type GetChannelQueryResult = Apollo.QueryResult<GetChannelQuery, GetChannelQueryVariables>;
export const GetChannelVideosDocument = gql`
    query getChannelVideos($channelId: String!, $platform: StreamingPlatform!, $first: Int!, $after: String) {
  channel(filter: {id: $channelId, platform: $platform}) {
    id
    videos(first: $first, after: $after) {
      data {
        id
        title
        publishedAt
        ... on TwitchVideo {
          id
          url
          thumbnailUrl
          stream {
            id
            endedAt
          }
        }
      }
      pagination {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetChannelVideosQuery__
 *
 * To run a query within a React component, call `useGetChannelVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelVideosQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      platform: // value for 'platform'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChannelVideosQuery(baseOptions: Apollo.QueryHookOptions<GetChannelVideosQuery, GetChannelVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelVideosQuery, GetChannelVideosQueryVariables>(GetChannelVideosDocument, options);
      }
export function useGetChannelVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelVideosQuery, GetChannelVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelVideosQuery, GetChannelVideosQueryVariables>(GetChannelVideosDocument, options);
        }
export type GetChannelVideosQueryHookResult = ReturnType<typeof useGetChannelVideosQuery>;
export type GetChannelVideosLazyQueryHookResult = ReturnType<typeof useGetChannelVideosLazyQuery>;
export type GetChannelVideosQueryResult = Apollo.QueryResult<GetChannelVideosQuery, GetChannelVideosQueryVariables>;
export const GetVideoDetailDocument = gql`
    query getVideoDetail($videoId: String!) {
  video(id: $videoId, platform: TWITCH) {
    id
    title
    publishedAt
    ... on TwitchVideo {
      id
      url
      thumbnailUrl
      stream {
        id
        startedAt
        endedAt
      }
    }
  }
}
    `;

/**
 * __useGetVideoDetailQuery__
 *
 * To run a query within a React component, call `useGetVideoDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoDetailQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetVideoDetailQuery(baseOptions: Apollo.QueryHookOptions<GetVideoDetailQuery, GetVideoDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoDetailQuery, GetVideoDetailQueryVariables>(GetVideoDetailDocument, options);
      }
export function useGetVideoDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoDetailQuery, GetVideoDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoDetailQuery, GetVideoDetailQueryVariables>(GetVideoDetailDocument, options);
        }
export type GetVideoDetailQueryHookResult = ReturnType<typeof useGetVideoDetailQuery>;
export type GetVideoDetailLazyQueryHookResult = ReturnType<typeof useGetVideoDetailLazyQuery>;
export type GetVideoDetailQueryResult = Apollo.QueryResult<GetVideoDetailQuery, GetVideoDetailQueryVariables>;
export const GetMatchesDocument = gql`
    query getMatches($accountIds: [String!]!, $first: Int!, $after: String) {
  valorantMatches(
    filterBy: {playerAccountIds: $accountIds, matchTypes: [UNRATED, COMPETITIVE, CUSTOM, PREMIER]}
    first: $first
    after: $after
  ) {
    data {
      id
      startedAt
      endedAt
      type
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMatchesQuery__
 *
 * To run a query within a React component, call `useGetMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesQuery({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
      }
export function useGetMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
        }
export type GetMatchesQueryHookResult = ReturnType<typeof useGetMatchesQuery>;
export type GetMatchesLazyQueryHookResult = ReturnType<typeof useGetMatchesLazyQuery>;
export type GetMatchesQueryResult = Apollo.QueryResult<GetMatchesQuery, GetMatchesQueryVariables>;
export const GetMatchDocument = gql`
    query getMatch($matchId: String!) {
  valorantMatch(id: $matchId) {
    id
    startedAt
    endedAt
    type
    map
  }
}
    `;

/**
 * __useGetMatchQuery__
 *
 * To run a query within a React component, call `useGetMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchQuery(baseOptions: Apollo.QueryHookOptions<GetMatchQuery, GetMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchQuery, GetMatchQueryVariables>(GetMatchDocument, options);
      }
export function useGetMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchQuery, GetMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchQuery, GetMatchQueryVariables>(GetMatchDocument, options);
        }
export type GetMatchQueryHookResult = ReturnType<typeof useGetMatchQuery>;
export type GetMatchLazyQueryHookResult = ReturnType<typeof useGetMatchLazyQuery>;
export type GetMatchQueryResult = Apollo.QueryResult<GetMatchQuery, GetMatchQueryVariables>;
export const GetFeedSignalsDocument = gql`
    query getFeedSignals($includeValorant: Boolean = true, $includeChat: Boolean = true, $channelIds: [String!]!, $minKills: Int, $reactionTypes: [String!], $agents: [ValorantAgent!], $roundCeremony: ValorantRoundCeremony, $maps: [ValorantMap!], $first: Int!, $after: String, $startsAt: TimeRangeFilterInput, $playersFilter: ValorantMomentPlayerFilter, $isUsed: Boolean, $tags: [String!]) {
  moments(
    filter: {channelIds: $channelIds, startsAt: $startsAt, isUsed: $isUsed, valorant: {include: $includeValorant, minKills: $minKills, roundCeremony: $roundCeremony, maps: $maps, agents: $agents, players: $playersFilter, tags: {include: {and: $tags}}}, manual: {include: true}, chat: {include: $includeChat, types: $reactionTypes}}
    orderBy: {startsAt: ASC}
    first: $first
    after: $after
  ) {
    data {
      ...FeedPreview
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${FeedPreviewFragmentDoc}`;

/**
 * __useGetFeedSignalsQuery__
 *
 * To run a query within a React component, call `useGetFeedSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedSignalsQuery({
 *   variables: {
 *      includeValorant: // value for 'includeValorant'
 *      includeChat: // value for 'includeChat'
 *      channelIds: // value for 'channelIds'
 *      minKills: // value for 'minKills'
 *      reactionTypes: // value for 'reactionTypes'
 *      agents: // value for 'agents'
 *      roundCeremony: // value for 'roundCeremony'
 *      maps: // value for 'maps'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startsAt: // value for 'startsAt'
 *      playersFilter: // value for 'playersFilter'
 *      isUsed: // value for 'isUsed'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetFeedSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedSignalsQuery, GetFeedSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedSignalsQuery, GetFeedSignalsQueryVariables>(GetFeedSignalsDocument, options);
      }
export function useGetFeedSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedSignalsQuery, GetFeedSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedSignalsQuery, GetFeedSignalsQueryVariables>(GetFeedSignalsDocument, options);
        }
export type GetFeedSignalsQueryHookResult = ReturnType<typeof useGetFeedSignalsQuery>;
export type GetFeedSignalsLazyQueryHookResult = ReturnType<typeof useGetFeedSignalsLazyQuery>;
export type GetFeedSignalsQueryResult = Apollo.QueryResult<GetFeedSignalsQuery, GetFeedSignalsQueryVariables>;
export const GetSignalTypeDocument = gql`
    query getSignalType($signalId: String!) {
  moment(filter: {id: $signalId}) {
    id
    __typename
  }
}
    `;

/**
 * __useGetSignalTypeQuery__
 *
 * To run a query within a React component, call `useGetSignalTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalTypeQuery({
 *   variables: {
 *      signalId: // value for 'signalId'
 *   },
 * });
 */
export function useGetSignalTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSignalTypeQuery, GetSignalTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalTypeQuery, GetSignalTypeQueryVariables>(GetSignalTypeDocument, options);
      }
export function useGetSignalTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalTypeQuery, GetSignalTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalTypeQuery, GetSignalTypeQueryVariables>(GetSignalTypeDocument, options);
        }
export type GetSignalTypeQueryHookResult = ReturnType<typeof useGetSignalTypeQuery>;
export type GetSignalTypeLazyQueryHookResult = ReturnType<typeof useGetSignalTypeLazyQuery>;
export type GetSignalTypeQueryResult = Apollo.QueryResult<GetSignalTypeQuery, GetSignalTypeQueryVariables>;
export const SyncMatchVideoDocument = gql`
    mutation syncMatchVideo($matchId: String!, $videoId: String!) {
  createValorantMatchVideoSync(
    input: {valorantMatchId: $matchId, videoId: $videoId}
  ) {
    match {
      id
    }
    video {
      id
    }
    status
    error
  }
}
    `;
export type SyncMatchVideoMutationFn = Apollo.MutationFunction<SyncMatchVideoMutation, SyncMatchVideoMutationVariables>;

/**
 * __useSyncMatchVideoMutation__
 *
 * To run a mutation, you first call `useSyncMatchVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMatchVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMatchVideoMutation, { data, loading, error }] = useSyncMatchVideoMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useSyncMatchVideoMutation(baseOptions?: Apollo.MutationHookOptions<SyncMatchVideoMutation, SyncMatchVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncMatchVideoMutation, SyncMatchVideoMutationVariables>(SyncMatchVideoDocument, options);
      }
export type SyncMatchVideoMutationHookResult = ReturnType<typeof useSyncMatchVideoMutation>;
export type SyncMatchVideoMutationResult = Apollo.MutationResult<SyncMatchVideoMutation>;
export type SyncMatchVideoMutationOptions = Apollo.BaseMutationOptions<SyncMatchVideoMutation, SyncMatchVideoMutationVariables>;
export const CollectionLoginDocument = gql`
    mutation collectionLogin($organizationSlug: String!, $collectionSlug: String!, $password: String!) {
  authenticateClient(
    type: COLLECTION
    organizationSlug: $organizationSlug
    collectionSlug: $collectionSlug
    password: $password
  ) {
    accessToken
  }
}
    `;
export type CollectionLoginMutationFn = Apollo.MutationFunction<CollectionLoginMutation, CollectionLoginMutationVariables>;

/**
 * __useCollectionLoginMutation__
 *
 * To run a mutation, you first call `useCollectionLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionLoginMutation, { data, loading, error }] = useCollectionLoginMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      collectionSlug: // value for 'collectionSlug'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCollectionLoginMutation(baseOptions?: Apollo.MutationHookOptions<CollectionLoginMutation, CollectionLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectionLoginMutation, CollectionLoginMutationVariables>(CollectionLoginDocument, options);
      }
export type CollectionLoginMutationHookResult = ReturnType<typeof useCollectionLoginMutation>;
export type CollectionLoginMutationResult = Apollo.MutationResult<CollectionLoginMutation>;
export type CollectionLoginMutationOptions = Apollo.BaseMutationOptions<CollectionLoginMutation, CollectionLoginMutationVariables>;
export const GetMomentCollectionBySlugDocument = gql`
    query getMomentCollectionBySlug($organizationSlug: String!, $collectionSlug: String!) {
  momentCollection(
    filter: {organizationSlug: $organizationSlug, slug: $collectionSlug}
  ) {
    id
    title
  }
}
    `;

/**
 * __useGetMomentCollectionBySlugQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionBySlugQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      collectionSlug: // value for 'collectionSlug'
 *   },
 * });
 */
export function useGetMomentCollectionBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetMomentCollectionBySlugQuery, GetMomentCollectionBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionBySlugQuery, GetMomentCollectionBySlugQueryVariables>(GetMomentCollectionBySlugDocument, options);
      }
export function useGetMomentCollectionBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionBySlugQuery, GetMomentCollectionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionBySlugQuery, GetMomentCollectionBySlugQueryVariables>(GetMomentCollectionBySlugDocument, options);
        }
export type GetMomentCollectionBySlugQueryHookResult = ReturnType<typeof useGetMomentCollectionBySlugQuery>;
export type GetMomentCollectionBySlugLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionBySlugLazyQuery>;
export type GetMomentCollectionBySlugQueryResult = Apollo.QueryResult<GetMomentCollectionBySlugQuery, GetMomentCollectionBySlugQueryVariables>;
export const UpdatePartialMomentsInCollectionDocument = gql`
    mutation updatePartialMomentsInCollection($collectionId: String!, $password: String, $title: String, $slug: String) {
  updateMomentCollection(
    id: $collectionId
    input: {slug: $slug, title: $title, password: $password}
  ) {
    ...MomentCollectionShort
  }
}
    ${MomentCollectionShortFragmentDoc}`;
export type UpdatePartialMomentsInCollectionMutationFn = Apollo.MutationFunction<UpdatePartialMomentsInCollectionMutation, UpdatePartialMomentsInCollectionMutationVariables>;

/**
 * __useUpdatePartialMomentsInCollectionMutation__
 *
 * To run a mutation, you first call `useUpdatePartialMomentsInCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartialMomentsInCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartialMomentsInCollectionMutation, { data, loading, error }] = useUpdatePartialMomentsInCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      password: // value for 'password'
 *      title: // value for 'title'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUpdatePartialMomentsInCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartialMomentsInCollectionMutation, UpdatePartialMomentsInCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartialMomentsInCollectionMutation, UpdatePartialMomentsInCollectionMutationVariables>(UpdatePartialMomentsInCollectionDocument, options);
      }
export type UpdatePartialMomentsInCollectionMutationHookResult = ReturnType<typeof useUpdatePartialMomentsInCollectionMutation>;
export type UpdatePartialMomentsInCollectionMutationResult = Apollo.MutationResult<UpdatePartialMomentsInCollectionMutation>;
export type UpdatePartialMomentsInCollectionMutationOptions = Apollo.BaseMutationOptions<UpdatePartialMomentsInCollectionMutation, UpdatePartialMomentsInCollectionMutationVariables>;
export const DeleteMomentCollectionDocument = gql`
    mutation deleteMomentCollection($id: String!) {
  deleteMomentCollection(id: $id) {
    id
  }
}
    `;
export type DeleteMomentCollectionMutationFn = Apollo.MutationFunction<DeleteMomentCollectionMutation, DeleteMomentCollectionMutationVariables>;

/**
 * __useDeleteMomentCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteMomentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMomentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMomentCollectionMutation, { data, loading, error }] = useDeleteMomentCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMomentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMomentCollectionMutation, DeleteMomentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMomentCollectionMutation, DeleteMomentCollectionMutationVariables>(DeleteMomentCollectionDocument, options);
      }
export type DeleteMomentCollectionMutationHookResult = ReturnType<typeof useDeleteMomentCollectionMutation>;
export type DeleteMomentCollectionMutationResult = Apollo.MutationResult<DeleteMomentCollectionMutation>;
export type DeleteMomentCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteMomentCollectionMutation, DeleteMomentCollectionMutationVariables>;
export const GetEventCollectionDocument = gql`
    query getEventCollection($collectionId: String!, $start: Date!, $end: Date!) {
  channelCollection(filter: {id: $collectionId}) {
    channels(first: 100) {
      data {
        id
        name
        streams(first: 10, filterBy: {overlaps: {from: $start, to: $end}}) {
          data {
            id
            startedAt
            endedAt
            ... on TwitchStream {
              video {
                ... on TwitchVideo {
                  id
                  relatedVideos {
                    reasons {
                      ... on CustomReason {
                        reason
                      }
                    }
                    video {
                      id
                    }
                    offset
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventCollectionQuery__
 *
 * To run a query within a React component, call `useGetEventCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetEventCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetEventCollectionQuery, GetEventCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventCollectionQuery, GetEventCollectionQueryVariables>(GetEventCollectionDocument, options);
      }
export function useGetEventCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventCollectionQuery, GetEventCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventCollectionQuery, GetEventCollectionQueryVariables>(GetEventCollectionDocument, options);
        }
export type GetEventCollectionQueryHookResult = ReturnType<typeof useGetEventCollectionQuery>;
export type GetEventCollectionLazyQueryHookResult = ReturnType<typeof useGetEventCollectionLazyQuery>;
export type GetEventCollectionQueryResult = Apollo.QueryResult<GetEventCollectionQuery, GetEventCollectionQueryVariables>;
export const AddRelatedVideoDocument = gql`
    mutation addRelatedVideo($primaryVideoId: String!, $secondaryVideoId: String!, $offset: Float!, $overlaps: [TimerangeInput!]!) {
  addRelatedVideo(
    mainVideoId: $primaryVideoId
    relatedVideoId: $secondaryVideoId
    input: {offset: $offset, overlaps: $overlaps, reason: "EventEditor"}
  ) {
    offset
  }
}
    `;
export type AddRelatedVideoMutationFn = Apollo.MutationFunction<AddRelatedVideoMutation, AddRelatedVideoMutationVariables>;

/**
 * __useAddRelatedVideoMutation__
 *
 * To run a mutation, you first call `useAddRelatedVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRelatedVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRelatedVideoMutation, { data, loading, error }] = useAddRelatedVideoMutation({
 *   variables: {
 *      primaryVideoId: // value for 'primaryVideoId'
 *      secondaryVideoId: // value for 'secondaryVideoId'
 *      offset: // value for 'offset'
 *      overlaps: // value for 'overlaps'
 *   },
 * });
 */
export function useAddRelatedVideoMutation(baseOptions?: Apollo.MutationHookOptions<AddRelatedVideoMutation, AddRelatedVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRelatedVideoMutation, AddRelatedVideoMutationVariables>(AddRelatedVideoDocument, options);
      }
export type AddRelatedVideoMutationHookResult = ReturnType<typeof useAddRelatedVideoMutation>;
export type AddRelatedVideoMutationResult = Apollo.MutationResult<AddRelatedVideoMutation>;
export type AddRelatedVideoMutationOptions = Apollo.BaseMutationOptions<AddRelatedVideoMutation, AddRelatedVideoMutationVariables>;
export const UpdateRelatedVideoDocument = gql`
    mutation updateRelatedVideo($primaryVideoId: String!, $secondaryVideoId: String!, $offset: Float!, $overlaps: [TimerangeInput!]!) {
  updateRelatedVideo(
    mainVideoId: $primaryVideoId
    relatedVideoId: $secondaryVideoId
    input: {offset: $offset, overlaps: $overlaps, reason: "EventEditor"}
  ) {
    offset
  }
}
    `;
export type UpdateRelatedVideoMutationFn = Apollo.MutationFunction<UpdateRelatedVideoMutation, UpdateRelatedVideoMutationVariables>;

/**
 * __useUpdateRelatedVideoMutation__
 *
 * To run a mutation, you first call `useUpdateRelatedVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRelatedVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRelatedVideoMutation, { data, loading, error }] = useUpdateRelatedVideoMutation({
 *   variables: {
 *      primaryVideoId: // value for 'primaryVideoId'
 *      secondaryVideoId: // value for 'secondaryVideoId'
 *      offset: // value for 'offset'
 *      overlaps: // value for 'overlaps'
 *   },
 * });
 */
export function useUpdateRelatedVideoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRelatedVideoMutation, UpdateRelatedVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRelatedVideoMutation, UpdateRelatedVideoMutationVariables>(UpdateRelatedVideoDocument, options);
      }
export type UpdateRelatedVideoMutationHookResult = ReturnType<typeof useUpdateRelatedVideoMutation>;
export type UpdateRelatedVideoMutationResult = Apollo.MutationResult<UpdateRelatedVideoMutation>;
export type UpdateRelatedVideoMutationOptions = Apollo.BaseMutationOptions<UpdateRelatedVideoMutation, UpdateRelatedVideoMutationVariables>;
export const GetContentFeedDocument = gql`
    query getContentFeed($channelIds: [String!]!, $rating: Rating, $first: Int!, $after: String, $startsAt: TimeRangeFilterInput, $sort: Sort = DESC) {
  moments(
    filter: {channelIds: $channelIds, multiPerspective: {include: true, minUserRating: $rating}, startsAt: $startsAt}
    orderBy: {startsAt: $sort}
    first: $first
    after: $after
  ) {
    data {
      ...FeedPreview
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${FeedPreviewFragmentDoc}`;

/**
 * __useGetContentFeedQuery__
 *
 * To run a query within a React component, call `useGetContentFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFeedQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      rating: // value for 'rating'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startsAt: // value for 'startsAt'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetContentFeedQuery(baseOptions: Apollo.QueryHookOptions<GetContentFeedQuery, GetContentFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFeedQuery, GetContentFeedQueryVariables>(GetContentFeedDocument, options);
      }
export function useGetContentFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFeedQuery, GetContentFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFeedQuery, GetContentFeedQueryVariables>(GetContentFeedDocument, options);
        }
export type GetContentFeedQueryHookResult = ReturnType<typeof useGetContentFeedQuery>;
export type GetContentFeedLazyQueryHookResult = ReturnType<typeof useGetContentFeedLazyQuery>;
export type GetContentFeedQueryResult = Apollo.QueryResult<GetContentFeedQuery, GetContentFeedQueryVariables>;
export const GetContentMomentDetailDocument = gql`
    query getContentMomentDetail($momentId: String!) {
  moment(filter: {id: $momentId}) {
    ...ContentMoment
  }
}
    ${ContentMomentFragmentDoc}`;

/**
 * __useGetContentMomentDetailQuery__
 *
 * To run a query within a React component, call `useGetContentMomentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentMomentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentMomentDetailQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useGetContentMomentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetContentMomentDetailQuery, GetContentMomentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentMomentDetailQuery, GetContentMomentDetailQueryVariables>(GetContentMomentDetailDocument, options);
      }
export function useGetContentMomentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentMomentDetailQuery, GetContentMomentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentMomentDetailQuery, GetContentMomentDetailQueryVariables>(GetContentMomentDetailDocument, options);
        }
export type GetContentMomentDetailQueryHookResult = ReturnType<typeof useGetContentMomentDetailQuery>;
export type GetContentMomentDetailLazyQueryHookResult = ReturnType<typeof useGetContentMomentDetailLazyQuery>;
export type GetContentMomentDetailQueryResult = Apollo.QueryResult<GetContentMomentDetailQuery, GetContentMomentDetailQueryVariables>;
export const GetMomentEditDetailsDocument = gql`
    query getMomentEditDetails($momentId: String!, $includeUnpublished: Boolean = false, $includeUnapproved: Boolean = true) {
  moment(filter: {id: $momentId}) {
    ...PreviewMoment
  }
}
    ${PreviewMomentFragmentDoc}`;

/**
 * __useGetMomentEditDetailsQuery__
 *
 * To run a query within a React component, call `useGetMomentEditDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentEditDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentEditDetailsQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      includeUnapproved: // value for 'includeUnapproved'
 *   },
 * });
 */
export function useGetMomentEditDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMomentEditDetailsQuery, GetMomentEditDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentEditDetailsQuery, GetMomentEditDetailsQueryVariables>(GetMomentEditDetailsDocument, options);
      }
export function useGetMomentEditDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentEditDetailsQuery, GetMomentEditDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentEditDetailsQuery, GetMomentEditDetailsQueryVariables>(GetMomentEditDetailsDocument, options);
        }
export type GetMomentEditDetailsQueryHookResult = ReturnType<typeof useGetMomentEditDetailsQuery>;
export type GetMomentEditDetailsLazyQueryHookResult = ReturnType<typeof useGetMomentEditDetailsLazyQuery>;
export type GetMomentEditDetailsQueryResult = Apollo.QueryResult<GetMomentEditDetailsQuery, GetMomentEditDetailsQueryVariables>;
export const FeedValorantMomentsDocument = gql`
    query feedValorantMoments($channelIds: [String!]!, $minKills: Int, $agents: [ValorantAgent!], $roundCeremony: ValorantRoundCeremony, $maps: [ValorantMap!], $first: Int!, $after: String, $startedAt: Date, $endedAt: Date, $startsAt: TimeRangeFilterInput, $playersFilter: ValorantMomentPlayerFilter, $isUsed: Boolean, $tags: [String!]) {
  moments(
    filter: {channelIds: $channelIds, startsAt: $startsAt, isUsed: $isUsed, valorant: {include: true, minKills: $minKills, roundCeremony: $roundCeremony, maps: $maps, agents: $agents, matchStartedAt: $startedAt, matchEndedAt: $endedAt, players: $playersFilter, tags: {include: {and: $tags}}}}
    orderBy: {startsAt: DESC}
    first: $first
    after: $after
  ) {
    data {
      ...FeedPreview
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${FeedPreviewFragmentDoc}`;

/**
 * __useFeedValorantMomentsQuery__
 *
 * To run a query within a React component, call `useFeedValorantMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedValorantMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedValorantMomentsQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      minKills: // value for 'minKills'
 *      agents: // value for 'agents'
 *      roundCeremony: // value for 'roundCeremony'
 *      maps: // value for 'maps'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startedAt: // value for 'startedAt'
 *      endedAt: // value for 'endedAt'
 *      startsAt: // value for 'startsAt'
 *      playersFilter: // value for 'playersFilter'
 *      isUsed: // value for 'isUsed'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useFeedValorantMomentsQuery(baseOptions: Apollo.QueryHookOptions<FeedValorantMomentsQuery, FeedValorantMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedValorantMomentsQuery, FeedValorantMomentsQueryVariables>(FeedValorantMomentsDocument, options);
      }
export function useFeedValorantMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedValorantMomentsQuery, FeedValorantMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedValorantMomentsQuery, FeedValorantMomentsQueryVariables>(FeedValorantMomentsDocument, options);
        }
export type FeedValorantMomentsQueryHookResult = ReturnType<typeof useFeedValorantMomentsQuery>;
export type FeedValorantMomentsLazyQueryHookResult = ReturnType<typeof useFeedValorantMomentsLazyQuery>;
export type FeedValorantMomentsQueryResult = Apollo.QueryResult<FeedValorantMomentsQuery, FeedValorantMomentsQueryVariables>;
export const GetFeedValorantSignalDocument = gql`
    query getFeedValorantSignal($signalId: String!) {
  moment(filter: {id: $signalId}) {
    ...FeedValorantMoment
  }
}
    ${FeedValorantMomentFragmentDoc}`;

/**
 * __useGetFeedValorantSignalQuery__
 *
 * To run a query within a React component, call `useGetFeedValorantSignalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedValorantSignalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedValorantSignalQuery({
 *   variables: {
 *      signalId: // value for 'signalId'
 *   },
 * });
 */
export function useGetFeedValorantSignalQuery(baseOptions: Apollo.QueryHookOptions<GetFeedValorantSignalQuery, GetFeedValorantSignalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedValorantSignalQuery, GetFeedValorantSignalQueryVariables>(GetFeedValorantSignalDocument, options);
      }
export function useGetFeedValorantSignalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedValorantSignalQuery, GetFeedValorantSignalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedValorantSignalQuery, GetFeedValorantSignalQueryVariables>(GetFeedValorantSignalDocument, options);
        }
export type GetFeedValorantSignalQueryHookResult = ReturnType<typeof useGetFeedValorantSignalQuery>;
export type GetFeedValorantSignalLazyQueryHookResult = ReturnType<typeof useGetFeedValorantSignalLazyQuery>;
export type GetFeedValorantSignalQueryResult = Apollo.QueryResult<GetFeedValorantSignalQuery, GetFeedValorantSignalQueryVariables>;
export const GetChannelCollectionDocument = gql`
    query getChannelCollection($id: String!) {
  channelCollection(filter: {id: $id}) {
    id
    ...ChannelCollectionPreview
  }
}
    ${ChannelCollectionPreviewFragmentDoc}`;

/**
 * __useGetChannelCollectionQuery__
 *
 * To run a query within a React component, call `useGetChannelCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChannelCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetChannelCollectionQuery, GetChannelCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelCollectionQuery, GetChannelCollectionQueryVariables>(GetChannelCollectionDocument, options);
      }
export function useGetChannelCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelCollectionQuery, GetChannelCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelCollectionQuery, GetChannelCollectionQueryVariables>(GetChannelCollectionDocument, options);
        }
export type GetChannelCollectionQueryHookResult = ReturnType<typeof useGetChannelCollectionQuery>;
export type GetChannelCollectionLazyQueryHookResult = ReturnType<typeof useGetChannelCollectionLazyQuery>;
export type GetChannelCollectionQueryResult = Apollo.QueryResult<GetChannelCollectionQuery, GetChannelCollectionQueryVariables>;
export const GetChannelCollectionsDocument = gql`
    query getChannelCollections($first: Int!, $collectionIds: [String!]) {
  channelCollections(first: $first, filterBy: {ids: $collectionIds}) {
    data {
      ...ChannelCollectionPreview
    }
  }
}
    ${ChannelCollectionPreviewFragmentDoc}`;

/**
 * __useGetChannelCollectionsQuery__
 *
 * To run a query within a React component, call `useGetChannelCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelCollectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      collectionIds: // value for 'collectionIds'
 *   },
 * });
 */
export function useGetChannelCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelCollectionsQuery, GetChannelCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelCollectionsQuery, GetChannelCollectionsQueryVariables>(GetChannelCollectionsDocument, options);
      }
export function useGetChannelCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelCollectionsQuery, GetChannelCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelCollectionsQuery, GetChannelCollectionsQueryVariables>(GetChannelCollectionsDocument, options);
        }
export type GetChannelCollectionsQueryHookResult = ReturnType<typeof useGetChannelCollectionsQuery>;
export type GetChannelCollectionsLazyQueryHookResult = ReturnType<typeof useGetChannelCollectionsLazyQuery>;
export type GetChannelCollectionsQueryResult = Apollo.QueryResult<GetChannelCollectionsQuery, GetChannelCollectionsQueryVariables>;
export const GetReactionFeedDocument = gql`
    query getReactionFeed($channelIds: [String!]!, $types: [String!], $first: Int!, $startsAt: TimeRangeFilterInput, $after: String, $sort: Sort = DESC) {
  moments(
    filter: {channelIds: $channelIds, startsAt: $startsAt, chat: {include: true, types: $types}}
    orderBy: {startsAt: $sort}
    first: $first
    after: $after
  ) {
    data {
      ...FeedPreview
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    ${FeedPreviewFragmentDoc}`;

/**
 * __useGetReactionFeedQuery__
 *
 * To run a query within a React component, call `useGetReactionFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionFeedQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      types: // value for 'types'
 *      first: // value for 'first'
 *      startsAt: // value for 'startsAt'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetReactionFeedQuery(baseOptions: Apollo.QueryHookOptions<GetReactionFeedQuery, GetReactionFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReactionFeedQuery, GetReactionFeedQueryVariables>(GetReactionFeedDocument, options);
      }
export function useGetReactionFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReactionFeedQuery, GetReactionFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReactionFeedQuery, GetReactionFeedQueryVariables>(GetReactionFeedDocument, options);
        }
export type GetReactionFeedQueryHookResult = ReturnType<typeof useGetReactionFeedQuery>;
export type GetReactionFeedLazyQueryHookResult = ReturnType<typeof useGetReactionFeedLazyQuery>;
export type GetReactionFeedQueryResult = Apollo.QueryResult<GetReactionFeedQuery, GetReactionFeedQueryVariables>;
export const GetReactionSignalDocument = gql`
    query getReactionSignal($signalId: String!) {
  moment(filter: {id: $signalId}) {
    ...ReactionFeedDetail
    ...ManualFeedDetail
  }
}
    ${ReactionFeedDetailFragmentDoc}
${ManualFeedDetailFragmentDoc}`;

/**
 * __useGetReactionSignalQuery__
 *
 * To run a query within a React component, call `useGetReactionSignalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionSignalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionSignalQuery({
 *   variables: {
 *      signalId: // value for 'signalId'
 *   },
 * });
 */
export function useGetReactionSignalQuery(baseOptions: Apollo.QueryHookOptions<GetReactionSignalQuery, GetReactionSignalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReactionSignalQuery, GetReactionSignalQueryVariables>(GetReactionSignalDocument, options);
      }
export function useGetReactionSignalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReactionSignalQuery, GetReactionSignalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReactionSignalQuery, GetReactionSignalQueryVariables>(GetReactionSignalDocument, options);
        }
export type GetReactionSignalQueryHookResult = ReturnType<typeof useGetReactionSignalQuery>;
export type GetReactionSignalLazyQueryHookResult = ReturnType<typeof useGetReactionSignalLazyQuery>;
export type GetReactionSignalQueryResult = Apollo.QueryResult<GetReactionSignalQuery, GetReactionSignalQueryVariables>;
export const GetChannelCollectionChatMomentsDocument = gql`
    query getChannelCollectionChatMoments($collectionId: String!, $timerange: TimeRangeFilterInput) {
  channelCollection(filter: {id: $collectionId}) {
    id
    title
    slug
    channels(first: 100) {
      data {
        ... on TwitchUser {
          id
          name
          profileImageUrl
          videos(filterBy: {publishedAt: $timerange}, first: 100) {
            data {
              id
              ... on TwitchVideo {
                valorantMatches {
                  id
                  startedAt
                  endedAt
                }
                moments(first: 100) {
                  data {
                    ...ReactionDetail
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ReactionDetailFragmentDoc}`;

/**
 * __useGetChannelCollectionChatMomentsQuery__
 *
 * To run a query within a React component, call `useGetChannelCollectionChatMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelCollectionChatMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelCollectionChatMomentsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      timerange: // value for 'timerange'
 *   },
 * });
 */
export function useGetChannelCollectionChatMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelCollectionChatMomentsQuery, GetChannelCollectionChatMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelCollectionChatMomentsQuery, GetChannelCollectionChatMomentsQueryVariables>(GetChannelCollectionChatMomentsDocument, options);
      }
export function useGetChannelCollectionChatMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelCollectionChatMomentsQuery, GetChannelCollectionChatMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelCollectionChatMomentsQuery, GetChannelCollectionChatMomentsQueryVariables>(GetChannelCollectionChatMomentsDocument, options);
        }
export type GetChannelCollectionChatMomentsQueryHookResult = ReturnType<typeof useGetChannelCollectionChatMomentsQuery>;
export type GetChannelCollectionChatMomentsLazyQueryHookResult = ReturnType<typeof useGetChannelCollectionChatMomentsLazyQuery>;
export type GetChannelCollectionChatMomentsQueryResult = Apollo.QueryResult<GetChannelCollectionChatMomentsQuery, GetChannelCollectionChatMomentsQueryVariables>;
export const GetMomentThumbnailDocument = gql`
    query getMomentThumbnail($id: String!) {
  moment(filter: {id: $id}) {
    id
    thumbnail
  }
}
    `;

/**
 * __useGetMomentThumbnailQuery__
 *
 * To run a query within a React component, call `useGetMomentThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentThumbnailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMomentThumbnailQuery(baseOptions: Apollo.QueryHookOptions<GetMomentThumbnailQuery, GetMomentThumbnailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentThumbnailQuery, GetMomentThumbnailQueryVariables>(GetMomentThumbnailDocument, options);
      }
export function useGetMomentThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentThumbnailQuery, GetMomentThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentThumbnailQuery, GetMomentThumbnailQueryVariables>(GetMomentThumbnailDocument, options);
        }
export type GetMomentThumbnailQueryHookResult = ReturnType<typeof useGetMomentThumbnailQuery>;
export type GetMomentThumbnailLazyQueryHookResult = ReturnType<typeof useGetMomentThumbnailLazyQuery>;
export type GetMomentThumbnailQueryResult = Apollo.QueryResult<GetMomentThumbnailQuery, GetMomentThumbnailQueryVariables>;
export const GetVideosWithGameSectionsDocument = gql`
    query getVideosWithGameSections($channelId: String!, $startTime: Date!, $endTime: Date!) {
  channel(filter: {id: $channelId, platform: TWITCH}) {
    id
    name
    ... on TwitchUser {
      profileImageUrl
    }
    streams(first: 10, filterBy: {startedAt: {from: $startTime, to: $endTime}}) {
      data {
        id
        ... on TwitchStream {
          startedAt
          endedAt
          gamesPlayed {
            startedAt
            game {
              id
            }
          }
          video {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetVideosWithGameSectionsQuery__
 *
 * To run a query within a React component, call `useGetVideosWithGameSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosWithGameSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosWithGameSectionsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetVideosWithGameSectionsQuery(baseOptions: Apollo.QueryHookOptions<GetVideosWithGameSectionsQuery, GetVideosWithGameSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideosWithGameSectionsQuery, GetVideosWithGameSectionsQueryVariables>(GetVideosWithGameSectionsDocument, options);
      }
export function useGetVideosWithGameSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideosWithGameSectionsQuery, GetVideosWithGameSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideosWithGameSectionsQuery, GetVideosWithGameSectionsQueryVariables>(GetVideosWithGameSectionsDocument, options);
        }
export type GetVideosWithGameSectionsQueryHookResult = ReturnType<typeof useGetVideosWithGameSectionsQuery>;
export type GetVideosWithGameSectionsLazyQueryHookResult = ReturnType<typeof useGetVideosWithGameSectionsLazyQuery>;
export type GetVideosWithGameSectionsQueryResult = Apollo.QueryResult<GetVideosWithGameSectionsQuery, GetVideosWithGameSectionsQueryVariables>;
export const GetMomentDetailDocument = gql`
    query getMomentDetail($momentId: String!) {
  moment(filter: {id: $momentId}) {
    ... on MultiPerspectiveMoment {
      ...MultiPerspectiveMomentDetail
    }
  }
}
    ${MultiPerspectiveMomentDetailFragmentDoc}`;

/**
 * __useGetMomentDetailQuery__
 *
 * To run a query within a React component, call `useGetMomentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentDetailQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useGetMomentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMomentDetailQuery, GetMomentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentDetailQuery, GetMomentDetailQueryVariables>(GetMomentDetailDocument, options);
      }
export function useGetMomentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentDetailQuery, GetMomentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentDetailQuery, GetMomentDetailQueryVariables>(GetMomentDetailDocument, options);
        }
export type GetMomentDetailQueryHookResult = ReturnType<typeof useGetMomentDetailQuery>;
export type GetMomentDetailLazyQueryHookResult = ReturnType<typeof useGetMomentDetailLazyQuery>;
export type GetMomentDetailQueryResult = Apollo.QueryResult<GetMomentDetailQuery, GetMomentDetailQueryVariables>;
export const AddEditToMomentDocument = gql`
    mutation AddEditToMoment($editInput: MomentEditInput!, $momentId: String!) {
  addMomentEditToMoment(input: $editInput, momentId: $momentId) {
    id
    moment {
      edits(first: 100) {
        ...MomentEdit
      }
    }
  }
}
    ${MomentEditFragmentDoc}`;
export type AddEditToMomentMutationFn = Apollo.MutationFunction<AddEditToMomentMutation, AddEditToMomentMutationVariables>;

/**
 * __useAddEditToMomentMutation__
 *
 * To run a mutation, you first call `useAddEditToMomentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditToMomentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditToMomentMutation, { data, loading, error }] = useAddEditToMomentMutation({
 *   variables: {
 *      editInput: // value for 'editInput'
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useAddEditToMomentMutation(baseOptions?: Apollo.MutationHookOptions<AddEditToMomentMutation, AddEditToMomentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditToMomentMutation, AddEditToMomentMutationVariables>(AddEditToMomentDocument, options);
      }
export type AddEditToMomentMutationHookResult = ReturnType<typeof useAddEditToMomentMutation>;
export type AddEditToMomentMutationResult = Apollo.MutationResult<AddEditToMomentMutation>;
export type AddEditToMomentMutationOptions = Apollo.BaseMutationOptions<AddEditToMomentMutation, AddEditToMomentMutationVariables>;
export const ExportMomentEditDocument = gql`
    mutation exportMomentEdit($exportMomentEdit: MomentEditInput!, $exportMomentId: String!) {
  exportMoment(edit: $exportMomentEdit, id: $exportMomentId) {
    id
    output {
      videos {
        resolution
        url
      }
      thumbnails {
        index
        url
      }
    }
    status
  }
}
    `;
export type ExportMomentEditMutationFn = Apollo.MutationFunction<ExportMomentEditMutation, ExportMomentEditMutationVariables>;

/**
 * __useExportMomentEditMutation__
 *
 * To run a mutation, you first call `useExportMomentEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMomentEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMomentEditMutation, { data, loading, error }] = useExportMomentEditMutation({
 *   variables: {
 *      exportMomentEdit: // value for 'exportMomentEdit'
 *      exportMomentId: // value for 'exportMomentId'
 *   },
 * });
 */
export function useExportMomentEditMutation(baseOptions?: Apollo.MutationHookOptions<ExportMomentEditMutation, ExportMomentEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMomentEditMutation, ExportMomentEditMutationVariables>(ExportMomentEditDocument, options);
      }
export type ExportMomentEditMutationHookResult = ReturnType<typeof useExportMomentEditMutation>;
export type ExportMomentEditMutationResult = Apollo.MutationResult<ExportMomentEditMutation>;
export type ExportMomentEditMutationOptions = Apollo.BaseMutationOptions<ExportMomentEditMutation, ExportMomentEditMutationVariables>;
export const ExportEditDocument = gql`
    mutation ExportEdit($editId: String!) {
  exportEdit(id: $editId) {
    status
  }
}
    `;
export type ExportEditMutationFn = Apollo.MutationFunction<ExportEditMutation, ExportEditMutationVariables>;

/**
 * __useExportEditMutation__
 *
 * To run a mutation, you first call `useExportEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEditMutation, { data, loading, error }] = useExportEditMutation({
 *   variables: {
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useExportEditMutation(baseOptions?: Apollo.MutationHookOptions<ExportEditMutation, ExportEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEditMutation, ExportEditMutationVariables>(ExportEditDocument, options);
      }
export type ExportEditMutationHookResult = ReturnType<typeof useExportEditMutation>;
export type ExportEditMutationResult = Apollo.MutationResult<ExportEditMutation>;
export type ExportEditMutationOptions = Apollo.BaseMutationOptions<ExportEditMutation, ExportEditMutationVariables>;
export const UpdateMomentEditDocument = gql`
    mutation updateMomentEdit($editId: String!, $editInput: PartialMomentEditInput!) {
  updateMomentEdit(id: $editId, input: $editInput) {
    id
  }
}
    `;
export type UpdateMomentEditMutationFn = Apollo.MutationFunction<UpdateMomentEditMutation, UpdateMomentEditMutationVariables>;

/**
 * __useUpdateMomentEditMutation__
 *
 * To run a mutation, you first call `useUpdateMomentEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMomentEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMomentEditMutation, { data, loading, error }] = useUpdateMomentEditMutation({
 *   variables: {
 *      editId: // value for 'editId'
 *      editInput: // value for 'editInput'
 *   },
 * });
 */
export function useUpdateMomentEditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMomentEditMutation, UpdateMomentEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMomentEditMutation, UpdateMomentEditMutationVariables>(UpdateMomentEditDocument, options);
      }
export type UpdateMomentEditMutationHookResult = ReturnType<typeof useUpdateMomentEditMutation>;
export type UpdateMomentEditMutationResult = Apollo.MutationResult<UpdateMomentEditMutation>;
export type UpdateMomentEditMutationOptions = Apollo.BaseMutationOptions<UpdateMomentEditMutation, UpdateMomentEditMutationVariables>;
export const GetMomentEditDocument = gql`
    query getMomentEdit($editId: String!) {
  momentEdit(filter: {id: $editId}) {
    id
    title
    format {
      ...Format
    }
    scenes {
      id
      ...Scene
    }
  }
}
    ${FormatFragmentDoc}
${SceneFragmentDoc}`;

/**
 * __useGetMomentEditQuery__
 *
 * To run a query within a React component, call `useGetMomentEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentEditQuery({
 *   variables: {
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useGetMomentEditQuery(baseOptions: Apollo.QueryHookOptions<GetMomentEditQuery, GetMomentEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentEditQuery, GetMomentEditQueryVariables>(GetMomentEditDocument, options);
      }
export function useGetMomentEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentEditQuery, GetMomentEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentEditQuery, GetMomentEditQueryVariables>(GetMomentEditDocument, options);
        }
export type GetMomentEditQueryHookResult = ReturnType<typeof useGetMomentEditQuery>;
export type GetMomentEditLazyQueryHookResult = ReturnType<typeof useGetMomentEditLazyQuery>;
export type GetMomentEditQueryResult = Apollo.QueryResult<GetMomentEditQuery, GetMomentEditQueryVariables>;
export const AddSceneDocument = gql`
    mutation addScene($editId: String!, $sceneInput: SceneInput!) {
  addSceneToMomentEdit(editId: $editId, scene: $sceneInput) {
    id
  }
}
    `;
export type AddSceneMutationFn = Apollo.MutationFunction<AddSceneMutation, AddSceneMutationVariables>;

/**
 * __useAddSceneMutation__
 *
 * To run a mutation, you first call `useAddSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSceneMutation, { data, loading, error }] = useAddSceneMutation({
 *   variables: {
 *      editId: // value for 'editId'
 *      sceneInput: // value for 'sceneInput'
 *   },
 * });
 */
export function useAddSceneMutation(baseOptions?: Apollo.MutationHookOptions<AddSceneMutation, AddSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSceneMutation, AddSceneMutationVariables>(AddSceneDocument, options);
      }
export type AddSceneMutationHookResult = ReturnType<typeof useAddSceneMutation>;
export type AddSceneMutationResult = Apollo.MutationResult<AddSceneMutation>;
export type AddSceneMutationOptions = Apollo.BaseMutationOptions<AddSceneMutation, AddSceneMutationVariables>;
export const UpdateSceneDocument = gql`
    mutation updateScene($sceneId: String!, $sceneInput: PartialSceneInput!) {
  updateScene(sceneId: $sceneId, input: $sceneInput) {
    id
  }
}
    `;
export type UpdateSceneMutationFn = Apollo.MutationFunction<UpdateSceneMutation, UpdateSceneMutationVariables>;

/**
 * __useUpdateSceneMutation__
 *
 * To run a mutation, you first call `useUpdateSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSceneMutation, { data, loading, error }] = useUpdateSceneMutation({
 *   variables: {
 *      sceneId: // value for 'sceneId'
 *      sceneInput: // value for 'sceneInput'
 *   },
 * });
 */
export function useUpdateSceneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSceneMutation, UpdateSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSceneMutation, UpdateSceneMutationVariables>(UpdateSceneDocument, options);
      }
export type UpdateSceneMutationHookResult = ReturnType<typeof useUpdateSceneMutation>;
export type UpdateSceneMutationResult = Apollo.MutationResult<UpdateSceneMutation>;
export type UpdateSceneMutationOptions = Apollo.BaseMutationOptions<UpdateSceneMutation, UpdateSceneMutationVariables>;
export const RemoveSceneDocument = gql`
    mutation removeScene($sceneId: String!) {
  removeScene(sceneId: $sceneId) {
    id
  }
}
    `;
export type RemoveSceneMutationFn = Apollo.MutationFunction<RemoveSceneMutation, RemoveSceneMutationVariables>;

/**
 * __useRemoveSceneMutation__
 *
 * To run a mutation, you first call `useRemoveSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSceneMutation, { data, loading, error }] = useRemoveSceneMutation({
 *   variables: {
 *      sceneId: // value for 'sceneId'
 *   },
 * });
 */
export function useRemoveSceneMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSceneMutation, RemoveSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSceneMutation, RemoveSceneMutationVariables>(RemoveSceneDocument, options);
      }
export type RemoveSceneMutationHookResult = ReturnType<typeof useRemoveSceneMutation>;
export type RemoveSceneMutationResult = Apollo.MutationResult<RemoveSceneMutation>;
export type RemoveSceneMutationOptions = Apollo.BaseMutationOptions<RemoveSceneMutation, RemoveSceneMutationVariables>;
export const SetMomentPublishedDocument = gql`
    mutation setMomentPublished($momentId: String!, $nextPublishStatus: Boolean!) {
  updateMultiPerspectiveMoment(
    id: $momentId
    input: {published: $nextPublishStatus}
  ) {
    id
    published
    publishedAt
  }
}
    `;
export type SetMomentPublishedMutationFn = Apollo.MutationFunction<SetMomentPublishedMutation, SetMomentPublishedMutationVariables>;

/**
 * __useSetMomentPublishedMutation__
 *
 * To run a mutation, you first call `useSetMomentPublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMomentPublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMomentPublishedMutation, { data, loading, error }] = useSetMomentPublishedMutation({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      nextPublishStatus: // value for 'nextPublishStatus'
 *   },
 * });
 */
export function useSetMomentPublishedMutation(baseOptions?: Apollo.MutationHookOptions<SetMomentPublishedMutation, SetMomentPublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMomentPublishedMutation, SetMomentPublishedMutationVariables>(SetMomentPublishedDocument, options);
      }
export type SetMomentPublishedMutationHookResult = ReturnType<typeof useSetMomentPublishedMutation>;
export type SetMomentPublishedMutationResult = Apollo.MutationResult<SetMomentPublishedMutation>;
export type SetMomentPublishedMutationOptions = Apollo.BaseMutationOptions<SetMomentPublishedMutation, SetMomentPublishedMutationVariables>;
export const SetMomentEditPublishedDocument = gql`
    mutation setMomentEditPublished($editId: String!, $nextPublishStatus: Boolean!) {
  updateMomentEdit(id: $editId, input: {published: $nextPublishStatus}) {
    id
    published
    publishedAt
  }
}
    `;
export type SetMomentEditPublishedMutationFn = Apollo.MutationFunction<SetMomentEditPublishedMutation, SetMomentEditPublishedMutationVariables>;

/**
 * __useSetMomentEditPublishedMutation__
 *
 * To run a mutation, you first call `useSetMomentEditPublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMomentEditPublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMomentEditPublishedMutation, { data, loading, error }] = useSetMomentEditPublishedMutation({
 *   variables: {
 *      editId: // value for 'editId'
 *      nextPublishStatus: // value for 'nextPublishStatus'
 *   },
 * });
 */
export function useSetMomentEditPublishedMutation(baseOptions?: Apollo.MutationHookOptions<SetMomentEditPublishedMutation, SetMomentEditPublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMomentEditPublishedMutation, SetMomentEditPublishedMutationVariables>(SetMomentEditPublishedDocument, options);
      }
export type SetMomentEditPublishedMutationHookResult = ReturnType<typeof useSetMomentEditPublishedMutation>;
export type SetMomentEditPublishedMutationResult = Apollo.MutationResult<SetMomentEditPublishedMutation>;
export type SetMomentEditPublishedMutationOptions = Apollo.BaseMutationOptions<SetMomentEditPublishedMutation, SetMomentEditPublishedMutationVariables>;
export const GetUserOrganizationRosterDocument = gql`
    query getUserOrganizationRoster($first: Int!, $after: String) {
  viewer {
    id
    organization {
      id
      roster(first: $first, after: $after, orderBy: {name: ASC}) {
        pagination {
          endCursor
          hasNextPage
        }
        data {
          id
          name
          profileImageUrl
          broadcasterType
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserOrganizationRosterQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationRosterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserOrganizationRosterQuery(baseOptions: Apollo.QueryHookOptions<GetUserOrganizationRosterQuery, GetUserOrganizationRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrganizationRosterQuery, GetUserOrganizationRosterQueryVariables>(GetUserOrganizationRosterDocument, options);
      }
export function useGetUserOrganizationRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrganizationRosterQuery, GetUserOrganizationRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrganizationRosterQuery, GetUserOrganizationRosterQueryVariables>(GetUserOrganizationRosterDocument, options);
        }
export type GetUserOrganizationRosterQueryHookResult = ReturnType<typeof useGetUserOrganizationRosterQuery>;
export type GetUserOrganizationRosterLazyQueryHookResult = ReturnType<typeof useGetUserOrganizationRosterLazyQuery>;
export type GetUserOrganizationRosterQueryResult = Apollo.QueryResult<GetUserOrganizationRosterQuery, GetUserOrganizationRosterQueryVariables>;
export const GetOrganizationBySlugDocument = gql`
    query getOrganizationBySlug($slug: String!) {
  organization(by: {slug: $slug}) {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetOrganizationBySlugQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options);
      }
export function useGetOrganizationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options);
        }
export type GetOrganizationBySlugQueryHookResult = ReturnType<typeof useGetOrganizationBySlugQuery>;
export type GetOrganizationBySlugLazyQueryHookResult = ReturnType<typeof useGetOrganizationBySlugLazyQuery>;
export type GetOrganizationBySlugQueryResult = Apollo.QueryResult<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>;
export const GetValorantLeaderboardSnapshotDocument = gql`
    query getValorantLeaderboardSnapshot($twitchUserIds: [String!]!, $snapshotTime: Date!) {
  valorantLeaderboard(
    first: 100
    region: NA
    filterBy: {twitchUserIds: $twitchUserIds}
    snapshotTakenAt: {after: $snapshotTime}
  ) {
    data {
      ...LeaderboardPlayer
    }
  }
}
    ${LeaderboardPlayerFragmentDoc}`;

/**
 * __useGetValorantLeaderboardSnapshotQuery__
 *
 * To run a query within a React component, call `useGetValorantLeaderboardSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantLeaderboardSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantLeaderboardSnapshotQuery({
 *   variables: {
 *      twitchUserIds: // value for 'twitchUserIds'
 *      snapshotTime: // value for 'snapshotTime'
 *   },
 * });
 */
export function useGetValorantLeaderboardSnapshotQuery(baseOptions: Apollo.QueryHookOptions<GetValorantLeaderboardSnapshotQuery, GetValorantLeaderboardSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantLeaderboardSnapshotQuery, GetValorantLeaderboardSnapshotQueryVariables>(GetValorantLeaderboardSnapshotDocument, options);
      }
export function useGetValorantLeaderboardSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantLeaderboardSnapshotQuery, GetValorantLeaderboardSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantLeaderboardSnapshotQuery, GetValorantLeaderboardSnapshotQueryVariables>(GetValorantLeaderboardSnapshotDocument, options);
        }
export type GetValorantLeaderboardSnapshotQueryHookResult = ReturnType<typeof useGetValorantLeaderboardSnapshotQuery>;
export type GetValorantLeaderboardSnapshotLazyQueryHookResult = ReturnType<typeof useGetValorantLeaderboardSnapshotLazyQuery>;
export type GetValorantLeaderboardSnapshotQueryResult = Apollo.QueryResult<GetValorantLeaderboardSnapshotQuery, GetValorantLeaderboardSnapshotQueryVariables>;
export const GetTwitchVideosDocument = gql`
    query getTwitchVideos($userId: String!, $start: Date!, $end: Date!) {
  channel(filter: {id: $userId, platform: TWITCH}) {
    id
    videos(first: 100, filterBy: {publishedAt: {from: $start, to: $end}}) {
      data {
        id
        ... on TwitchVideo {
          stream {
            startedAt
            endedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTwitchVideosQuery__
 *
 * To run a query within a React component, call `useGetTwitchVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwitchVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwitchVideosQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetTwitchVideosQuery(baseOptions: Apollo.QueryHookOptions<GetTwitchVideosQuery, GetTwitchVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwitchVideosQuery, GetTwitchVideosQueryVariables>(GetTwitchVideosDocument, options);
      }
export function useGetTwitchVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwitchVideosQuery, GetTwitchVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwitchVideosQuery, GetTwitchVideosQueryVariables>(GetTwitchVideosDocument, options);
        }
export type GetTwitchVideosQueryHookResult = ReturnType<typeof useGetTwitchVideosQuery>;
export type GetTwitchVideosLazyQueryHookResult = ReturnType<typeof useGetTwitchVideosLazyQuery>;
export type GetTwitchVideosQueryResult = Apollo.QueryResult<GetTwitchVideosQuery, GetTwitchVideosQueryVariables>;
export const GetValorantMatchesDocument = gql`
    query getValorantMatches($playerAccountIds: [String!]!, $start: Date!, $end: Date!, $first: Int!, $after: String) {
  valorantMatches(
    first: $first
    after: $after
    filterBy: {playerAccountIds: $playerAccountIds, startedAt: {from: $start, to: $end}, matchTypes: COMPETITIVE}
    orderBy: {startedAt: ASC}
  ) {
    pagination {
      hasNextPage
      endCursor
    }
    data {
      ...ValorantMatchDiscoveryPreview
    }
  }
}
    ${ValorantMatchDiscoveryPreviewFragmentDoc}`;

/**
 * __useGetValorantMatchesQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchesQuery({
 *   variables: {
 *      playerAccountIds: // value for 'playerAccountIds'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetValorantMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchesQuery, GetValorantMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchesQuery, GetValorantMatchesQueryVariables>(GetValorantMatchesDocument, options);
      }
export function useGetValorantMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchesQuery, GetValorantMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchesQuery, GetValorantMatchesQueryVariables>(GetValorantMatchesDocument, options);
        }
export type GetValorantMatchesQueryHookResult = ReturnType<typeof useGetValorantMatchesQuery>;
export type GetValorantMatchesLazyQueryHookResult = ReturnType<typeof useGetValorantMatchesLazyQuery>;
export type GetValorantMatchesQueryResult = Apollo.QueryResult<GetValorantMatchesQuery, GetValorantMatchesQueryVariables>;
export const GetValorantMatchHighlightDocument = gql`
    query getValorantMatchHighlight($matchId: String!) {
  valorantMatch(id: $matchId) {
    id
    startedAt
    endedAt
    map
    videoSyncData {
      video {
        id
      }
      matchStartTime
      status
    }
    players {
      ...ValorantMatchPlayerHighlight
    }
  }
}
    ${ValorantMatchPlayerHighlightFragmentDoc}`;

/**
 * __useGetValorantMatchHighlightQuery__
 *
 * To run a query within a React component, call `useGetValorantMatchHighlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorantMatchHighlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorantMatchHighlightQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetValorantMatchHighlightQuery(baseOptions: Apollo.QueryHookOptions<GetValorantMatchHighlightQuery, GetValorantMatchHighlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorantMatchHighlightQuery, GetValorantMatchHighlightQueryVariables>(GetValorantMatchHighlightDocument, options);
      }
export function useGetValorantMatchHighlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorantMatchHighlightQuery, GetValorantMatchHighlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorantMatchHighlightQuery, GetValorantMatchHighlightQueryVariables>(GetValorantMatchHighlightDocument, options);
        }
export type GetValorantMatchHighlightQueryHookResult = ReturnType<typeof useGetValorantMatchHighlightQuery>;
export type GetValorantMatchHighlightLazyQueryHookResult = ReturnType<typeof useGetValorantMatchHighlightLazyQuery>;
export type GetValorantMatchHighlightQueryResult = Apollo.QueryResult<GetValorantMatchHighlightQuery, GetValorantMatchHighlightQueryVariables>;
export const GetLinkedAccountsFromChannelCollectionDocument = gql`
    query getLinkedAccountsFromChannelCollection($slug: String!) {
  channelCollection(filter: {slug: $slug}) {
    id
    slug
    channels(first: 150) {
      data {
        id
        ... on TwitchUser {
          id
          viewCount
          displayName
        }
        linkedAccounts {
          id
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useGetLinkedAccountsFromChannelCollectionQuery__
 *
 * To run a query within a React component, call `useGetLinkedAccountsFromChannelCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedAccountsFromChannelCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedAccountsFromChannelCollectionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetLinkedAccountsFromChannelCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedAccountsFromChannelCollectionQuery, GetLinkedAccountsFromChannelCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedAccountsFromChannelCollectionQuery, GetLinkedAccountsFromChannelCollectionQueryVariables>(GetLinkedAccountsFromChannelCollectionDocument, options);
      }
export function useGetLinkedAccountsFromChannelCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedAccountsFromChannelCollectionQuery, GetLinkedAccountsFromChannelCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedAccountsFromChannelCollectionQuery, GetLinkedAccountsFromChannelCollectionQueryVariables>(GetLinkedAccountsFromChannelCollectionDocument, options);
        }
export type GetLinkedAccountsFromChannelCollectionQueryHookResult = ReturnType<typeof useGetLinkedAccountsFromChannelCollectionQuery>;
export type GetLinkedAccountsFromChannelCollectionLazyQueryHookResult = ReturnType<typeof useGetLinkedAccountsFromChannelCollectionLazyQuery>;
export type GetLinkedAccountsFromChannelCollectionQueryResult = Apollo.QueryResult<GetLinkedAccountsFromChannelCollectionQuery, GetLinkedAccountsFromChannelCollectionQueryVariables>;
export const GetCurrentOrganizationRosterDocument = gql`
    query getCurrentOrganizationRoster {
  viewer {
    id
    organization {
      id
      slug
      name
      roster(first: 100) {
        data {
          ...RosterPreviewUser
        }
      }
    }
  }
}
    ${RosterPreviewUserFragmentDoc}`;

/**
 * __useGetCurrentOrganizationRosterQuery__
 *
 * To run a query within a React component, call `useGetCurrentOrganizationRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentOrganizationRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentOrganizationRosterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentOrganizationRosterQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentOrganizationRosterQuery, GetCurrentOrganizationRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentOrganizationRosterQuery, GetCurrentOrganizationRosterQueryVariables>(GetCurrentOrganizationRosterDocument, options);
      }
export function useGetCurrentOrganizationRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentOrganizationRosterQuery, GetCurrentOrganizationRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentOrganizationRosterQuery, GetCurrentOrganizationRosterQueryVariables>(GetCurrentOrganizationRosterDocument, options);
        }
export type GetCurrentOrganizationRosterQueryHookResult = ReturnType<typeof useGetCurrentOrganizationRosterQuery>;
export type GetCurrentOrganizationRosterLazyQueryHookResult = ReturnType<typeof useGetCurrentOrganizationRosterLazyQuery>;
export type GetCurrentOrganizationRosterQueryResult = Apollo.QueryResult<GetCurrentOrganizationRosterQuery, GetCurrentOrganizationRosterQueryVariables>;
export const GetRecentMomentsDocument = gql`
    query getRecentMoments($channelIds: [String!], $first: Int!, $after: String) {
  moments(
    first: $first
    after: $after
    filter: {channelIds: $channelIds, multiPerspective: {include: true, mainVideoOnly: true}}
    orderBy: {startsAt: DESC}
  ) {
    pagination {
      hasNextPage
    }
    data {
      id
      ... on MultiPerspectiveMoment {
        signals {
          __typename
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentMomentsQuery__
 *
 * To run a query within a React component, call `useGetRecentMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentMomentsQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetRecentMomentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentMomentsQuery, GetRecentMomentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentMomentsQuery, GetRecentMomentsQueryVariables>(GetRecentMomentsDocument, options);
      }
export function useGetRecentMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentMomentsQuery, GetRecentMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentMomentsQuery, GetRecentMomentsQueryVariables>(GetRecentMomentsDocument, options);
        }
export type GetRecentMomentsQueryHookResult = ReturnType<typeof useGetRecentMomentsQuery>;
export type GetRecentMomentsLazyQueryHookResult = ReturnType<typeof useGetRecentMomentsLazyQuery>;
export type GetRecentMomentsQueryResult = Apollo.QueryResult<GetRecentMomentsQuery, GetRecentMomentsQueryVariables>;
export const GetMomentVideoPreviewDocument = gql`
    query getMomentVideoPreview($momentId: String!) {
  moment(filter: {id: $momentId}) {
    id
    ... on MultiPerspectiveMoment {
      edits(
        first: 1
        orderBy: {createdAt: ASC}
        filterBy: {includeUnpublished: true, includeUnapproved: true}
      ) {
        id
        exports(first: 1, orderBy: {createdAt: ASC}) {
          id
          output {
            videos {
              resolution
              url
            }
            thumbnails {
              index
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMomentVideoPreviewQuery__
 *
 * To run a query within a React component, call `useGetMomentVideoPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentVideoPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentVideoPreviewQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *   },
 * });
 */
export function useGetMomentVideoPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetMomentVideoPreviewQuery, GetMomentVideoPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentVideoPreviewQuery, GetMomentVideoPreviewQueryVariables>(GetMomentVideoPreviewDocument, options);
      }
export function useGetMomentVideoPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentVideoPreviewQuery, GetMomentVideoPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentVideoPreviewQuery, GetMomentVideoPreviewQueryVariables>(GetMomentVideoPreviewDocument, options);
        }
export type GetMomentVideoPreviewQueryHookResult = ReturnType<typeof useGetMomentVideoPreviewQuery>;
export type GetMomentVideoPreviewLazyQueryHookResult = ReturnType<typeof useGetMomentVideoPreviewLazyQuery>;
export type GetMomentVideoPreviewQueryResult = Apollo.QueryResult<GetMomentVideoPreviewQuery, GetMomentVideoPreviewQueryVariables>;
export const GetChannelInfoDocument = gql`
    query getChannelInfo($channelName: String!) {
  channel(filter: {name: $channelName, platform: TWITCH}) {
    id
    ... on TwitchUser {
      login
      displayName
      profileImageUrl
    }
  }
}
    `;

/**
 * __useGetChannelInfoQuery__
 *
 * To run a query within a React component, call `useGetChannelInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInfoQuery({
 *   variables: {
 *      channelName: // value for 'channelName'
 *   },
 * });
 */
export function useGetChannelInfoQuery(baseOptions: Apollo.QueryHookOptions<GetChannelInfoQuery, GetChannelInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelInfoQuery, GetChannelInfoQueryVariables>(GetChannelInfoDocument, options);
      }
export function useGetChannelInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelInfoQuery, GetChannelInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelInfoQuery, GetChannelInfoQueryVariables>(GetChannelInfoDocument, options);
        }
export type GetChannelInfoQueryHookResult = ReturnType<typeof useGetChannelInfoQuery>;
export type GetChannelInfoLazyQueryHookResult = ReturnType<typeof useGetChannelInfoLazyQuery>;
export type GetChannelInfoQueryResult = Apollo.QueryResult<GetChannelInfoQuery, GetChannelInfoQueryVariables>;
export const GetChatMomentsForVideoDocument = gql`
    query getChatMomentsForVideo($channelId: String!, $videoStart: Date!, $videoEnd: Date!) {
  moments(
    first: 100
    filter: {channelIds: [$channelId], chat: {include: true}, startsAt: {from: $videoStart, to: $videoEnd}}
  ) {
    data {
      id
      ... on ChatMoment {
        metadata
      }
    }
  }
}
    `;

/**
 * __useGetChatMomentsForVideoQuery__
 *
 * To run a query within a React component, call `useGetChatMomentsForVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMomentsForVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMomentsForVideoQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      videoStart: // value for 'videoStart'
 *      videoEnd: // value for 'videoEnd'
 *   },
 * });
 */
export function useGetChatMomentsForVideoQuery(baseOptions: Apollo.QueryHookOptions<GetChatMomentsForVideoQuery, GetChatMomentsForVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMomentsForVideoQuery, GetChatMomentsForVideoQueryVariables>(GetChatMomentsForVideoDocument, options);
      }
export function useGetChatMomentsForVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMomentsForVideoQuery, GetChatMomentsForVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMomentsForVideoQuery, GetChatMomentsForVideoQueryVariables>(GetChatMomentsForVideoDocument, options);
        }
export type GetChatMomentsForVideoQueryHookResult = ReturnType<typeof useGetChatMomentsForVideoQuery>;
export type GetChatMomentsForVideoLazyQueryHookResult = ReturnType<typeof useGetChatMomentsForVideoLazyQuery>;
export type GetChatMomentsForVideoQueryResult = Apollo.QueryResult<GetChatMomentsForVideoQuery, GetChatMomentsForVideoQueryVariables>;
export const GetRecentChannelVideosDocument = gql`
    query getRecentChannelVideos($channelName: String!, $first: Int!, $after: String) {
  channel(filter: {name: $channelName, platform: TWITCH}) {
    id
    videos(first: $first, after: $after) {
      data {
        id
        title
        publishedAt
        ... on TwitchVideo {
          id
          url
          thumbnailUrl
          stream {
            id
            endedAt
          }
        }
      }
      pagination {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetRecentChannelVideosQuery__
 *
 * To run a query within a React component, call `useGetRecentChannelVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentChannelVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentChannelVideosQuery({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetRecentChannelVideosQuery(baseOptions: Apollo.QueryHookOptions<GetRecentChannelVideosQuery, GetRecentChannelVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentChannelVideosQuery, GetRecentChannelVideosQueryVariables>(GetRecentChannelVideosDocument, options);
      }
export function useGetRecentChannelVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentChannelVideosQuery, GetRecentChannelVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentChannelVideosQuery, GetRecentChannelVideosQueryVariables>(GetRecentChannelVideosDocument, options);
        }
export type GetRecentChannelVideosQueryHookResult = ReturnType<typeof useGetRecentChannelVideosQuery>;
export type GetRecentChannelVideosLazyQueryHookResult = ReturnType<typeof useGetRecentChannelVideosLazyQuery>;
export type GetRecentChannelVideosQueryResult = Apollo.QueryResult<GetRecentChannelVideosQuery, GetRecentChannelVideosQueryVariables>;